import { defineComponent as ge, ref as B, shallowRef as ui, onMounted as rt, watch as Te, onUnmounted as jt, h as ko, nextTick as Ge, createElementBlock as C, openBlock as v, createElementVNode as u, createStaticVNode as Zn, createCommentVNode as H, normalizeStyle as ne, createVNode as K, toDisplayString as ae, withModifiers as he, computed as V, inject as el, reactive as Ln, normalizeClass as Z, renderSlot as at, toValue as gt, unref as p, getCurrentScope as tl, onScopeDispose as nl, shallowReadonly as Ct, createBlock as Ce, Teleport as Yn, withCtx as Pe, Fragment as se, renderList as pe, withDirectives as Le, vModelText as _e, createTextVNode as an, withKeys as Et, vModelSelect as $o, toRef as Tt, isRef as Io, Transition as ol, resolveDynamicComponent as di, provide as ci, mergeModels as To, useModel as il, toRaw as Lt } from "vue";
const fi = /^[a-z0-9]+(-[a-z0-9]+)*$/, pn = (e, t, n, o = "") => {
  const i = e.split(":");
  if (e.slice(0, 1) === "@") {
    if (i.length < 2 || i.length > 3)
      return null;
    o = i.shift().slice(1);
  }
  if (i.length > 3 || !i.length)
    return null;
  if (i.length > 1) {
    const a = i.pop(), d = i.pop(), r = {
      // Allow provider without '@': "provider:prefix:name"
      provider: i.length > 0 ? i[0] : o,
      prefix: d,
      name: a
    };
    return t && !nn(r) ? null : r;
  }
  const l = i[0], s = l.split("-");
  if (s.length > 1) {
    const a = {
      provider: o,
      prefix: s.shift(),
      name: s.join("-")
    };
    return t && !nn(a) ? null : a;
  }
  if (n && o === "") {
    const a = {
      provider: o,
      prefix: "",
      name: l
    };
    return t && !nn(a, n) ? null : a;
  }
  return null;
}, nn = (e, t) => e ? !!// Check prefix: cannot be empty, unless allowSimpleName is enabled
// Check name: cannot be empty
((t && e.prefix === "" || e.prefix) && e.name) : !1, pi = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
), un = Object.freeze({
  rotate: 0,
  vFlip: !1,
  hFlip: !1
}), vn = Object.freeze({
  ...pi,
  ...un
}), Bn = Object.freeze({
  ...vn,
  body: "",
  hidden: !1
});
function ll(e, t) {
  const n = {};
  !e.hFlip != !t.hFlip && (n.hFlip = !0), !e.vFlip != !t.vFlip && (n.vFlip = !0);
  const o = ((e.rotate || 0) + (t.rotate || 0)) % 4;
  return o && (n.rotate = o), n;
}
function So(e, t) {
  const n = ll(e, t);
  for (const o in Bn)
    o in un ? o in e && !(o in n) && (n[o] = un[o]) : o in t ? n[o] = t[o] : o in e && (n[o] = e[o]);
  return n;
}
function rl(e, t) {
  const n = e.icons, o = e.aliases || /* @__PURE__ */ Object.create(null), i = /* @__PURE__ */ Object.create(null);
  function l(s) {
    if (n[s])
      return i[s] = [];
    if (!(s in i)) {
      i[s] = null;
      const a = o[s] && o[s].parent, d = a && l(a);
      d && (i[s] = [a].concat(d));
    }
    return i[s];
  }
  return Object.keys(n).concat(Object.keys(o)).forEach(l), i;
}
function sl(e, t, n) {
  const o = e.icons, i = e.aliases || /* @__PURE__ */ Object.create(null);
  let l = {};
  function s(a) {
    l = So(
      o[a] || i[a],
      l
    );
  }
  return s(t), n.forEach(s), So(e, l);
}
function vi(e, t) {
  const n = [];
  if (typeof e != "object" || typeof e.icons != "object")
    return n;
  e.not_found instanceof Array && e.not_found.forEach((i) => {
    t(i, null), n.push(i);
  });
  const o = rl(e);
  for (const i in o) {
    const l = o[i];
    l && (t(i, sl(e, i, l)), n.push(i));
  }
  return n;
}
const al = {
  provider: "",
  aliases: {},
  not_found: {},
  ...pi
};
function Cn(e, t) {
  for (const n in t)
    if (n in e && typeof e[n] != typeof t[n])
      return !1;
  return !0;
}
function mi(e) {
  if (typeof e != "object" || e === null)
    return null;
  const t = e;
  if (typeof t.prefix != "string" || !e.icons || typeof e.icons != "object" || !Cn(e, al))
    return null;
  const n = t.icons;
  for (const i in n) {
    const l = n[i];
    if (
      // Name cannot be empty
      !i || // Must have body
      typeof l.body != "string" || // Check other props
      !Cn(
        l,
        Bn
      )
    )
      return null;
  }
  const o = t.aliases || /* @__PURE__ */ Object.create(null);
  for (const i in o) {
    const l = o[i], s = l.parent;
    if (
      // Name cannot be empty
      !i || // Parent must be set and point to existing icon
      typeof s != "string" || !n[s] && !o[s] || // Check other props
      !Cn(
        l,
        Bn
      )
    )
      return null;
  }
  return t;
}
const Po = /* @__PURE__ */ Object.create(null);
function ul(e, t) {
  return {
    provider: e,
    prefix: t,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function Ot(e, t) {
  const n = Po[e] || (Po[e] = /* @__PURE__ */ Object.create(null));
  return n[t] || (n[t] = ul(e, t));
}
function hi(e, t) {
  return mi(t) ? vi(t, (n, o) => {
    o ? e.icons[n] = o : e.missing.add(n);
  }) : [];
}
function dl(e, t, n) {
  try {
    if (typeof n.body == "string")
      return e.icons[t] = { ...n }, !0;
  } catch {
  }
  return !1;
}
let Vt = !1;
function gi(e) {
  return typeof e == "boolean" && (Vt = e), Vt;
}
function cl(e) {
  const t = typeof e == "string" ? pn(e, !0, Vt) : e;
  if (t) {
    const n = Ot(t.provider, t.prefix), o = t.name;
    return n.icons[o] || (n.missing.has(o) ? null : void 0);
  }
}
function fl(e, t) {
  const n = pn(e, !0, Vt);
  if (!n)
    return !1;
  const o = Ot(n.provider, n.prefix);
  return t ? dl(o, n.name, t) : (o.missing.add(n.name), !0);
}
function pl(e, t) {
  if (typeof e != "object")
    return !1;
  if (typeof t != "string" && (t = e.provider || ""), Vt && !t && !e.prefix) {
    let i = !1;
    return mi(e) && (e.prefix = "", vi(e, (l, s) => {
      fl(l, s) && (i = !0);
    })), i;
  }
  const n = e.prefix;
  if (!nn({
    prefix: n,
    name: "a"
  }))
    return !1;
  const o = Ot(t, n);
  return !!hi(o, e);
}
const bi = Object.freeze({
  width: null,
  height: null
}), xi = Object.freeze({
  // Dimensions
  ...bi,
  // Transformations
  ...un
}), vl = /(-?[0-9.]*[0-9]+[0-9.]*)/g, ml = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function Ao(e, t, n) {
  if (t === 1)
    return e;
  if (n = n || 100, typeof e == "number")
    return Math.ceil(e * t * n) / n;
  if (typeof e != "string")
    return e;
  const o = e.split(vl);
  if (o === null || !o.length)
    return e;
  const i = [];
  let l = o.shift(), s = ml.test(l);
  for (; ; ) {
    if (s) {
      const a = parseFloat(l);
      isNaN(a) ? i.push(l) : i.push(Math.ceil(a * t * n) / n);
    } else
      i.push(l);
    if (l = o.shift(), l === void 0)
      return i.join("");
    s = !s;
  }
}
function hl(e, t = "defs") {
  let n = "";
  const o = e.indexOf("<" + t);
  for (; o >= 0; ) {
    const i = e.indexOf(">", o), l = e.indexOf("</" + t);
    if (i === -1 || l === -1)
      break;
    const s = e.indexOf(">", l);
    if (s === -1)
      break;
    n += e.slice(i + 1, l).trim(), e = e.slice(0, o).trim() + e.slice(s + 1);
  }
  return {
    defs: n,
    content: e
  };
}
function gl(e, t) {
  return e ? "<defs>" + e + "</defs>" + t : t;
}
function bl(e, t, n) {
  const o = hl(e);
  return gl(o.defs, t + o.content + n);
}
const xl = (e) => e === "unset" || e === "undefined" || e === "none";
function yl(e, t) {
  const n = {
    ...vn,
    ...e
  }, o = {
    ...xi,
    ...t
  }, i = {
    left: n.left,
    top: n.top,
    width: n.width,
    height: n.height
  };
  let l = n.body;
  [n, o].forEach((I) => {
    const b = [], w = I.hFlip, S = I.vFlip;
    let A = I.rotate;
    w ? S ? A += 2 : (b.push(
      "translate(" + (i.width + i.left).toString() + " " + (0 - i.top).toString() + ")"
    ), b.push("scale(-1 1)"), i.top = i.left = 0) : S && (b.push(
      "translate(" + (0 - i.left).toString() + " " + (i.height + i.top).toString() + ")"
    ), b.push("scale(1 -1)"), i.top = i.left = 0);
    let g;
    switch (A < 0 && (A -= Math.floor(A / 4) * 4), A = A % 4, A) {
      case 1:
        g = i.height / 2 + i.top, b.unshift(
          "rotate(90 " + g.toString() + " " + g.toString() + ")"
        );
        break;
      case 2:
        b.unshift(
          "rotate(180 " + (i.width / 2 + i.left).toString() + " " + (i.height / 2 + i.top).toString() + ")"
        );
        break;
      case 3:
        g = i.width / 2 + i.left, b.unshift(
          "rotate(-90 " + g.toString() + " " + g.toString() + ")"
        );
        break;
    }
    A % 2 === 1 && (i.left !== i.top && (g = i.left, i.left = i.top, i.top = g), i.width !== i.height && (g = i.width, i.width = i.height, i.height = g)), b.length && (l = bl(
      l,
      '<g transform="' + b.join(" ") + '">',
      "</g>"
    ));
  });
  const s = o.width, a = o.height, d = i.width, r = i.height;
  let f, y;
  s === null ? (y = a === null ? "1em" : a === "auto" ? r : a, f = Ao(y, d / r)) : (f = s === "auto" ? d : s, y = a === null ? Ao(f, r / d) : a === "auto" ? r : a);
  const k = {}, m = (I, b) => {
    xl(b) || (k[I] = b.toString());
  };
  m("width", f), m("height", y);
  const h = [i.left, i.top, d, r];
  return k.viewBox = h.join(" "), {
    attributes: k,
    viewBox: h,
    body: l
  };
}
const wl = /\sid="(\S+)"/g, Cl = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
let kl = 0;
function $l(e, t = Cl) {
  const n = [];
  let o;
  for (; o = wl.exec(e); )
    n.push(o[1]);
  if (!n.length)
    return e;
  const i = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  return n.forEach((l) => {
    const s = typeof t == "function" ? t(l) : t + (kl++).toString(), a = l.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    e = e.replace(
      // Allowed characters before id: [#;"]
      // Allowed characters after id: [)"], .[a-z]
      new RegExp('([#;"])(' + a + ')([")]|\\.[a-z])', "g"),
      "$1" + s + i + "$3"
    );
  }), e = e.replace(new RegExp(i, "g"), ""), e;
}
const Nn = /* @__PURE__ */ Object.create(null);
function Il(e, t) {
  Nn[e] = t;
}
function zn(e) {
  return Nn[e] || Nn[""];
}
function Kn(e) {
  let t;
  if (typeof e.resources == "string")
    t = [e.resources];
  else if (t = e.resources, !(t instanceof Array) || !t.length)
    return null;
  return {
    // API hosts
    resources: t,
    // Root path
    path: e.path || "/",
    // URL length limit
    maxURL: e.maxURL || 500,
    // Timeout before next host is used.
    rotate: e.rotate || 750,
    // Timeout before failing query.
    timeout: e.timeout || 5e3,
    // Randomise default API end point.
    random: e.random === !0,
    // Start index
    index: e.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: e.dataAfterTimeout !== !1
  };
}
const Qn = /* @__PURE__ */ Object.create(null), Bt = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
], on = [];
for (; Bt.length > 0; )
  Bt.length === 1 || Math.random() > 0.5 ? on.push(Bt.shift()) : on.push(Bt.pop());
Qn[""] = Kn({
  resources: ["https://api.iconify.design"].concat(on)
});
function Tl(e, t) {
  const n = Kn(t);
  return n === null ? !1 : (Qn[e] = n, !0);
}
function Jn(e) {
  return Qn[e];
}
const Sl = () => {
  let e;
  try {
    if (e = fetch, typeof e == "function")
      return e;
  } catch {
  }
};
let Eo = Sl();
function Pl(e, t) {
  const n = Jn(e);
  if (!n)
    return 0;
  let o;
  if (!n.maxURL)
    o = 0;
  else {
    let i = 0;
    n.resources.forEach((s) => {
      i = Math.max(i, s.length);
    });
    const l = t + ".json?icons=";
    o = n.maxURL - i - n.path.length - l.length;
  }
  return o;
}
function Al(e) {
  return e === 404;
}
const El = (e, t, n) => {
  const o = [], i = Pl(e, t), l = "icons";
  let s = {
    type: l,
    provider: e,
    prefix: t,
    icons: []
  }, a = 0;
  return n.forEach((d, r) => {
    a += d.length + 1, a >= i && r > 0 && (o.push(s), s = {
      type: l,
      provider: e,
      prefix: t,
      icons: []
    }, a = d.length), s.icons.push(d);
  }), o.push(s), o;
};
function Ol(e) {
  if (typeof e == "string") {
    const t = Jn(e);
    if (t)
      return t.path;
  }
  return "/";
}
const Ml = (e, t, n) => {
  if (!Eo) {
    n("abort", 424);
    return;
  }
  let o = Ol(t.provider);
  switch (t.type) {
    case "icons": {
      const l = t.prefix, a = t.icons.join(","), d = new URLSearchParams({
        icons: a
      });
      o += l + ".json?" + d.toString();
      break;
    }
    case "custom": {
      const l = t.uri;
      o += l.slice(0, 1) === "/" ? l.slice(1) : l;
      break;
    }
    default:
      n("abort", 400);
      return;
  }
  let i = 503;
  Eo(e + o).then((l) => {
    const s = l.status;
    if (s !== 200) {
      setTimeout(() => {
        n(Al(s) ? "abort" : "next", s);
      });
      return;
    }
    return i = 501, l.json();
  }).then((l) => {
    if (typeof l != "object" || l === null) {
      setTimeout(() => {
        l === 404 ? n("abort", l) : n("next", i);
      });
      return;
    }
    setTimeout(() => {
      n("success", l);
    });
  }).catch(() => {
    n("next", i);
  });
}, Rl = {
  prepare: El,
  send: Ml
};
function Dl(e) {
  const t = {
    loaded: [],
    missing: [],
    pending: []
  }, n = /* @__PURE__ */ Object.create(null);
  e.sort((i, l) => i.provider !== l.provider ? i.provider.localeCompare(l.provider) : i.prefix !== l.prefix ? i.prefix.localeCompare(l.prefix) : i.name.localeCompare(l.name));
  let o = {
    provider: "",
    prefix: "",
    name: ""
  };
  return e.forEach((i) => {
    if (o.name === i.name && o.prefix === i.prefix && o.provider === i.provider)
      return;
    o = i;
    const l = i.provider, s = i.prefix, a = i.name, d = n[l] || (n[l] = /* @__PURE__ */ Object.create(null)), r = d[s] || (d[s] = Ot(l, s));
    let f;
    a in r.icons ? f = t.loaded : s === "" || r.missing.has(a) ? f = t.missing : f = t.pending;
    const y = {
      provider: l,
      prefix: s,
      name: a
    };
    f.push(y);
  }), t;
}
function yi(e, t) {
  e.forEach((n) => {
    const o = n.loaderCallbacks;
    o && (n.loaderCallbacks = o.filter((i) => i.id !== t));
  });
}
function Ll(e) {
  e.pendingCallbacksFlag || (e.pendingCallbacksFlag = !0, setTimeout(() => {
    e.pendingCallbacksFlag = !1;
    const t = e.loaderCallbacks ? e.loaderCallbacks.slice(0) : [];
    if (!t.length)
      return;
    let n = !1;
    const o = e.provider, i = e.prefix;
    t.forEach((l) => {
      const s = l.icons, a = s.pending.length;
      s.pending = s.pending.filter((d) => {
        if (d.prefix !== i)
          return !0;
        const r = d.name;
        if (e.icons[r])
          s.loaded.push({
            provider: o,
            prefix: i,
            name: r
          });
        else if (e.missing.has(r))
          s.missing.push({
            provider: o,
            prefix: i,
            name: r
          });
        else
          return n = !0, !0;
        return !1;
      }), s.pending.length !== a && (n || yi([e], l.id), l.callback(
        s.loaded.slice(0),
        s.missing.slice(0),
        s.pending.slice(0),
        l.abort
      ));
    });
  }));
}
let Bl = 0;
function Nl(e, t, n) {
  const o = Bl++, i = yi.bind(null, n, o);
  if (!t.pending.length)
    return i;
  const l = {
    id: o,
    icons: t,
    callback: e,
    abort: i
  };
  return n.forEach((s) => {
    (s.loaderCallbacks || (s.loaderCallbacks = [])).push(l);
  }), i;
}
function zl(e, t = !0, n = !1) {
  const o = [];
  return e.forEach((i) => {
    const l = typeof i == "string" ? pn(i, t, n) : i;
    l && o.push(l);
  }), o;
}
var _l = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: !1,
  dataAfterTimeout: !1
};
function Vl(e, t, n, o) {
  const i = e.resources.length, l = e.random ? Math.floor(Math.random() * i) : e.index;
  let s;
  if (e.random) {
    let T = e.resources.slice(0);
    for (s = []; T.length > 1; ) {
      const _ = Math.floor(Math.random() * T.length);
      s.push(T[_]), T = T.slice(0, _).concat(T.slice(_ + 1));
    }
    s = s.concat(T);
  } else
    s = e.resources.slice(l).concat(e.resources.slice(0, l));
  const a = Date.now();
  let d = "pending", r = 0, f, y = null, k = [], m = [];
  typeof o == "function" && m.push(o);
  function h() {
    y && (clearTimeout(y), y = null);
  }
  function I() {
    d === "pending" && (d = "aborted"), h(), k.forEach((T) => {
      T.status === "pending" && (T.status = "aborted");
    }), k = [];
  }
  function b(T, _) {
    _ && (m = []), typeof T == "function" && m.push(T);
  }
  function w() {
    return {
      startTime: a,
      payload: t,
      status: d,
      queriesSent: r,
      queriesPending: k.length,
      subscribe: b,
      abort: I
    };
  }
  function S() {
    d = "failed", m.forEach((T) => {
      T(void 0, f);
    });
  }
  function A() {
    k.forEach((T) => {
      T.status === "pending" && (T.status = "aborted");
    }), k = [];
  }
  function g(T, _, W) {
    const U = _ !== "success";
    switch (k = k.filter((z) => z !== T), d) {
      case "pending":
        break;
      case "failed":
        if (U || !e.dataAfterTimeout)
          return;
        break;
      default:
        return;
    }
    if (_ === "abort") {
      f = W, S();
      return;
    }
    if (U) {
      f = W, k.length || (s.length ? x() : S());
      return;
    }
    if (h(), A(), !e.random) {
      const z = e.resources.indexOf(T.resource);
      z !== -1 && z !== e.index && (e.index = z);
    }
    d = "completed", m.forEach((z) => {
      z(W);
    });
  }
  function x() {
    if (d !== "pending")
      return;
    h();
    const T = s.shift();
    if (T === void 0) {
      if (k.length) {
        y = setTimeout(() => {
          h(), d === "pending" && (A(), S());
        }, e.timeout);
        return;
      }
      S();
      return;
    }
    const _ = {
      status: "pending",
      resource: T,
      callback: (W, U) => {
        g(_, W, U);
      }
    };
    k.push(_), r++, y = setTimeout(x, e.rotate), n(T, t, _.callback);
  }
  return setTimeout(x), w;
}
function wi(e) {
  const t = {
    ..._l,
    ...e
  };
  let n = [];
  function o() {
    n = n.filter((a) => a().status === "pending");
  }
  function i(a, d, r) {
    const f = Vl(
      t,
      a,
      d,
      (y, k) => {
        o(), r && r(y, k);
      }
    );
    return n.push(f), f;
  }
  function l(a) {
    return n.find((d) => a(d)) || null;
  }
  return {
    query: i,
    find: l,
    setIndex: (a) => {
      t.index = a;
    },
    getIndex: () => t.index,
    cleanup: o
  };
}
function Oo() {
}
const kn = /* @__PURE__ */ Object.create(null);
function Fl(e) {
  if (!kn[e]) {
    const t = Jn(e);
    if (!t)
      return;
    const n = wi(t), o = {
      config: t,
      redundancy: n
    };
    kn[e] = o;
  }
  return kn[e];
}
function jl(e, t, n) {
  let o, i;
  if (typeof e == "string") {
    const l = zn(e);
    if (!l)
      return n(void 0, 424), Oo;
    i = l.send;
    const s = Fl(e);
    s && (o = s.redundancy);
  } else {
    const l = Kn(e);
    if (l) {
      o = wi(l);
      const s = e.resources ? e.resources[0] : "", a = zn(s);
      a && (i = a.send);
    }
  }
  return !o || !i ? (n(void 0, 424), Oo) : o.query(t, i, n)().abort;
}
function Mo() {
}
function Hl(e) {
  e.iconsLoaderFlag || (e.iconsLoaderFlag = !0, setTimeout(() => {
    e.iconsLoaderFlag = !1, Ll(e);
  }));
}
function Ul(e) {
  const t = [], n = [];
  return e.forEach((o) => {
    (o.match(fi) ? t : n).push(o);
  }), {
    valid: t,
    invalid: n
  };
}
function Nt(e, t, n) {
  function o() {
    const i = e.pendingIcons;
    t.forEach((l) => {
      i && i.delete(l), e.icons[l] || e.missing.add(l);
    });
  }
  if (n && typeof n == "object")
    try {
      if (!hi(e, n).length) {
        o();
        return;
      }
    } catch (i) {
      console.error(i);
    }
  o(), Hl(e);
}
function Ro(e, t) {
  e instanceof Promise ? e.then((n) => {
    t(n);
  }).catch(() => {
    t(null);
  }) : t(e);
}
function Gl(e, t) {
  e.iconsToLoad ? e.iconsToLoad = e.iconsToLoad.concat(t).sort() : e.iconsToLoad = t, e.iconsQueueFlag || (e.iconsQueueFlag = !0, setTimeout(() => {
    e.iconsQueueFlag = !1;
    const { provider: n, prefix: o } = e, i = e.iconsToLoad;
    if (delete e.iconsToLoad, !i || !i.length)
      return;
    const l = e.loadIcon;
    if (e.loadIcons && (i.length > 1 || !l)) {
      Ro(
        e.loadIcons(i, o, n),
        (f) => {
          Nt(e, i, f);
        }
      );
      return;
    }
    if (l) {
      i.forEach((f) => {
        const y = l(f, o, n);
        Ro(y, (k) => {
          const m = k ? {
            prefix: o,
            icons: {
              [f]: k
            }
          } : null;
          Nt(e, [f], m);
        });
      });
      return;
    }
    const { valid: s, invalid: a } = Ul(i);
    if (a.length && Nt(e, a, null), !s.length)
      return;
    const d = o.match(fi) ? zn(n) : null;
    if (!d) {
      Nt(e, s, null);
      return;
    }
    d.prepare(n, o, s).forEach((f) => {
      jl(n, f, (y) => {
        Nt(e, f.icons, y);
      });
    });
  }));
}
const Wl = (e, t) => {
  const n = zl(e, !0, gi()), o = Dl(n);
  if (!o.pending.length) {
    let d = !0;
    return t && setTimeout(() => {
      d && t(
        o.loaded,
        o.missing,
        o.pending,
        Mo
      );
    }), () => {
      d = !1;
    };
  }
  const i = /* @__PURE__ */ Object.create(null), l = [];
  let s, a;
  return o.pending.forEach((d) => {
    const { provider: r, prefix: f } = d;
    if (f === a && r === s)
      return;
    s = r, a = f, l.push(Ot(r, f));
    const y = i[r] || (i[r] = /* @__PURE__ */ Object.create(null));
    y[f] || (y[f] = []);
  }), o.pending.forEach((d) => {
    const { provider: r, prefix: f, name: y } = d, k = Ot(r, f), m = k.pendingIcons || (k.pendingIcons = /* @__PURE__ */ new Set());
    m.has(y) || (m.add(y), i[r][f].push(y));
  }), l.forEach((d) => {
    const r = i[d.provider][d.prefix];
    r.length && Gl(d, r);
  }), t ? Nl(t, o, l) : Mo;
};
function Xl(e, t) {
  const n = {
    ...e
  };
  for (const o in t) {
    const i = t[o], l = typeof i;
    o in bi ? (i === null || i && (l === "string" || l === "number")) && (n[o] = i) : l === typeof n[o] && (n[o] = o === "rotate" ? i % 4 : i);
  }
  return n;
}
const ql = /[\s,]+/;
function Zl(e, t) {
  t.split(ql).forEach((n) => {
    switch (n.trim()) {
      case "horizontal":
        e.hFlip = !0;
        break;
      case "vertical":
        e.vFlip = !0;
        break;
    }
  });
}
function Yl(e, t = 0) {
  const n = e.replace(/^-?[0-9.]*/, "");
  function o(i) {
    for (; i < 0; )
      i += 4;
    return i % 4;
  }
  if (n === "") {
    const i = parseInt(e);
    return isNaN(i) ? 0 : o(i);
  } else if (n !== e) {
    let i = 0;
    switch (n) {
      case "%":
        i = 25;
        break;
      case "deg":
        i = 90;
    }
    if (i) {
      let l = parseFloat(e.slice(0, e.length - n.length));
      return isNaN(l) ? 0 : (l = l / i, l % 1 === 0 ? o(l) : 0);
    }
  }
  return t;
}
function Kl(e, t) {
  let n = e.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const o in t)
    n += " " + o + '="' + t[o] + '"';
  return '<svg xmlns="http://www.w3.org/2000/svg"' + n + ">" + e + "</svg>";
}
function Ql(e) {
  return e.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function Jl(e) {
  return "data:image/svg+xml," + Ql(e);
}
function er(e) {
  return 'url("' + Jl(e) + '")';
}
const Do = {
  ...xi,
  inline: !1
}, tr = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": !0,
  role: "img"
}, nr = {
  display: "inline-block"
}, _n = {
  backgroundColor: "currentColor"
}, Ci = {
  backgroundColor: "transparent"
}, Lo = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
}, Bo = {
  webkitMask: _n,
  mask: _n,
  background: Ci
};
for (const e in Bo) {
  const t = Bo[e];
  for (const n in Lo)
    t[e + n] = Lo[n];
}
const ln = {};
["horizontal", "vertical"].forEach((e) => {
  const t = e.slice(0, 1) + "Flip";
  ln[e + "-flip"] = t, ln[e.slice(0, 1) + "-flip"] = t, ln[e + "Flip"] = t;
});
function No(e) {
  return e + (e.match(/^[-0-9.]+$/) ? "px" : "");
}
const zo = (e, t) => {
  const n = Xl(Do, t), o = { ...tr }, i = t.mode || "svg", l = {}, s = t.style, a = typeof s == "object" && !(s instanceof Array) ? s : {};
  for (let I in t) {
    const b = t[I];
    if (b !== void 0)
      switch (I) {
        // Properties to ignore
        case "icon":
        case "style":
        case "onLoad":
        case "mode":
        case "ssr":
          break;
        // Boolean attributes
        case "inline":
        case "hFlip":
        case "vFlip":
          n[I] = b === !0 || b === "true" || b === 1;
          break;
        // Flip as string: 'horizontal,vertical'
        case "flip":
          typeof b == "string" && Zl(n, b);
          break;
        // Color: override style
        case "color":
          l.color = b;
          break;
        // Rotation as string
        case "rotate":
          typeof b == "string" ? n[I] = Yl(b) : typeof b == "number" && (n[I] = b);
          break;
        // Remove aria-hidden
        case "ariaHidden":
        case "aria-hidden":
          b !== !0 && b !== "true" && delete o["aria-hidden"];
          break;
        default: {
          const w = ln[I];
          w ? (b === !0 || b === "true" || b === 1) && (n[w] = !0) : Do[I] === void 0 && (o[I] = b);
        }
      }
  }
  const d = yl(e, n), r = d.attributes;
  if (n.inline && (l.verticalAlign = "-0.125em"), i === "svg") {
    o.style = {
      ...l,
      ...a
    }, Object.assign(o, r);
    let I = 0, b = t.id;
    return typeof b == "string" && (b = b.replace(/-/g, "_")), o.innerHTML = $l(d.body, b ? () => b + "ID" + I++ : "iconifyVue"), ko("svg", o);
  }
  const { body: f, width: y, height: k } = e, m = i === "mask" || (i === "bg" ? !1 : f.indexOf("currentColor") !== -1), h = Kl(f, {
    ...r,
    width: y + "",
    height: k + ""
  });
  return o.style = {
    ...l,
    "--svg": er(h),
    width: No(r.width),
    height: No(r.height),
    ...nr,
    ...m ? _n : Ci,
    ...a
  }, ko("span", o);
};
gi(!0);
Il("", Rl);
if (typeof document < "u" && typeof window < "u") {
  const e = window;
  if (e.IconifyPreload !== void 0) {
    const t = e.IconifyPreload, n = "Invalid IconifyPreload syntax.";
    typeof t == "object" && t !== null && (t instanceof Array ? t : [t]).forEach((o) => {
      try {
        // Check if item is an object and not null/array
        (typeof o != "object" || o === null || o instanceof Array || // Check for 'icons' and 'prefix'
        typeof o.icons != "object" || typeof o.prefix != "string" || // Add icon set
        !pl(o)) && console.error(n);
      } catch {
        console.error(n);
      }
    });
  }
  if (e.IconifyProviders !== void 0) {
    const t = e.IconifyProviders;
    if (typeof t == "object" && t !== null)
      for (let n in t) {
        const o = "IconifyProviders[" + n + "] is invalid.";
        try {
          const i = t[n];
          if (typeof i != "object" || !i || i.resources === void 0)
            continue;
          Tl(n, i) || console.error(o);
        } catch {
          console.error(o);
        }
      }
  }
}
const or = {
  ...vn,
  body: ""
}, ki = ge((e, { emit: t }) => {
  const n = B(null);
  function o() {
    n.value && (n.value.abort?.(), n.value = null);
  }
  const i = B(!!e.ssr), l = B(""), s = ui(null);
  function a() {
    const r = e.icon;
    if (typeof r == "object" && r !== null && typeof r.body == "string")
      return l.value = "", {
        data: r
      };
    let f;
    if (typeof r != "string" || (f = pn(r, !1, !0)) === null)
      return null;
    let y = cl(f);
    if (!y) {
      const h = n.value;
      return (!h || h.name !== r) && (y === null ? n.value = {
        name: r
      } : n.value = {
        name: r,
        abort: Wl([f], d)
      }), null;
    }
    o(), l.value !== r && (l.value = r, Ge(() => {
      t("load", r);
    }));
    const k = e.customise;
    if (k) {
      y = Object.assign({}, y);
      const h = k(y.body, f.name, f.prefix, f.provider);
      typeof h == "string" && (y.body = h);
    }
    const m = ["iconify"];
    return f.prefix !== "" && m.push("iconify--" + f.prefix), f.provider !== "" && m.push("iconify--" + f.provider), { data: y, classes: m };
  }
  function d() {
    const r = a();
    r ? r.data !== s.value?.data && (s.value = r) : s.value = null;
  }
  return i.value ? d() : rt(() => {
    i.value = !0, d();
  }), Te(() => e.icon, d), jt(o), () => {
    const r = s.value;
    if (!r)
      return zo(or, e);
    let f = e;
    return r.classes && (f = {
      ...e,
      class: r.classes.join(" ")
    }), zo({
      ...vn,
      ...r.data
    }, f);
  };
}, {
  props: [
    // Icon and render mode
    "icon",
    "mode",
    "ssr",
    // Layout and style
    "width",
    "height",
    "style",
    "color",
    "inline",
    // Transformations
    "rotate",
    "hFlip",
    "horizontalFlip",
    "vFlip",
    "verticalFlip",
    "flip",
    // Misc
    "id",
    "ariaHidden",
    "customise",
    "title"
  ],
  emits: ["load"]
}), Me = (e, t) => {
  const n = e.__vccOpts || e;
  for (const [o, i] of t)
    n[o] = i;
  return n;
}, ir = {}, lr = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "20px",
  viewBox: "0 -960 960 960",
  width: "20px",
  fill: "currentColor"
};
function rr(e, t) {
  return v(), C("svg", lr, [...t[0] || (t[0] = [
    u("path", { d: "M294-238.35 239.35-294l185-186-185-186L294-721.65l186 186 186-186L720.65-666l-185 186 185 186L666-238.35l-186-186-186 186Z" }, null, -1)
  ])]);
}
const dt = /* @__PURE__ */ Me(ir, [["render", rr]]), sr = {}, ar = {
  width: "36",
  height: "30",
  viewBox: "0 0 36 30",
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg"
};
function ur(e, t) {
  return v(), C("svg", ar, [...t[0] || (t[0] = [
    Zn('<path d="M24 6C24 9.31371 21.3137 12 18 12C14.6863 12 12 9.31371 12 6C12 2.68629 14.6863 0 18 0C21.3137 0 24 2.68629 24 6Z"></path><path d="M34 10C34 12.2091 32.2091 14 30 14C27.7909 14 26 12.2091 26 10C26 7.79086 27.7909 6 30 6C32.2091 6 34 7.79086 34 10Z"></path><path d="M26 24C26 19.5817 22.4183 16 18 16C13.5817 16 10 19.5817 10 24V30H26V24Z"></path><path d="M10 10C10 12.2091 8.20914 14 6 14C3.79086 14 2 12.2091 2 10C2 7.79086 3.79086 6 6 6C8.20914 6 10 7.79086 10 10Z"></path><path d="M30 30V24C30 21.8917 29.4563 19.9104 28.5015 18.1886C28.9805 18.0655 29.4826 18 30 18C33.3137 18 36 20.6863 36 24V30H30Z"></path><path d="M7.49853 18.1886C6.5437 19.9104 6 21.8917 6 24V30H0V24C0 20.6863 2.68629 18 6 18C6.51742 18 7.01954 18.0655 7.49853 18.1886Z"></path>', 6)
  ])]);
}
const $i = /* @__PURE__ */ Me(sr, [["render", ur]]), dr = { class: "relative group flex flex-col items-center z-0" }, cr = { class: "relative" }, fr = {
  class: "text-white font-bold text-4xl",
  style: { "text-shadow": "0 2px 4px rgba(0, 0, 0, 0.2)" }
}, pr = /* @__PURE__ */ ge({
  __name: "PopulationIcon",
  props: {
    name: {},
    count: {},
    color: {},
    showDelete: { type: Boolean, default: !0 }
  },
  emits: ["delete", "click"],
  setup(e) {
    return (t, n) => (v(), C("div", dr, [
      u("div", cr, [
        u("div", {
          class: "size-48 rounded-full flex flex-col items-center justify-center cursor-pointer transition-all hover:brightness-95 shadow-lg",
          style: ne({ backgroundColor: e.color }),
          onClick: n[0] || (n[0] = (o) => t.$emit("click"))
        }, [
          K($i, { class: "text-white" }),
          u("span", fr, ae(e.count), 1)
        ], 4),
        e.showDelete ? (v(), C("button", {
          key: 0,
          class: "absolute cursor-pointer -top-2 -right-2 text-red-500 hover:text-red-700 bg-white hover:bg-red-50 hover:scale-110 group-hover:opacity-100 opacity-0 transition-all rounded-full p-1 flex shadow-md",
          title: "Delete Population",
          onClick: n[1] || (n[1] = he((o) => t.$emit("delete"), ["stop"]))
        }, [
          K(dt)
        ])) : H("", !0)
      ])
    ]));
  }
}), Vn = {
  id: "baseline-default",
  name: "Baseline / Enrollment",
  type: "baseline",
  globalOrder: "!"
};
function eo() {
  return {
    status: null,
    allocationRatios: [],
    scheme: null,
    blockSize: "",
    stratFactors: [],
    numStrata: "",
    seqMethod: null,
    seqResp: null,
    concealment: null,
    concealMethod: null,
    concealOtherSpec: ""
  };
}
function Ii(e) {
  return e?.status === "randomized";
}
var ze = /* @__PURE__ */ ((e) => (e.EXACT = "exact", e.BETWEEN = "between", e))(ze || {}), rn = /* @__PURE__ */ ((e) => (e.DEVICE = "device", e.PROCEDURE = "procedure", e.MEDICATION = "medication", e))(rn || {}), De = /* @__PURE__ */ ((e) => (e.EXPERIMENTAL = "experimental", e.COMPARATOR = "comparator", e.NO_COMPARISON = "no_comparison", e))(De || {}), Oe = /* @__PURE__ */ ((e) => (e.NON_ACTIVE = "non_active", e.ACTIVE = "active", e))(Oe || {}), tt = /* @__PURE__ */ ((e) => (e.PLACEBO = "placebo", e.SHAM = "sham", e.NO_INTERVENTION = "no_intervention", e))(tt || {}), He = /* @__PURE__ */ ((e) => (e.PROTOCOL = "protocol", e.ROUTINE = "routine", e))(He || {});
const ot = [
  "#4A90D9",
  "#F5A623",
  "#9B59B6",
  "#1A7A4A",
  "#E74C3C",
  "#FF7F5C",
  "#F4D03F",
  "#E91E8C",
  "#7B4A2D",
  "#00BCD4"
];
function vr(e = {}) {
  const t = B(e.populations ?? []), n = B(
    (e.arms ?? []).map((k) => ({
      ...k,
      anchorPoints: k.anchorPoints ?? []
    }))
  ), o = B(e.periods ?? []), i = B(
    e.interventionDefinitions ?? []
  ), l = e.anchors ?? [], s = B(
    l.some((k) => k.type === "baseline") ? l : [Vn, ...l]
  ), a = B(null), d = B(null), r = B(e.mode ?? "edit"), f = B(null), y = B([]);
  return {
    populationsDataEntity: t,
    armsDataEntity: n,
    periodsDataEntity: o,
    interventionDefinitions: i,
    hoveredTimepointId: a,
    hoveredTimepointPeriodId: d,
    anchors: s,
    mode: r,
    selectedAnchor: f,
    selectedInterventionTimepoints: y
  };
}
function Fn(e) {
  return [...e].sort((t, n) => t.order.localeCompare(n.order));
}
function Pt(e) {
  return [...e].sort((t, n) => t.globalOrder.localeCompare(n.globalOrder));
}
const _o = [
  "#0ea5e9",
  "#3b82f6",
  "#1e40af",
  "#60a5fa",
  "#0284c7",
  "#6366f1",
  "#075985",
  "#93c5fd",
  "#2563eb",
  "#4f46e5"
];
function Ti(e) {
  return _o[e % _o.length];
}
function mr(e) {
  return `P${e + 1}`;
}
function Vo(e) {
  return `G${e + 1}`;
}
const Ne = "abcdefghijklmnopqrstuvwxyz", qt = 13;
function ut(e, t) {
  if (e === null && t === null)
    return Ne[qt];
  if (e === null && t !== null) {
    const a = t.charAt(0), d = Ne.indexOf(a);
    return d > 0 ? Ne[Math.floor(d / 2)] : t.length > 1 ? "a" + ut(null, t.slice(1)) : "a" + Ne[qt];
  }
  if (t === null && e !== null) {
    const a = e.charAt(e.length - 1), d = Ne.indexOf(a);
    return d < Ne.length - 1 ? e.slice(0, -1) + Ne[Math.floor((d + Ne.length) / 2)] : e + Ne[qt];
  }
  let n = 0;
  for (; n < e.length && n < t.length && e[n] === t[n]; )
    n++;
  const o = n < e.length ? e[n] : "a", i = n < t.length ? t[n] : "z", l = Ne.indexOf(o), s = Ne.indexOf(i);
  return s - l > 1 ? e.slice(0, n) + Ne[Math.floor((l + s) / 2)] : e + Ne[qt];
}
function Si(e, t) {
  return e.filter((n) => n.armId === t).sort((n, o) => n.globalOrder.localeCompare(o.globalOrder));
}
function Pi(e, t, n, o) {
  const i = o?.idGenerator ?? (() => Date.now().toString()), l = Si(e, t);
  let s = o?.globalOrderBefore ?? null, a = o?.globalOrderAfter ?? null;
  if (s === null && a === null)
    if (o?.afterPeriodId) {
      const k = l.find((m) => m.id === o.afterPeriodId);
      if (k) {
        const m = l.indexOf(k);
        s = k.globalOrder, a = m + 1 < l.length ? l[m + 1].globalOrder : null;
      }
    } else
      s = e.reduce((m, h) => m === null || h.globalOrder.localeCompare(m) > 0 ? h.globalOrder : m, null);
  const d = ut(s, a), r = {
    id: i() + "-start",
    name: "Start",
    order: "a",
    isStart: !0
  }, f = {
    id: i(),
    definitionId: n.definitionId,
    order: "n"
  }, y = {
    id: i(),
    armId: t,
    globalOrder: d,
    timepoints: [r],
    interventions: [f]
  };
  return { periods: [...e, y], newPeriod: y };
}
function hr(e, t) {
  return e.filter((n) => n.id !== t);
}
function gr(e, t, n) {
  return e.map((o) => o.id === t ? { ...o, ...n } : o);
}
function br(e, t, n, o) {
  const i = o?.idGenerator ?? (() => Date.now().toString()), l = e.find((I) => I.id === t);
  if (!l) return null;
  const s = [...l.interventions].sort(
    (I, b) => I.order.localeCompare(b.order)
  ), a = s[0]?.order ?? null, d = s[1]?.order ?? null, r = ut(null, a);
  let f, y = null, k = null;
  a !== null && r.localeCompare(a) >= 0 ? (f = a, y = s[0].id, k = ut(a, d)) : f = r;
  const m = {
    id: i(),
    definitionId: n.definitionId,
    order: f,
    bodyPartName: "unnamed body part"
  };
  return { periods: e.map((I) => {
    if (I.id !== t) return I;
    const b = y ? I.interventions.map(
      (w) => w.id === y ? { ...w, order: k } : w
    ) : I.interventions;
    return { ...I, interventions: [...b, m] };
  }), newIntervention: m };
}
function xr(e, t, n) {
  const o = e.find((l) => l.id === t);
  return o ? o.interventions.length <= 1 ? { periods: e.filter((l) => l.id !== t), removedPeriod: !0 } : { periods: e.map(
    (l) => l.id === t ? { ...l, interventions: l.interventions.filter((s) => s.id !== n) } : l
  ), removedPeriod: !1 } : { periods: e, removedPeriod: !1 };
}
function yr(e, t, n, o) {
  return e.map(
    (i) => i.id === t ? {
      ...i,
      interventions: i.interventions.map(
        (l) => l.id === n ? { ...l, ...o } : l
      )
    } : i
  );
}
function wr(e, t) {
  const n = new Map(t.map((l) => [l.id, l])), o = new Set(
    e.flatMap(
      (l) => l.interventions.map((s) => n.get(s.definitionId)?.color).filter(Boolean)
    )
  );
  return ot.find((l) => !o.has(l)) ?? ot[e.length % ot.length];
}
function to(e) {
  if (e.role === De.COMPARATOR && e.comparatorType === "non_active" && e.nonActiveType)
    return {
      placebo: "Placebo",
      sham: "Sham",
      no_intervention: "No intervention"
    }[e.nonActiveType] ?? null;
  const n = (e.items ?? []).filter((o) => o.name.trim()).map((o) => o.name.trim());
  return n.length > 0 ? n.join(" + ") : null;
}
function Cr(e, t, n, o = () => Date.now().toString()) {
  const i = e.find((h) => h.id === t);
  if (!i) return e;
  const l = [...i.timepoints].sort((h, I) => h.order.localeCompare(I.order));
  if (i.timepoints.length === 1) {
    const I = l[0]?.participantCount, b = {
      id: o(),
      name: "End",
      order: "z",
      isEnd: !0,
      participantCount: I
    };
    return e.map(
      (w) => w.id === t ? { ...w, timepoints: [...w.timepoints, b] } : w
    );
  }
  let s = null, a = null, d;
  const r = l.filter((h) => !h.isStart && !h.isEnd);
  if (n === null)
    a = l.length > 0 ? l[0].order : null;
  else {
    const h = l.findIndex((I) => I.id === n);
    h >= 0 && (s = l[h].order, d = l[h], a = h + 1 < l.length ? l[h + 1].order : null);
  }
  const f = ut(s, a), k = `Mid ${r.length + 1}`, m = {
    id: o(),
    name: k,
    order: f,
    participantCount: d?.participantCount
  };
  return e.map(
    (h) => h.id === t ? { ...h, timepoints: [...h.timepoints, m] } : h
  );
}
function kr(e, t, n) {
  const o = e.find((a) => a.id === t);
  if (!o) return { periods: e, removed: !1, reason: "Period not found" };
  const i = o.timepoints.find((a) => a.id === n);
  if (!i) return { periods: e, removed: !1, reason: "Timepoint not found" };
  if (i.isStart)
    return { periods: e, removed: !1, reason: "Cannot remove start timepoint" };
  const l = [...o.timepoints].sort((a, d) => a.order.localeCompare(d.order));
  return i.isEnd && l.some((a) => !a.isStart && !a.isEnd) ? {
    periods: e,
    removed: !1,
    reason: "Cannot remove end timepoint when middle timepoints exist"
  } : { periods: e.map(
    (a) => a.id === t ? { ...a, timepoints: a.timepoints.filter((d) => d.id !== n) } : a
  ), removed: !0 };
}
function $r(e, t, n, o, i) {
  const l = e.find((a) => a.id === t);
  if (!l) return e;
  const s = l.timepoints.find((a) => a.id === n);
  if (!s) return e;
  if (i) {
    const a = s.name;
    return e.map((d) => ({
      ...d,
      timepoints: d.timepoints.map((r) => r.name === a ? { ...r, name: o } : r)
    }));
  }
  return e.map(
    (a) => a.id === t ? {
      ...a,
      timepoints: a.timepoints.map(
        (d) => d.id === n ? { ...d, name: o } : d
      )
    } : a
  );
}
function Ir(e, t, n, o) {
  const i = e.find((s) => s.id === t);
  if (!i) return null;
  const l = i.interventions[0];
  return l ? Pi(
    e,
    n,
    { definitionId: l.definitionId },
    { idGenerator: o }
  ) : null;
}
const Zt = 96, $n = 96;
function Tr(e, t) {
  const n = V(() => {
    const a = /* @__PURE__ */ new Map();
    for (const f of e.value) {
      const y = a.get(f.globalOrder);
      y ? y.periodIds.push(f.id) : a.set(f.globalOrder, {
        id: `col-period-${f.globalOrder}`,
        type: "period",
        globalOrder: f.globalOrder,
        x: 0,
        periodIds: [f.id]
      });
    }
    for (const f of t.value)
      a.has(f.globalOrder) || a.set(f.globalOrder, {
        id: `col-anchor-${f.id}`,
        type: "anchor",
        globalOrder: f.globalOrder,
        x: 0,
        periodIds: []
      });
    const d = [...a.values()].sort(
      (f, y) => f.globalOrder.localeCompare(y.globalOrder)
    );
    let r = $n;
    for (const f of d)
      f.x = r, r += Zt;
    return d;
  }), o = V(() => n.value.length === 0 ? $n + Zt : n.value[n.value.length - 1].x + Zt * 2);
  function i(a) {
    return n.value.find((r) => r.periodIds.includes(a))?.x;
  }
  function l(a) {
    const d = t.value.find((f) => f.id === a);
    return d ? n.value.find(
      (f) => f.type === "anchor" && f.globalOrder === d.globalOrder
    )?.x : void 0;
  }
  const s = V(() => n.value.filter((a) => a.type === "anchor"));
  return {
    columns: n,
    totalWidth: o,
    getColumnXForPeriod: i,
    getColumnXForAnchor: l,
    anchorColumns: s,
    COLUMN_WIDTH: Zt,
    BASELINE_COLUMN_WIDTH: $n
  };
}
function Sr(e) {
  const {
    populationsDataEntity: t,
    armsDataEntity: n,
    periodsDataEntity: o,
    interventionDefinitions: i,
    anchors: l,
    selectedAnchor: s,
    selectedInterventionTimepoints: a
  } = e;
  function d(L) {
    return o.value.find(
      (N) => N.interventions.some((D) => D.id === L)
    );
  }
  const r = V(() => t.value.map((L, N) => {
    const D = n.value.filter((X) => X.populationId === L.id).map((X) => ({
      id: X.id,
      name: X.name,
      participantsCount: X.participantsCount,
      populationId: X.populationId,
      anchorPoints: X.anchorPoints
    }));
    return {
      id: L.id,
      name: L.name,
      color: Ti(N),
      arms: D.length > 0 ? D : void 0,
      inclusionCriteria: L.inclusionCriteria,
      exclusionCriteria: L.exclusionCriteria,
      randomization: L.randomization
    };
  })), f = V(() => o.value), y = Tr(o, l);
  function k(L) {
    return n.value.filter((D) => D.populationId === L).reduce((D, X) => D + X.participantsCount, 0);
  }
  const m = V(() => s.value ? l.value.find((L) => L.id === s.value.anchorId) ?? null : null);
  function h(L) {
    const N = /* @__PURE__ */ new Set();
    for (const D of o.value) {
      const X = Pt(
        l.value.filter((q) => q.globalOrder < D.globalOrder)
      ).at(-1), G = Pt(
        l.value.filter((q) => q.globalOrder > D.globalOrder)
      )[0];
      (X?.globalOrder === L || G?.globalOrder === L) && N.add(D.id);
    }
    return N;
  }
  const I = V(() => !s.value || !m.value ? new Set(o.value.map((L) => L.id)) : h(m.value.globalOrder)), b = V(() => {
    if (a.value.length === 0) return null;
    const L = a.value[0]?.interventionId;
    return L ? d(L)?.armId ?? null : null;
  }), w = V(() => {
    if (a.value.length === 0) return null;
    const L = a.value[0]?.interventionId;
    return L ? d(L)?.id ?? null : null;
  }), S = V(() => {
    const L = /* @__PURE__ */ new Set();
    for (const N of a.value) {
      const X = d(N.interventionId)?.timepoints.find((G) => G.id === N.timepointId);
      X && L.add(X.name);
    }
    return L;
  }), A = V(() => {
    if (a.value.length === 0) return /* @__PURE__ */ new Set();
    const L = a.value[0]?.interventionId;
    if (!L) return /* @__PURE__ */ new Set();
    const N = d(L);
    return N ? new Set(N.timepoints.map((D) => D.name)) : /* @__PURE__ */ new Set();
  }), g = V(() => {
    if (a.value.length === 0) return /* @__PURE__ */ new Set();
    const L = a.value[0], N = d(L.interventionId);
    if (!N) return /* @__PURE__ */ new Set();
    const D = N.globalOrder, X = Pt(
      l.value.filter((Q) => Q.globalOrder < D)
    ).at(-1), G = Pt(
      l.value.filter((Q) => Q.globalOrder > D)
    )[0], q = /* @__PURE__ */ new Set();
    return X && q.add(X.id), G && q.add(G.id), q;
  }), x = V(() => {
    if (a.value.length === 0) return /* @__PURE__ */ new Set();
    const L = a.value.map((q) => d(q.interventionId)).filter((q) => q !== void 0);
    if (L.length === 0) return /* @__PURE__ */ new Set();
    const D = [...new Set(L.map((q) => q.id))].map(
      (q) => L.find((Q) => Q.id === q)
    );
    if (D.length === 1)
      return new Set(D[0].timepoints.map((q) => q.name));
    const X = D[0].timepoints.map((q) => q.name), G = D.slice(1).map((q) => new Set(q.timepoints.map((Q) => Q.name)));
    return new Set(X.filter((q) => G.every((Q) => Q.has(q))));
  }), T = V(
    () => new Set(a.value.map((L) => L.interventionId))
  ), _ = V(() => {
    const L = /* @__PURE__ */ new Map();
    for (const N of T.value) {
      const D = o.value.find((G) => G.interventions.some((q) => q.id === N));
      if (!D) continue;
      const X = L.get(D.armId) ?? [];
      X.push(N), L.set(D.armId, X);
    }
    return L;
  }), W = V(() => {
    const L = T.value;
    if (L.size < 2) return /* @__PURE__ */ new Set();
    const N = /* @__PURE__ */ new Set(), D = /* @__PURE__ */ new Set();
    for (const G of L) {
      const q = o.value.find((ce) => ce.interventions.some((be) => be.id === G));
      if (!q) continue;
      N.add(q.armId);
      const Q = q.interventions.find((ce) => ce.id === G);
      Q && D.add(Q.definitionId);
    }
    if (N.size !== 1) return /* @__PURE__ */ new Set();
    const X = /* @__PURE__ */ new Set();
    for (const G of n.value) {
      if (N.has(G.id)) continue;
      const q = new Set(
        o.value.filter((Q) => Q.armId === G.id).flatMap((Q) => Q.interventions.map((ce) => ce.definitionId))
      );
      [...D].every((Q) => q.has(Q)) && X.add(G.id);
    }
    return X;
  });
  function U(L) {
    return Si(o.value, L);
  }
  function z() {
    return wr(o.value, i.value);
  }
  function M(L) {
    return t.value.find((N) => N.id === L);
  }
  function R(L) {
    return n.value.find((N) => N.id === L);
  }
  function F(L, N, D) {
    const X = [...N].sort((q, Q) => q.localeCompare(Q)), G = [...D].sort((q, Q) => q.localeCompare(Q));
    return t.value.find((q) => {
      if (q.id === L) return !1;
      const Q = [...q.inclusionCriteria ?? []].sort((ve, xe) => ve.localeCompare(xe)), ce = [...q.exclusionCriteria ?? []].sort((ve, xe) => ve.localeCompare(xe)), be = Q.length === X.length && Q.every((ve, xe) => ve === X[xe]), ye = ce.length === G.length && ce.every((ve, xe) => ve === G[xe]);
      return be && ye;
    });
  }
  return {
    populations: r,
    periods: f,
    columnLayout: y,
    getPopulationParticipantsCount: k,
    selectedAnchorDefinition: m,
    selectablePeriodIds: I,
    armIdWithSelectedTimepoints: b,
    periodIdWithSelectedTimepoints: w,
    commonTimepointNamesInSelectedPeriods: x,
    selectedTimepointNames: S,
    allTimepointNamesInSelectedPeriod: A,
    adjacentAnchorIds: g,
    selectedInterventionIds: T,
    selectedInterventionIdsByArm: _,
    expandableArmIds: W,
    getPeriodsForArm: U,
    getNextPeriodColor: z,
    getPopulationById: M,
    getArmById: R,
    findPopulationWithSameCriteria: F
  };
}
let nt = !1;
function qp(e) {
  nt = e.enabled;
}
const Je = {
  lifecycle: "color: #06b6d4; font-weight: bold; font-size: 14px",
  user: "color: #a855f7; font-weight: bold",
  state: {
    add: "color: #10b981; font-weight: bold",
    remove: "color: #ef4444; font-weight: bold",
    update: "color: #3b82f6; font-weight: bold",
    reset: "color: #dc2626; font-weight: bold; font-size: 14px"
  },
  computed: "color: #06b6d4; font-weight: bold"
}, oe = {
  lifecycle(e, t) {
    nt && (t ? console.log(`%c[VDB:Lifecycle] 🚀 ${e}`, Je.lifecycle, t) : console.log(`%c[VDB:Lifecycle] 🚀 ${e}`, Je.lifecycle));
  },
  user(e, t) {
    nt && (t ? console.log(`%c[VDB:User] ${e}`, Je.user, t) : console.log(`%c[VDB:User] ${e}`, Je.user));
  },
  state: {
    add(e, t) {
      nt && console.log(`%c[VDB:State] ${e}`, Je.state.add, t);
    },
    remove(e, t) {
      nt && console.log(`%c[VDB:State] ${e}`, Je.state.remove, t);
    },
    update(e, t) {
      nt && console.log(`%c[VDB:State] ${e}`, Je.state.update, t);
    },
    reset(e, t) {
      nt && console.log(`%c[VDB:State] 🔄 ${e}`, Je.state.reset, t);
    },
    warn(e, t) {
      nt && console.warn(`[VDB:State] ${e}`, t);
    }
  },
  computed(e, t) {
    nt && console.log(`%c[VDB:Computed] ${e}`, Je.computed, t);
  }
};
let Pr = 0;
const it = {
  now: () => `${Date.now()}-${++Pr}`
};
function Ar(e) {
  const {
    populationsDataEntity: t,
    armsDataEntity: n,
    periodsDataEntity: o,
    interventionDefinitions: i,
    hoveredTimepointId: l,
    hoveredTimepointPeriodId: s,
    anchors: a,
    selectedAnchor: d,
    selectedInterventionTimepoints: r
  } = e;
  function f(c, $ = null) {
    c !== l.value && oe.user("Timepoint hover changed", { timepointId: c }), l.value = c, s.value = $;
  }
  function y(c) {
    const $ = { ...c };
    if (!$.name) {
      const j = t.value.length;
      $.name = mr(j);
    }
    oe.state.add("Adding population", {
      id: $.id,
      name: $.name,
      totalPopulations: t.value.length + 1
    });
    const E = {
      id: `${$.id}-arm-1`,
      name: Vo(0),
      participantsCount: 0,
      populationId: $.id,
      anchorPoints: []
    };
    oe.state.add("Auto-creating default arm for new population", {
      populationId: $.id,
      armId: E.id
    }), t.value = [...t.value, $], n.value = [...n.value, E];
  }
  function k(c) {
    const $ = { ...c, anchorPoints: c.anchorPoints ?? [] };
    if (!$.name) {
      const E = n.value.filter(
        (j) => j.populationId === $.populationId
      ).length;
      $.name = Vo(E);
    }
    oe.state.add("Adding arm", {
      id: $.id,
      name: $.name,
      populationId: $.populationId,
      participantsCount: $.participantsCount
    }), n.value = [...n.value, $];
  }
  function m(c) {
    if (!t.value.find((j) => j.id === c)) return;
    const E = n.value.filter((j) => j.populationId === c).map((j) => j.id);
    oe.state.remove("Removing population", { id: c, armIds: E }), t.value = t.value.filter((j) => j.id !== c), n.value = n.value.filter((j) => j.populationId !== c), o.value = o.value.filter(
      (j) => !E.includes(j.armId)
    );
  }
  function h(c) {
    const $ = n.value.find((j) => j.id === c);
    if (!$) return;
    if (n.value.filter(
      (j) => j.populationId === $.populationId
    ).length <= 1) {
      oe.state.warn("Cannot remove last arm of population", {
        armId: c,
        populationId: $.populationId
      });
      return;
    }
    oe.state.remove("Removing arm", { armId: c, populationId: $.populationId }), n.value = n.value.filter((j) => j.id !== c), o.value = o.value.filter((j) => j.armId !== c);
  }
  function I(c, $) {
    const E = t.value.find((j) => j.id === c);
    if (!E) {
      oe.state.warn("Population not found for update:", { id: c });
      return;
    }
    oe.state.update("Updating population", { id: c, updates: $, before: { ...E } }), t.value = t.value.map(
      (j) => j.id === c ? { ...j, ...$ } : j
    );
  }
  function b(c, $) {
    const E = n.value.find((j) => j.id === c);
    if (!E) {
      oe.state.warn("Arm not found for update:", { armId: c });
      return;
    }
    oe.state.update("Updating arm", { armId: c, updates: $, before: { ...E } }), n.value = n.value.map(
      (j) => j.id === c ? { ...j, ...$ } : j
    );
  }
  function w(c = "followup", $) {
    if (c === "baseline" && a.value.some((Y) => Y.type === "baseline")) {
      oe.state.warn("Baseline anchor already exists", {});
      return;
    }
    let E;
    if (c === "baseline") {
      const ee = [
        ...o.value.map((de) => de.globalOrder),
        ...a.value.map((de) => de.globalOrder)
      ].reduce((de, ie) => de === null || ie.localeCompare(de) < 0 ? ie : de, null);
      E = ut(null, ee);
    } else {
      const ee = [
        ...o.value.map((ie) => ie.globalOrder),
        ...a.value.map((ie) => ie.globalOrder)
      ].reduce((ie, Ee) => ie === null || Ee.localeCompare(ie) > 0 ? Ee : ie, null);
      E = ut($ !== void 0 ? $ : ee, null);
    }
    const j = {
      id: it.now(),
      name: c === "baseline" ? "Baseline / Enrollment" : "Longitudinal time point / Follow-up",
      type: c,
      globalOrder: E
    };
    oe.state.add("Adding anchor", { id: j.id, type: c, globalOrder: E }), a.value = [...a.value, j], n.value = n.value.map((Y) => {
      const ee = _(Y.id, j.globalOrder, Y);
      return ee === void 0 ? Y : {
        ...Y,
        anchorPoints: [
          ...Y.anchorPoints ?? [],
          { anchorId: j.id, participantCount: ee }
        ]
      };
    });
  }
  function S(c) {
    oe.state.remove("Removing anchor", { id: c }), a.value = a.value.filter(($) => $.id !== c), n.value = n.value.map(($) => ({
      ...$,
      anchorPoints: $.anchorPoints.filter((E) => E.anchorId !== c)
    }));
  }
  function A(c, $) {
    oe.state.update("Updating anchor", { id: c, updates: $ }), a.value = a.value.map((E) => E.id === c ? { ...E, ...$ } : E);
  }
  function g(c, $, E) {
    const j = ut($, E);
    oe.state.update("Moving anchor", { id: c, newGlobalOrder: j }), a.value = a.value.map(
      (Y) => Y.id === c ? { ...Y, globalOrder: j } : Y
    );
  }
  function x(c, $, E) {
    n.value = n.value.map((j) => j.id !== c ? j : j.anchorPoints.find((ee) => ee.anchorId === $) ? {
      ...j,
      anchorPoints: j.anchorPoints.map(
        (ee) => ee.anchorId === $ ? { ...ee, ...E } : ee
      )
    } : {
      ...j,
      anchorPoints: [...j.anchorPoints, { anchorId: $, ...E }]
    });
  }
  function T(c, $) {
    const E = t.value.find((ee) => ee.id === c), j = t.value.find((ee) => ee.id === $);
    if (!E || !j) {
      oe.state.warn("Cannot merge: population not found", {
        sourcePopulationId: c,
        targetPopulationId: $
      });
      return;
    }
    const Y = n.value.filter((ee) => ee.populationId === c);
    oe.state.update("Merging populations", {
      sourceId: c,
      targetId: $,
      armsToMove: Y.length
    }), n.value = n.value.map(
      (ee) => ee.populationId === c ? { ...ee, populationId: $ } : ee
    ), m(c);
  }
  function _(c, $, E) {
    const j = o.value.filter((ee) => ee.armId === c && ee.globalOrder.localeCompare($) < 0).sort((ee, de) => de.globalOrder.localeCompare(ee.globalOrder));
    if (j.length > 0) {
      const de = [...j[0].timepoints].sort((Ee, me) => Ee.order.localeCompare(me.order)), ie = de[de.length - 1];
      if (ie?.participantCount !== void 0) return ie.participantCount;
    }
    const Y = a.value.filter((ee) => ee.globalOrder.localeCompare($) < 0).sort((ee, de) => de.globalOrder.localeCompare(ee.globalOrder));
    for (const ee of Y) {
      const de = E?.anchorPoints?.find((ie) => ie.anchorId === ee.id);
      if (de?.participantCount !== void 0) return de.participantCount;
    }
    return E && E.participantsCount > 0 ? E.participantsCount : void 0;
  }
  function W(c, $, E, j) {
    const Y = n.value.find((me) => me.id === c);
    let ee, de;
    if (E !== void 0)
      ee = E, de = [
        ...o.value.map(($e) => $e.globalOrder),
        ...a.value.map(($e) => $e.globalOrder)
      ].filter(($e) => $e.localeCompare(E) > 0).sort()[0] ?? void 0;
    else if (j !== void 0) {
      de = j;
      const me = [
        ...o.value.map(($e) => $e.globalOrder),
        ...a.value.map(($e) => $e.globalOrder)
      ].filter(($e) => $e.localeCompare(j) < 0).sort();
      ee = me[me.length - 1] ?? void 0;
    }
    const ie = Pi(o.value, c, $, {
      idGenerator: it.now,
      globalOrderBefore: ee,
      globalOrderAfter: de
    }), Ee = _(c, ie.newPeriod.globalOrder, Y);
    return Ee !== void 0 && (ie.newPeriod = {
      ...ie.newPeriod,
      timepoints: ie.newPeriod.timepoints.map(
        (me) => me.isStart ? { ...me, participantCount: Ee } : me
      )
    }, ie.periods = ie.periods.map(
      (me) => me.id === ie.newPeriod.id ? ie.newPeriod : me
    )), oe.state.add("Adding intervention period", {
      periodId: ie.newPeriod.id,
      armId: c,
      globalOrder: ie.newPeriod.globalOrder,
      afterGlobalOrder: E
    }), o.value = ie.periods, ie.newPeriod;
  }
  function U(c) {
    const $ = o.value.find((E) => E.id === c);
    $ && (oe.state.remove("Removing intervention period", { periodId: c, armId: $.armId }), o.value = hr(o.value, c));
  }
  function z(c, $) {
    o.value = gr(
      o.value,
      c,
      $
    );
  }
  function M(c, $) {
    const E = br(o.value, c, $, {
      idGenerator: it.now
    });
    return E ? (oe.state.add("Adding intervention to period", {
      periodId: c,
      interventionId: E.newIntervention.id
    }), o.value = E.periods, E.newIntervention) : null;
  }
  function R(c, $) {
    oe.state.remove("Removing intervention from period", { periodId: c, interventionId: $ });
    const E = xr(
      o.value,
      c,
      $
    );
    o.value = E.periods;
  }
  function F(c, $, E) {
    o.value = yr(
      o.value,
      c,
      $,
      E
    );
  }
  function L(c, $) {
    const E = o.value.find((ee) => ee.id === c);
    if (!E) return;
    const j = E.timepoints.length;
    o.value = Cr(
      o.value,
      c,
      $,
      it.now
    );
    const Y = o.value.find((ee) => ee.id === c);
    if (Y && Y.timepoints.length > j) {
      const ee = Y.timepoints[Y.timepoints.length - 1];
      oe.state.add("Adding timepoint to period", {
        periodId: c,
        timepointId: ee?.id,
        timepointName: ee?.name,
        afterTimepointId: $,
        totalTimepoints: Y.timepoints.length
      });
    }
  }
  function N(c, $) {
    const E = o.value.find((ee) => ee.id === c);
    if (!E) return;
    const j = E.timepoints.find((ee) => ee.id === $);
    if (!j) return;
    const Y = kr(o.value, c, $);
    if (!Y.removed) {
      oe.state.warn(Y.reason ?? "Cannot remove timepoint", { timepointId: $, timepoint: j });
      return;
    }
    oe.state.remove("Removing timepoint from period", {
      periodId: c,
      timepointId: $,
      timepointName: j.name
    }), o.value = Y.periods;
  }
  function D(c, $, E, j) {
    const Y = o.value.find((de) => de.id === c);
    if (!Y) return;
    const ee = Y.timepoints.find((de) => de.id === $);
    ee && (oe.state.update("Renaming timepoint", {
      oldName: ee.name,
      newName: E,
      periodId: c,
      timepointId: $,
      applyToAll: j
    }), o.value = $r(
      o.value,
      c,
      $,
      E,
      j
    ));
  }
  function X(c, $) {
    const E = Ir(
      o.value,
      c,
      $,
      it.now
    );
    return E ? (oe.state.add("Cloning period to arm", {
      sourcePeriodId: c,
      targetArmId: $,
      newPeriodId: E.newPeriod.id
    }), o.value = E.periods, E.newPeriod) : null;
  }
  function G() {
    oe.state.reset("RESET ALL", {
      populations: t.value.length,
      arms: n.value.length,
      periods: o.value.length
    }), t.value = [], n.value = [], o.value = [], i.value = [], l.value = null, s.value = null, a.value = [Vn], d.value = null, r.value = [];
  }
  function q(c) {
    oe.state.update("Importing study design", {
      populations: c.populations?.length ?? 0,
      arms: c.arms?.length ?? 0,
      periods: c.periods?.length ?? 0
    }), t.value = c.populations ?? [], n.value = (c.arms ?? []).map(($) => ({
      ...$,
      anchorPoints: $.anchorPoints ?? []
    })), o.value = c.periods ?? [], i.value = c.interventionDefinitions, a.value = c.anchors ?? [Vn], d.value = null, r.value = [];
  }
  function Q(c, $) {
    return o.value.find(
      (j) => j.interventions.some((Y) => Y.id === c)
    )?.timepoints.find((j) => j.id === $)?.name;
  }
  function ce() {
    const c = /* @__PURE__ */ new Set();
    for (const $ of r.value) {
      const E = Q($.interventionId, $.timepointId);
      E && c.add(E);
    }
    return c;
  }
  function be(c) {
    r.value = r.value.filter(
      ($) => Q($.interventionId, $.timepointId) !== c
    );
  }
  function ye() {
    const c = ce();
    if (c.size === 0) return;
    const $ = new Set(
      r.value.map((Y) => Y.interventionId)
    ), E = [], j = /* @__PURE__ */ new Set();
    for (const Y of $) {
      const ee = o.value.find(
        (de) => de.interventions.some((ie) => ie.id === Y)
      );
      if (!ee) {
        j.add(Y);
        continue;
      }
      for (const de of c) {
        const ie = ee.timepoints.find((me) => me.name === de);
        if (!ie) {
          j.add(Y);
          break;
        }
        r.value.some(
          (me) => me.interventionId === Y && me.timepointId === ie.id
        ) || E.push({ interventionId: Y, timepointId: ie.id });
      }
    }
    j.size > 0 && (r.value = r.value.filter(
      (Y) => !j.has(Y.interventionId)
    )), E.length > 0 && (r.value = [...r.value, ...E]);
  }
  function ve() {
    return (d.value ? 1 : 0) + ce().size;
  }
  function xe(c, $) {
    if (d.value?.anchorId === c && d.value?.armId === $) {
      d.value = null;
      return;
    }
    ce().size > 0 || (d.value = { anchorId: c, armId: $ });
  }
  function Ae(c, $) {
    if (d.value !== null) return;
    const E = Q(c, $);
    if (r.value.some(
      (ie) => ie.interventionId === c && ie.timepointId === $
    )) {
      E ? be(E) : r.value = r.value.filter(
        (ie) => !(ie.interventionId === c && ie.timepointId === $)
      );
      return;
    }
    const Y = ce();
    if (E !== void 0 && !Y.has(E) && ve() >= 2) return;
    const de = new Set(
      r.value.map((ie) => ie.interventionId)
    );
    if (!de.has(c) && de.size >= 2) {
      const ie = o.value.find(
        (Se) => Se.interventions.some((Be) => Be.id === c)
      );
      if (!ie) return;
      const Ee = /* @__PURE__ */ new Set();
      for (const Se of de) {
        const Be = o.value.find((qe) => qe.interventions.some((Fe) => Fe.id === Se));
        Be && Ee.add(Be.armId);
      }
      if (Ee.has(ie.armId)) return;
      const me = /* @__PURE__ */ new Set();
      for (const Se of de) {
        const qe = o.value.find((Fe) => Fe.interventions.some((Qe) => Qe.id === Se))?.interventions.find((Fe) => Fe.id === Se);
        qe && me.add(qe.definitionId);
      }
      const $e = o.value.filter(
        (Se) => Se.armId === ie.armId
      ), vt = new Set(
        $e.flatMap((Se) => Se.interventions.map((Be) => Be.definitionId))
      );
      for (const Se of me)
        if (!vt.has(Se)) return;
      const mt = [];
      for (const Se of $e)
        for (const Be of Se.interventions)
          if (me.has(Be.definitionId))
            for (const qe of ce()) {
              const Fe = Se.timepoints.find((Qe) => Qe.name === qe);
              Fe && (r.value.some(
                (Qe) => Qe.interventionId === Be.id && Qe.timepointId === Fe.id
              ) || mt.push({ interventionId: Be.id, timepointId: Fe.id }));
            }
      if (mt.length === 0) return;
      r.value = [...r.value, ...mt], ye();
      return;
    }
    r.value = [
      ...r.value,
      { interventionId: c, timepointId: $ }
    ], ye();
  }
  function Re(c) {
    r.value = r.value.filter(
      ($) => $.interventionId !== c
    );
  }
  function Ie() {
    d.value = null, r.value = [];
  }
  function le() {
    return {
      selectedAnchor: d.value,
      interventionTimepoints: r.value
    };
  }
  function ue(c) {
    const $ = {
      id: it.now(),
      ...c
    };
    return i.value = [...i.value, $], $;
  }
  function ke(c, $) {
    i.value = i.value.map(
      (E) => E.id === c ? { ...E, ...$ } : E
    );
  }
  function re(c) {
    const $ = i.value.find((Y) => Y.id === c);
    if (!$) return null;
    const { id: E, ...j } = $;
    return ue({ ...j, items: [...j.items] });
  }
  function P(c) {
    let $ = 0;
    for (const E of o.value)
      for (const j of E.interventions)
        j.definitionId === c && $++;
    return $;
  }
  function O(c) {
    return i.value.find(($) => $.id === c);
  }
  return {
    setHoveredTimepoint: f,
    updateTimepointName: D,
    addPopulation: y,
    removePopulation: m,
    updatePopulation: I,
    mergePopulations: T,
    addArm: k,
    removeArm: h,
    updateArm: b,
    addAnchor: w,
    removeAnchor: S,
    updateAnchor: A,
    moveAnchor: g,
    updateArmAnchorPoint: x,
    addPeriod: W,
    removePeriod: U,
    updatePeriod: z,
    addInterventionToPeriod: M,
    removeInterventionFromPeriod: R,
    updateIntervention: F,
    addTimepointToPeriod: L,
    removeTimepointFromPeriod: N,
    clonePeriodToArm: X,
    resetAll: G,
    importStudyDesign: q,
    toggleAnchorSelection: xe,
    toggleInterventionTimepointSelection: Ae,
    removeInterventionTimepoints: Re,
    clearSelection: Ie,
    getSelection: le,
    createDefinition: ue,
    updateDefinition: ke,
    forkDefinition: re,
    getDefinitionUsageCount: P,
    getDefinitionById: O
  };
}
function Er(e, t) {
  const n = el(e, t);
  if (n === void 0)
    throw new Error(
      `[VDB] Missing required injection: "${String(e.description ?? e)}". Make sure the VisualStudyDesignBuilder component is an ancestor of this component.`
    );
  return n;
}
function Or(e = {}) {
  const t = vr(e), n = Sr(t), o = Ar(t), i = Ln({ visible: !1, armId: "", periodId: "" }), l = Ln({ visible: !1, populationId: "" });
  function s(k, m, h, I, b) {
    l.visible = !1, l.populationId = "", i.armId = k, i.periodId = m ?? "", i.intervention = h, i.afterGlobalOrder = I, i.beforeGlobalOrder = b, i.visible = !0;
  }
  function a() {
    i.visible = !1, i.intervention = void 0, i.armId = "", i.periodId = "", i.afterGlobalOrder = void 0, i.beforeGlobalOrder = void 0;
  }
  function d(k) {
    i.visible = !1, i.intervention = void 0, i.armId = "", i.periodId = "", l.populationId = k, l.visible = !0;
  }
  function r() {
    l.visible = !1, l.populationId = "";
  }
  const f = B(/* @__PURE__ */ new Map()), y = B(1);
  return {
    ...n,
    ...t,
    ...o,
    interventionDrawer: i,
    populationDrawer: l,
    openInterventionDrawer: s,
    closeInterventionDrawer: a,
    openPopulationDrawer: d,
    closePopulationDrawer: r,
    anchorGaps: f,
    scale: y
  };
}
const no = /* @__PURE__ */ Symbol(
  "VisualStudyDesignBuilderContext"
);
function pt() {
  return Er(no);
}
const Mr = {}, Rr = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Dr(e, t) {
  return v(), C("svg", Rr, [...t[0] || (t[0] = [
    u("path", {
      d: "M0 9V7H7.6L12.6 2H10V0H16V6H14V3.4L8.4 9H0ZM10 16V14H12.6L9.4 10.85L10.85 9.4L14 12.6V10H16V16H10Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const Lr = /* @__PURE__ */ Me(Mr, [["render", Dr]]), Br = {}, Nr = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function zr(e, t) {
  return v(), C("svg", Nr, [...t[0] || (t[0] = [
    u("path", {
      d: "M5.206 16.35C5.61807 16.561 6.04219 16.5962 6.47836 16.4554C6.91452 16.3147 7.23812 16.0383 7.44915 15.6262C7.66017 15.2141 7.69532 14.79 7.55459 14.3539C7.41385 13.9177 7.13745 13.5941 6.72538 13.3831C6.31331 13.172 5.88919 13.1369 5.45302 13.2776C5.01685 13.4184 4.69326 13.6948 4.48223 14.1068C4.27121 14.5189 4.23606 14.943 4.37679 15.3792C4.51752 15.8154 4.79393 16.139 5.206 16.35ZM9.76415 7.44923C10.1762 7.66026 10.6003 7.69541 11.0365 7.55467C11.4727 7.41394 11.7963 7.13754 12.0073 6.72547C12.2183 6.3134 12.2535 5.88928 12.1127 5.45311C11.972 5.01694 11.6956 4.69334 11.2835 4.48232C10.8715 4.27129 10.4473 4.23615 10.0112 4.37688C9.575 4.51761 9.25141 4.79401 9.04038 5.20608C8.82935 5.61816 8.79421 6.04228 8.93494 6.47844C9.07567 6.91461 9.35207 7.23821 9.76415 7.44923ZM11.9354 14.1787C12.3475 14.3897 12.7716 14.4249 13.2078 14.2841C13.644 14.1434 13.9676 13.867 14.1786 13.4549C14.3896 13.0428 14.4248 12.6187 14.284 12.1826C14.1433 11.7464 13.8669 11.4228 13.4548 11.2118C13.0428 11.0007 12.6186 10.9656 12.1825 11.1063C11.7463 11.2471 11.4227 11.5235 11.2117 11.9355C11.0007 12.3476 10.9655 12.7717 11.1062 13.2079C11.247 13.6441 11.5234 13.9677 11.9354 14.1787ZM14.1067 20.9081C14.5188 21.1192 14.9429 21.1543 15.3791 21.0136C15.8153 20.8728 16.1389 20.5964 16.3499 20.1844C16.5609 19.7723 16.5961 19.3482 16.4553 18.912C16.3146 18.4758 16.0382 18.1522 15.6261 17.9412C15.2141 17.7302 14.7899 17.695 14.3538 17.8358C13.9176 17.9765 13.594 18.2529 13.383 18.665C13.172 19.0771 13.1368 19.5012 13.2775 19.9373C13.4183 20.3735 13.6947 20.6971 14.1067 20.9081ZM18.6649 12.0074C19.077 12.2184 19.5011 12.2536 19.9373 12.1128C20.3734 11.9721 20.697 11.6957 20.908 11.2836C21.1191 10.8715 21.1542 10.4474 21.0135 10.0113C20.8727 9.57509 20.5963 9.25149 20.1843 9.04047C19.7722 8.82944 19.3481 8.7943 18.9119 8.93503C18.4757 9.07576 18.1522 9.35216 17.9411 9.76423C17.7301 10.1763 17.695 10.6004 17.8357 11.0366C17.9764 11.4728 18.2528 11.7964 18.6649 12.0074ZM1.21419 18.0507C0.670251 17.7722 0.303791 17.3401 0.114808 16.7543C-0.0741757 16.1686 -0.0293901 15.6038 0.249163 15.0599L7.33962 1.21427C7.61817 0.670337 8.0503 0.303878 8.63601 0.114895C9.22173 -0.0740884 9.78655 -0.0293035 10.3305 0.24925L24.1761 7.3397C24.72 7.61826 25.0865 8.05039 25.2755 8.6361C25.4644 9.22181 25.4197 9.78663 25.1411 10.3306L18.0507 24.1762C17.7721 24.7201 17.34 25.0866 16.7543 25.2756C16.1685 25.4645 15.6037 25.4197 15.0598 25.1412L1.21419 18.0507ZM2.22711 16.0728L16.0727 23.1633L23.1632 9.31765L9.31756 2.22719L2.22711 16.0728Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const Ai = /* @__PURE__ */ Me(Br, [["render", zr]]), _r = {}, Vr = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function Fr(e, t) {
  return v(), C("svg", Vr, [...t[0] || (t[0] = [
    u("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.0001 2.09961C7.3867 2.09961 7.7001 2.41301 7.7001 2.79961V6.29961H11.2001C11.5867 6.29961 11.9001 6.61301 11.9001 6.99961C11.9001 7.38621 11.5867 7.69961 11.2001 7.69961H7.7001V11.1996C7.7001 11.5862 7.3867 11.8996 7.0001 11.8996C6.6135 11.8996 6.3001 11.5862 6.3001 11.1996V7.69961H2.8001C2.4135 7.69961 2.1001 7.38621 2.1001 6.99961C2.1001 6.61301 2.4135 6.29961 2.8001 6.29961L6.3001 6.29961V2.79961C6.3001 2.41301 6.6135 2.09961 7.0001 2.09961Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const oo = /* @__PURE__ */ Me(_r, [["render", Fr]]), jr = ["title"], Hr = { class: "flex items-center justify-center size-8 shrink-0 relative" }, Ur = {
  class: "absolute size-3.5 rounded-full bg-[#555e69] flex items-center justify-center",
  style: { left: "17.5px", top: "-5.5px" }
}, Ht = /* @__PURE__ */ ge({
  __name: "ExpandButton",
  props: {
    label: {},
    title: {},
    direction: { default: "right" }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = B(!1), l = B(null), s = B(0);
    function a() {
      Ge(() => {
        l.value && (s.value = l.value.scrollWidth);
      });
    }
    return rt(a), Te(() => n.label, a), (d, r) => (v(), C("button", {
      class: Z(["flex items-center h-8 rounded-full border-[1.5px] border-[#555E69] bg-white text-[#555E69] cursor-pointer hover:bg-slate-50 shrink-0 transition-all duration-200", e.direction === "left" ? "flex-row-reverse" : ""]),
      title: e.title,
      onMouseenter: r[0] || (r[0] = (f) => i.value = !0),
      onMouseleave: r[1] || (r[1] = (f) => i.value = !1),
      onClick: r[2] || (r[2] = he((f) => o("click"), ["stop"]))
    }, [
      u("span", Hr, [
        at(d.$slots, "default"),
        u("span", Ur, [
          K(oo, { class: "size-3 text-white" })
        ])
      ]),
      u("span", {
        ref_key: "labelRef",
        ref: l,
        class: "overflow-hidden transition-all duration-200 text-xs font-semibold whitespace-nowrap",
        style: ne({ maxWidth: i.value ? `${s.value}px` : "0px" })
      }, [
        u("span", {
          class: Z(e.direction === "left" ? "pl-2.5" : "pr-2.5")
        }, ae(e.label), 3)
      ], 4)
    ], 42, jr));
  }
}), Gr = typeof window < "u" && typeof document < "u";
typeof WorkerGlobalScope < "u" && globalThis instanceof WorkerGlobalScope;
const Wr = Object.prototype.toString, Xr = (e) => Wr.call(e) === "[object Object]", Yt = () => {
};
function In(e) {
  return Array.isArray(e) ? e : [e];
}
function qr(e, t, n) {
  return Te(e, t, {
    ...n,
    immediate: !0
  });
}
const Ei = Gr ? window : void 0;
function _t(e) {
  var t;
  const n = gt(e);
  return (t = n?.$el) !== null && t !== void 0 ? t : n;
}
function Tn(...e) {
  const t = (o, i, l, s) => (o.addEventListener(i, l, s), () => o.removeEventListener(i, l, s)), n = V(() => {
    const o = In(gt(e[0])).filter((i) => i != null);
    return o.every((i) => typeof i != "string") ? o : void 0;
  });
  return qr(() => {
    var o, i;
    return [
      (o = (i = n.value) === null || i === void 0 ? void 0 : i.map((l) => _t(l))) !== null && o !== void 0 ? o : [Ei].filter((l) => l != null),
      In(gt(n.value ? e[1] : e[0])),
      In(p(n.value ? e[2] : e[1])),
      gt(n.value ? e[3] : e[2])
    ];
  }, ([o, i, l, s], a, d) => {
    if (!o?.length || !i?.length || !l?.length) return;
    const r = Xr(s) ? { ...s } : s, f = o.flatMap((y) => i.flatMap((k) => l.map((m) => t(y, k, m, r))));
    d(() => {
      f.forEach((y) => y());
    });
  }, { flush: "post" });
}
function Zr(e, t, n = {}) {
  const { window: o = Ei, ignore: i = [], capture: l = !0, detectIframe: s = !1, controls: a = !1 } = n;
  if (!o) return a ? {
    stop: Yt,
    cancel: Yt,
    trigger: Yt
  } : Yt;
  let d = !0;
  const r = (b) => gt(i).some((w) => {
    if (typeof w == "string") return Array.from(o.document.querySelectorAll(w)).some((S) => S === b.target || b.composedPath().includes(S));
    {
      const S = _t(w);
      return S && (b.target === S || b.composedPath().includes(S));
    }
  });
  function f(b) {
    const w = gt(b);
    return w && w.$.subTree.shapeFlag === 16;
  }
  function y(b, w) {
    const S = gt(b), A = S.$.subTree && S.$.subTree.children;
    return A == null || !Array.isArray(A) ? !1 : A.some((g) => g.el === w.target || w.composedPath().includes(g.el));
  }
  const k = (b) => {
    const w = _t(e);
    if (b.target != null && !(!(w instanceof Element) && f(e) && y(e, b)) && !(!w || w === b.target || b.composedPath().includes(w))) {
      if ("detail" in b && b.detail === 0 && (d = !r(b)), !d) {
        d = !0;
        return;
      }
      t(b);
    }
  };
  let m = !1;
  const h = [
    Tn(o, "click", (b) => {
      m || (m = !0, setTimeout(() => {
        m = !1;
      }, 0), k(b));
    }, {
      passive: !0,
      capture: l
    }),
    Tn(o, "pointerdown", (b) => {
      const w = _t(e);
      d = !r(b) && !!(w && !b.composedPath().includes(w));
    }, { passive: !0 }),
    s && Tn(o, "blur", (b) => {
      setTimeout(() => {
        var w;
        const S = _t(e);
        ((w = o.document.activeElement) === null || w === void 0 ? void 0 : w.tagName) === "IFRAME" && !S?.contains(o.document.activeElement) && t(b);
      }, 0);
    }, { passive: !0 })
  ].filter(Boolean), I = () => h.forEach((b) => b());
  return a ? {
    stop: I,
    cancel: () => {
      d = !1;
    },
    trigger: (b) => {
      d = !0, k(b), d = !1;
    }
  } : I;
}
const Mt = Math.min, bt = Math.max, dn = Math.round, Kt = Math.floor, Ze = (e) => ({
  x: e,
  y: e
}), Yr = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Kr = {
  start: "end",
  end: "start"
};
function jn(e, t, n) {
  return bt(e, Mt(t, n));
}
function xt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ct(e) {
  return e.split("-")[0];
}
function Ut(e) {
  return e.split("-")[1];
}
function io(e) {
  return e === "x" ? "y" : "x";
}
function lo(e) {
  return e === "y" ? "height" : "width";
}
const Qr = /* @__PURE__ */ new Set(["top", "bottom"]);
function lt(e) {
  return Qr.has(ct(e)) ? "y" : "x";
}
function ro(e) {
  return io(lt(e));
}
function Jr(e, t, n) {
  n === void 0 && (n = !1);
  const o = Ut(e), i = ro(e), l = lo(i);
  let s = i === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[l] > t.floating[l] && (s = cn(s)), [s, cn(s)];
}
function es(e) {
  const t = cn(e);
  return [Hn(e), t, Hn(t)];
}
function Hn(e) {
  return e.replace(/start|end/g, (t) => Kr[t]);
}
const Fo = ["left", "right"], jo = ["right", "left"], ts = ["top", "bottom"], ns = ["bottom", "top"];
function os(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? jo : Fo : t ? Fo : jo;
    case "left":
    case "right":
      return t ? ts : ns;
    default:
      return [];
  }
}
function is(e, t, n, o) {
  const i = Ut(e);
  let l = os(ct(e), n === "start", o);
  return i && (l = l.map((s) => s + "-" + i), t && (l = l.concat(l.map(Hn)))), l;
}
function cn(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Yr[t]);
}
function ls(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Oi(e) {
  return typeof e != "number" ? ls(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function fn(e) {
  const {
    x: t,
    y: n,
    width: o,
    height: i
  } = e;
  return {
    width: o,
    height: i,
    top: n,
    left: t,
    right: t + o,
    bottom: n + i,
    x: t,
    y: n
  };
}
function Ho(e, t, n) {
  let {
    reference: o,
    floating: i
  } = e;
  const l = lt(t), s = ro(t), a = lo(s), d = ct(t), r = l === "y", f = o.x + o.width / 2 - i.width / 2, y = o.y + o.height / 2 - i.height / 2, k = o[a] / 2 - i[a] / 2;
  let m;
  switch (d) {
    case "top":
      m = {
        x: f,
        y: o.y - i.height
      };
      break;
    case "bottom":
      m = {
        x: f,
        y: o.y + o.height
      };
      break;
    case "right":
      m = {
        x: o.x + o.width,
        y
      };
      break;
    case "left":
      m = {
        x: o.x - i.width,
        y
      };
      break;
    default:
      m = {
        x: o.x,
        y: o.y
      };
  }
  switch (Ut(t)) {
    case "start":
      m[s] -= k * (n && r ? -1 : 1);
      break;
    case "end":
      m[s] += k * (n && r ? -1 : 1);
      break;
  }
  return m;
}
async function rs(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: o,
    y: i,
    platform: l,
    rects: s,
    elements: a,
    strategy: d
  } = e, {
    boundary: r = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: y = "floating",
    altBoundary: k = !1,
    padding: m = 0
  } = xt(t, e), h = Oi(m), b = a[k ? y === "floating" ? "reference" : "floating" : y], w = fn(await l.getClippingRect({
    element: (n = await (l.isElement == null ? void 0 : l.isElement(b))) == null || n ? b : b.contextElement || await (l.getDocumentElement == null ? void 0 : l.getDocumentElement(a.floating)),
    boundary: r,
    rootBoundary: f,
    strategy: d
  })), S = y === "floating" ? {
    x: o,
    y: i,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, A = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(a.floating)), g = await (l.isElement == null ? void 0 : l.isElement(A)) ? await (l.getScale == null ? void 0 : l.getScale(A)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, x = fn(l.convertOffsetParentRelativeRectToViewportRelativeRect ? await l.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: a,
    rect: S,
    offsetParent: A,
    strategy: d
  }) : S);
  return {
    top: (w.top - x.top + h.top) / g.y,
    bottom: (x.bottom - w.bottom + h.bottom) / g.y,
    left: (w.left - x.left + h.left) / g.x,
    right: (x.right - w.right + h.right) / g.x
  };
}
const ss = async (e, t, n) => {
  const {
    placement: o = "bottom",
    strategy: i = "absolute",
    middleware: l = [],
    platform: s
  } = n, a = l.filter(Boolean), d = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let r = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: f,
    y
  } = Ho(r, o, d), k = o, m = {}, h = 0;
  for (let b = 0; b < a.length; b++) {
    var I;
    const {
      name: w,
      fn: S
    } = a[b], {
      x: A,
      y: g,
      data: x,
      reset: T
    } = await S({
      x: f,
      y,
      initialPlacement: o,
      placement: k,
      strategy: i,
      middlewareData: m,
      rects: r,
      platform: {
        ...s,
        detectOverflow: (I = s.detectOverflow) != null ? I : rs
      },
      elements: {
        reference: e,
        floating: t
      }
    });
    f = A ?? f, y = g ?? y, m = {
      ...m,
      [w]: {
        ...m[w],
        ...x
      }
    }, T && h <= 50 && (h++, typeof T == "object" && (T.placement && (k = T.placement), T.rects && (r = T.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : T.rects), {
      x: f,
      y
    } = Ho(r, k, d)), b = -1);
  }
  return {
    x: f,
    y,
    placement: k,
    strategy: i,
    middlewareData: m
  };
}, as = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: o,
      placement: i,
      rects: l,
      platform: s,
      elements: a,
      middlewareData: d
    } = t, {
      element: r,
      padding: f = 0
    } = xt(e, t) || {};
    if (r == null)
      return {};
    const y = Oi(f), k = {
      x: n,
      y: o
    }, m = ro(i), h = lo(m), I = await s.getDimensions(r), b = m === "y", w = b ? "top" : "left", S = b ? "bottom" : "right", A = b ? "clientHeight" : "clientWidth", g = l.reference[h] + l.reference[m] - k[m] - l.floating[h], x = k[m] - l.reference[m], T = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(r));
    let _ = T ? T[A] : 0;
    (!_ || !await (s.isElement == null ? void 0 : s.isElement(T))) && (_ = a.floating[A] || l.floating[h]);
    const W = g / 2 - x / 2, U = _ / 2 - I[h] / 2 - 1, z = Mt(y[w], U), M = Mt(y[S], U), R = z, F = _ - I[h] - M, L = _ / 2 - I[h] / 2 + W, N = jn(R, L, F), D = !d.arrow && Ut(i) != null && L !== N && l.reference[h] / 2 - (L < R ? z : M) - I[h] / 2 < 0, X = D ? L < R ? L - R : L - F : 0;
    return {
      [m]: k[m] + X,
      data: {
        [m]: N,
        centerOffset: L - N - X,
        ...D && {
          alignmentOffset: X
        }
      },
      reset: D
    };
  }
}), us = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, o;
      const {
        placement: i,
        middlewareData: l,
        rects: s,
        initialPlacement: a,
        platform: d,
        elements: r
      } = t, {
        mainAxis: f = !0,
        crossAxis: y = !0,
        fallbackPlacements: k,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: I = !0,
        ...b
      } = xt(e, t);
      if ((n = l.arrow) != null && n.alignmentOffset)
        return {};
      const w = ct(i), S = lt(a), A = ct(a) === a, g = await (d.isRTL == null ? void 0 : d.isRTL(r.floating)), x = k || (A || !I ? [cn(a)] : es(a)), T = h !== "none";
      !k && T && x.push(...is(a, I, h, g));
      const _ = [a, ...x], W = await d.detectOverflow(t, b), U = [];
      let z = ((o = l.flip) == null ? void 0 : o.overflows) || [];
      if (f && U.push(W[w]), y) {
        const L = Jr(i, s, g);
        U.push(W[L[0]], W[L[1]]);
      }
      if (z = [...z, {
        placement: i,
        overflows: U
      }], !U.every((L) => L <= 0)) {
        var M, R;
        const L = (((M = l.flip) == null ? void 0 : M.index) || 0) + 1, N = _[L];
        if (N && (!(y === "alignment" ? S !== lt(N) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        z.every((G) => lt(G.placement) === S ? G.overflows[0] > 0 : !0)))
          return {
            data: {
              index: L,
              overflows: z
            },
            reset: {
              placement: N
            }
          };
        let D = (R = z.filter((X) => X.overflows[0] <= 0).sort((X, G) => X.overflows[1] - G.overflows[1])[0]) == null ? void 0 : R.placement;
        if (!D)
          switch (m) {
            case "bestFit": {
              var F;
              const X = (F = z.filter((G) => {
                if (T) {
                  const q = lt(G.placement);
                  return q === S || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  q === "y";
                }
                return !0;
              }).map((G) => [G.placement, G.overflows.filter((q) => q > 0).reduce((q, Q) => q + Q, 0)]).sort((G, q) => G[1] - q[1])[0]) == null ? void 0 : F[0];
              X && (D = X);
              break;
            }
            case "initialPlacement":
              D = a;
              break;
          }
        if (i !== D)
          return {
            reset: {
              placement: D
            }
          };
      }
      return {};
    }
  };
}, Mi = /* @__PURE__ */ new Set(["left", "top"]);
async function ds(e, t) {
  const {
    placement: n,
    platform: o,
    elements: i
  } = e, l = await (o.isRTL == null ? void 0 : o.isRTL(i.floating)), s = ct(n), a = Ut(n), d = lt(n) === "y", r = Mi.has(s) ? -1 : 1, f = l && d ? -1 : 1, y = xt(t, e);
  let {
    mainAxis: k,
    crossAxis: m,
    alignmentAxis: h
  } = typeof y == "number" ? {
    mainAxis: y,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: y.mainAxis || 0,
    crossAxis: y.crossAxis || 0,
    alignmentAxis: y.alignmentAxis
  };
  return a && typeof h == "number" && (m = a === "end" ? h * -1 : h), d ? {
    x: m * f,
    y: k * r
  } : {
    x: k * r,
    y: m * f
  };
}
const cs = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, o;
      const {
        x: i,
        y: l,
        placement: s,
        middlewareData: a
      } = t, d = await ds(t, e);
      return s === ((n = a.offset) == null ? void 0 : n.placement) && (o = a.arrow) != null && o.alignmentOffset ? {} : {
        x: i + d.x,
        y: l + d.y,
        data: {
          ...d,
          placement: s
        }
      };
    }
  };
}, fs = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: o,
        placement: i,
        platform: l
      } = t, {
        mainAxis: s = !0,
        crossAxis: a = !1,
        limiter: d = {
          fn: (w) => {
            let {
              x: S,
              y: A
            } = w;
            return {
              x: S,
              y: A
            };
          }
        },
        ...r
      } = xt(e, t), f = {
        x: n,
        y: o
      }, y = await l.detectOverflow(t, r), k = lt(ct(i)), m = io(k);
      let h = f[m], I = f[k];
      if (s) {
        const w = m === "y" ? "top" : "left", S = m === "y" ? "bottom" : "right", A = h + y[w], g = h - y[S];
        h = jn(A, h, g);
      }
      if (a) {
        const w = k === "y" ? "top" : "left", S = k === "y" ? "bottom" : "right", A = I + y[w], g = I - y[S];
        I = jn(A, I, g);
      }
      const b = d.fn({
        ...t,
        [m]: h,
        [k]: I
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - o,
          enabled: {
            [m]: s,
            [k]: a
          }
        }
      };
    }
  };
}, ps = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: o,
        placement: i,
        rects: l,
        middlewareData: s
      } = t, {
        offset: a = 0,
        mainAxis: d = !0,
        crossAxis: r = !0
      } = xt(e, t), f = {
        x: n,
        y: o
      }, y = lt(i), k = io(y);
      let m = f[k], h = f[y];
      const I = xt(a, t), b = typeof I == "number" ? {
        mainAxis: I,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...I
      };
      if (d) {
        const A = k === "y" ? "height" : "width", g = l.reference[k] - l.floating[A] + b.mainAxis, x = l.reference[k] + l.reference[A] - b.mainAxis;
        m < g ? m = g : m > x && (m = x);
      }
      if (r) {
        var w, S;
        const A = k === "y" ? "width" : "height", g = Mi.has(ct(i)), x = l.reference[y] - l.floating[A] + (g && ((w = s.offset) == null ? void 0 : w[y]) || 0) + (g ? 0 : b.crossAxis), T = l.reference[y] + l.reference[A] + (g ? 0 : ((S = s.offset) == null ? void 0 : S[y]) || 0) - (g ? b.crossAxis : 0);
        h < x ? h = x : h > T && (h = T);
      }
      return {
        [k]: m,
        [y]: h
      };
    }
  };
};
function mn() {
  return typeof window < "u";
}
function wt(e) {
  return so(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function Ve(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function Ke(e) {
  var t;
  return (t = (so(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function so(e) {
  return mn() ? e instanceof Node || e instanceof Ve(e).Node : !1;
}
function We(e) {
  return mn() ? e instanceof Element || e instanceof Ve(e).Element : !1;
}
function Ye(e) {
  return mn() ? e instanceof HTMLElement || e instanceof Ve(e).HTMLElement : !1;
}
function Uo(e) {
  return !mn() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof Ve(e).ShadowRoot;
}
const vs = /* @__PURE__ */ new Set(["inline", "contents"]);
function Gt(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: o,
    display: i
  } = Xe(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + n) && !vs.has(i);
}
const ms = /* @__PURE__ */ new Set(["table", "td", "th"]);
function hs(e) {
  return ms.has(wt(e));
}
const gs = [":popover-open", ":modal"];
function hn(e) {
  return gs.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const bs = ["transform", "translate", "scale", "rotate", "perspective"], xs = ["transform", "translate", "scale", "rotate", "perspective", "filter"], ys = ["paint", "layout", "strict", "content"];
function ao(e) {
  const t = uo(), n = We(e) ? Xe(e) : e;
  return bs.some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || xs.some((o) => (n.willChange || "").includes(o)) || ys.some((o) => (n.contain || "").includes(o));
}
function ws(e) {
  let t = ft(e);
  for (; Ye(t) && !Rt(t); ) {
    if (ao(t))
      return t;
    if (hn(t))
      return null;
    t = ft(t);
  }
  return null;
}
function uo() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const Cs = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function Rt(e) {
  return Cs.has(wt(e));
}
function Xe(e) {
  return Ve(e).getComputedStyle(e);
}
function gn(e) {
  return We(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function ft(e) {
  if (wt(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Uo(e) && e.host || // Fallback.
    Ke(e)
  );
  return Uo(t) ? t.host : t;
}
function Ri(e) {
  const t = ft(e);
  return Rt(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ye(t) && Gt(t) ? t : Ri(t);
}
function Ft(e, t, n) {
  var o;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = Ri(e), l = i === ((o = e.ownerDocument) == null ? void 0 : o.body), s = Ve(i);
  if (l) {
    const a = Un(s);
    return t.concat(s, s.visualViewport || [], Gt(i) ? i : [], a && n ? Ft(a) : []);
  }
  return t.concat(i, Ft(i, [], n));
}
function Un(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function Di(e) {
  const t = Xe(e);
  let n = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const i = Ye(e), l = i ? e.offsetWidth : n, s = i ? e.offsetHeight : o, a = dn(n) !== l || dn(o) !== s;
  return a && (n = l, o = s), {
    width: n,
    height: o,
    $: a
  };
}
function co(e) {
  return We(e) ? e : e.contextElement;
}
function At(e) {
  const t = co(e);
  if (!Ye(t))
    return Ze(1);
  const n = t.getBoundingClientRect(), {
    width: o,
    height: i,
    $: l
  } = Di(t);
  let s = (l ? dn(n.width) : n.width) / o, a = (l ? dn(n.height) : n.height) / i;
  return (!s || !Number.isFinite(s)) && (s = 1), (!a || !Number.isFinite(a)) && (a = 1), {
    x: s,
    y: a
  };
}
const ks = /* @__PURE__ */ Ze(0);
function Li(e) {
  const t = Ve(e);
  return !uo() || !t.visualViewport ? ks : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function $s(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== Ve(e) ? !1 : t;
}
function yt(e, t, n, o) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), l = co(e);
  let s = Ze(1);
  t && (o ? We(o) && (s = At(o)) : s = At(e));
  const a = $s(l, n, o) ? Li(l) : Ze(0);
  let d = (i.left + a.x) / s.x, r = (i.top + a.y) / s.y, f = i.width / s.x, y = i.height / s.y;
  if (l) {
    const k = Ve(l), m = o && We(o) ? Ve(o) : o;
    let h = k, I = Un(h);
    for (; I && o && m !== h; ) {
      const b = At(I), w = I.getBoundingClientRect(), S = Xe(I), A = w.left + (I.clientLeft + parseFloat(S.paddingLeft)) * b.x, g = w.top + (I.clientTop + parseFloat(S.paddingTop)) * b.y;
      d *= b.x, r *= b.y, f *= b.x, y *= b.y, d += A, r += g, h = Ve(I), I = Un(h);
    }
  }
  return fn({
    width: f,
    height: y,
    x: d,
    y: r
  });
}
function bn(e, t) {
  const n = gn(e).scrollLeft;
  return t ? t.left + n : yt(Ke(e)).left + n;
}
function Bi(e, t) {
  const n = e.getBoundingClientRect(), o = n.left + t.scrollLeft - bn(e, n), i = n.top + t.scrollTop;
  return {
    x: o,
    y: i
  };
}
function Is(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: o,
    strategy: i
  } = e;
  const l = i === "fixed", s = Ke(o), a = t ? hn(t.floating) : !1;
  if (o === s || a && l)
    return n;
  let d = {
    scrollLeft: 0,
    scrollTop: 0
  }, r = Ze(1);
  const f = Ze(0), y = Ye(o);
  if ((y || !y && !l) && ((wt(o) !== "body" || Gt(s)) && (d = gn(o)), Ye(o))) {
    const m = yt(o);
    r = At(o), f.x = m.x + o.clientLeft, f.y = m.y + o.clientTop;
  }
  const k = s && !y && !l ? Bi(s, d) : Ze(0);
  return {
    width: n.width * r.x,
    height: n.height * r.y,
    x: n.x * r.x - d.scrollLeft * r.x + f.x + k.x,
    y: n.y * r.y - d.scrollTop * r.y + f.y + k.y
  };
}
function Ts(e) {
  return Array.from(e.getClientRects());
}
function Ss(e) {
  const t = Ke(e), n = gn(e), o = e.ownerDocument.body, i = bt(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), l = bt(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let s = -n.scrollLeft + bn(e);
  const a = -n.scrollTop;
  return Xe(o).direction === "rtl" && (s += bt(t.clientWidth, o.clientWidth) - i), {
    width: i,
    height: l,
    x: s,
    y: a
  };
}
const Go = 25;
function Ps(e, t) {
  const n = Ve(e), o = Ke(e), i = n.visualViewport;
  let l = o.clientWidth, s = o.clientHeight, a = 0, d = 0;
  if (i) {
    l = i.width, s = i.height;
    const f = uo();
    (!f || f && t === "fixed") && (a = i.offsetLeft, d = i.offsetTop);
  }
  const r = bn(o);
  if (r <= 0) {
    const f = o.ownerDocument, y = f.body, k = getComputedStyle(y), m = f.compatMode === "CSS1Compat" && parseFloat(k.marginLeft) + parseFloat(k.marginRight) || 0, h = Math.abs(o.clientWidth - y.clientWidth - m);
    h <= Go && (l -= h);
  } else r <= Go && (l += r);
  return {
    width: l,
    height: s,
    x: a,
    y: d
  };
}
const As = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Es(e, t) {
  const n = yt(e, !0, t === "fixed"), o = n.top + e.clientTop, i = n.left + e.clientLeft, l = Ye(e) ? At(e) : Ze(1), s = e.clientWidth * l.x, a = e.clientHeight * l.y, d = i * l.x, r = o * l.y;
  return {
    width: s,
    height: a,
    x: d,
    y: r
  };
}
function Wo(e, t, n) {
  let o;
  if (t === "viewport")
    o = Ps(e, n);
  else if (t === "document")
    o = Ss(Ke(e));
  else if (We(t))
    o = Es(t, n);
  else {
    const i = Li(e);
    o = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return fn(o);
}
function Ni(e, t) {
  const n = ft(e);
  return n === t || !We(n) || Rt(n) ? !1 : Xe(n).position === "fixed" || Ni(n, t);
}
function Os(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let o = Ft(e, [], !1).filter((a) => We(a) && wt(a) !== "body"), i = null;
  const l = Xe(e).position === "fixed";
  let s = l ? ft(e) : e;
  for (; We(s) && !Rt(s); ) {
    const a = Xe(s), d = ao(s);
    !d && a.position === "fixed" && (i = null), (l ? !d && !i : !d && a.position === "static" && !!i && As.has(i.position) || Gt(s) && !d && Ni(e, s)) ? o = o.filter((f) => f !== s) : i = a, s = ft(s);
  }
  return t.set(e, o), o;
}
function Ms(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: o,
    strategy: i
  } = e;
  const s = [...n === "clippingAncestors" ? hn(t) ? [] : Os(t, this._c) : [].concat(n), o], a = s[0], d = s.reduce((r, f) => {
    const y = Wo(t, f, i);
    return r.top = bt(y.top, r.top), r.right = Mt(y.right, r.right), r.bottom = Mt(y.bottom, r.bottom), r.left = bt(y.left, r.left), r;
  }, Wo(t, a, i));
  return {
    width: d.right - d.left,
    height: d.bottom - d.top,
    x: d.left,
    y: d.top
  };
}
function Rs(e) {
  const {
    width: t,
    height: n
  } = Di(e);
  return {
    width: t,
    height: n
  };
}
function Ds(e, t, n) {
  const o = Ye(t), i = Ke(t), l = n === "fixed", s = yt(e, !0, l, t);
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const d = Ze(0);
  function r() {
    d.x = bn(i);
  }
  if (o || !o && !l)
    if ((wt(t) !== "body" || Gt(i)) && (a = gn(t)), o) {
      const m = yt(t, !0, l, t);
      d.x = m.x + t.clientLeft, d.y = m.y + t.clientTop;
    } else i && r();
  l && !o && i && r();
  const f = i && !o && !l ? Bi(i, a) : Ze(0), y = s.left + a.scrollLeft - d.x - f.x, k = s.top + a.scrollTop - d.y - f.y;
  return {
    x: y,
    y: k,
    width: s.width,
    height: s.height
  };
}
function Sn(e) {
  return Xe(e).position === "static";
}
function Xo(e, t) {
  if (!Ye(e) || Xe(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return Ke(e) === n && (n = n.ownerDocument.body), n;
}
function zi(e, t) {
  const n = Ve(e);
  if (hn(e))
    return n;
  if (!Ye(e)) {
    let i = ft(e);
    for (; i && !Rt(i); ) {
      if (We(i) && !Sn(i))
        return i;
      i = ft(i);
    }
    return n;
  }
  let o = Xo(e, t);
  for (; o && hs(o) && Sn(o); )
    o = Xo(o, t);
  return o && Rt(o) && Sn(o) && !ao(o) ? n : o || ws(e) || n;
}
const Ls = async function(e) {
  const t = this.getOffsetParent || zi, n = this.getDimensions, o = await n(e.floating);
  return {
    reference: Ds(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Bs(e) {
  return Xe(e).direction === "rtl";
}
const Ns = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Is,
  getDocumentElement: Ke,
  getClippingRect: Ms,
  getOffsetParent: zi,
  getElementRects: Ls,
  getClientRects: Ts,
  getDimensions: Rs,
  getScale: At,
  isElement: We,
  isRTL: Bs
};
function _i(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function zs(e, t) {
  let n = null, o;
  const i = Ke(e);
  function l() {
    var a;
    clearTimeout(o), (a = n) == null || a.disconnect(), n = null;
  }
  function s(a, d) {
    a === void 0 && (a = !1), d === void 0 && (d = 1), l();
    const r = e.getBoundingClientRect(), {
      left: f,
      top: y,
      width: k,
      height: m
    } = r;
    if (a || t(), !k || !m)
      return;
    const h = Kt(y), I = Kt(i.clientWidth - (f + k)), b = Kt(i.clientHeight - (y + m)), w = Kt(f), A = {
      rootMargin: -h + "px " + -I + "px " + -b + "px " + -w + "px",
      threshold: bt(0, Mt(1, d)) || 1
    };
    let g = !0;
    function x(T) {
      const _ = T[0].intersectionRatio;
      if (_ !== d) {
        if (!g)
          return s();
        _ ? s(!1, _) : o = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      _ === 1 && !_i(r, e.getBoundingClientRect()) && s(), g = !1;
    }
    try {
      n = new IntersectionObserver(x, {
        ...A,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(x, A);
    }
    n.observe(e);
  }
  return s(!0), l;
}
function _s(e, t, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: l = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: a = typeof IntersectionObserver == "function",
    animationFrame: d = !1
  } = o, r = co(e), f = i || l ? [...r ? Ft(r) : [], ...Ft(t)] : [];
  f.forEach((w) => {
    i && w.addEventListener("scroll", n, {
      passive: !0
    }), l && w.addEventListener("resize", n);
  });
  const y = r && a ? zs(r, n) : null;
  let k = -1, m = null;
  s && (m = new ResizeObserver((w) => {
    let [S] = w;
    S && S.target === r && m && (m.unobserve(t), cancelAnimationFrame(k), k = requestAnimationFrame(() => {
      var A;
      (A = m) == null || A.observe(t);
    })), n();
  }), r && !d && m.observe(r), m.observe(t));
  let h, I = d ? yt(e) : null;
  d && b();
  function b() {
    const w = yt(e);
    I && !_i(I, w) && n(), I = w, h = requestAnimationFrame(b);
  }
  return n(), () => {
    var w;
    f.forEach((S) => {
      i && S.removeEventListener("scroll", n), l && S.removeEventListener("resize", n);
    }), y?.(), (w = m) == null || w.disconnect(), m = null, d && cancelAnimationFrame(h);
  };
}
const Vs = cs, Fs = fs, js = us, Hs = as, Us = ps, Gs = (e, t, n) => {
  const o = /* @__PURE__ */ new Map(), i = {
    platform: Ns,
    ...n
  }, l = {
    ...i.platform,
    _c: o
  };
  return ss(e, t, {
    ...i,
    platform: l
  });
};
function Ws(e) {
  return e != null && typeof e == "object" && "$el" in e;
}
function Gn(e) {
  if (Ws(e)) {
    const t = e.$el;
    return so(t) && wt(t) === "#comment" ? null : t;
  }
  return e;
}
function St(e) {
  return typeof e == "function" ? e() : p(e);
}
function Xs(e) {
  return {
    name: "arrow",
    options: e,
    fn(t) {
      const n = Gn(St(e.element));
      return n == null ? {} : Hs({
        element: n,
        padding: e.padding
      }).fn(t);
    }
  };
}
function Vi(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function qo(e, t) {
  const n = Vi(e);
  return Math.round(t * n) / n;
}
function qs(e, t, n) {
  n === void 0 && (n = {});
  const o = n.whileElementsMounted, i = V(() => {
    var _;
    return (_ = St(n.open)) != null ? _ : !0;
  }), l = V(() => St(n.middleware)), s = V(() => {
    var _;
    return (_ = St(n.placement)) != null ? _ : "bottom";
  }), a = V(() => {
    var _;
    return (_ = St(n.strategy)) != null ? _ : "absolute";
  }), d = V(() => {
    var _;
    return (_ = St(n.transform)) != null ? _ : !0;
  }), r = V(() => Gn(e.value)), f = V(() => Gn(t.value)), y = B(0), k = B(0), m = B(a.value), h = B(s.value), I = ui({}), b = B(!1), w = V(() => {
    const _ = {
      position: m.value,
      left: "0",
      top: "0"
    };
    if (!f.value)
      return _;
    const W = qo(f.value, y.value), U = qo(f.value, k.value);
    return d.value ? {
      ..._,
      transform: "translate(" + W + "px, " + U + "px)",
      ...Vi(f.value) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: m.value,
      left: W + "px",
      top: U + "px"
    };
  });
  let S;
  function A() {
    if (r.value == null || f.value == null)
      return;
    const _ = i.value;
    Gs(r.value, f.value, {
      middleware: l.value,
      placement: s.value,
      strategy: a.value
    }).then((W) => {
      y.value = W.x, k.value = W.y, m.value = W.strategy, h.value = W.placement, I.value = W.middlewareData, b.value = _ !== !1;
    });
  }
  function g() {
    typeof S == "function" && (S(), S = void 0);
  }
  function x() {
    if (g(), o === void 0) {
      A();
      return;
    }
    if (r.value != null && f.value != null) {
      S = o(r.value, f.value, A);
      return;
    }
  }
  function T() {
    i.value || (b.value = !1);
  }
  return Te([l, s, a, i], A, {
    flush: "sync"
  }), Te([r, f], x, {
    flush: "sync"
  }), Te(i, T, {
    flush: "sync"
  }), tl() && nl(g), {
    x: Ct(y),
    y: Ct(k),
    strategy: Ct(m),
    placement: Ct(h),
    middlewareData: Ct(I),
    isPositioned: Ct(b),
    floatingStyles: w,
    update: A
  };
}
const xn = /* @__PURE__ */ ge({
  __name: "FloatingMenu",
  props: {
    referenceEl: {},
    placement: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = V(() => n.referenceEl), l = B(null), s = B(null), { floatingStyles: a, middlewareData: d, placement: r } = qs(i, l, {
      placement: n.placement || "bottom-start",
      middleware: [
        Vs(12),
        js(),
        Fs({ padding: 8, limiter: Us() }),
        Xs({ element: s })
      ],
      whileElementsMounted: _s
    }), f = V(() => {
      const h = r.value.split("-")[0];
      return {
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left"
      }[h] || "top";
    }), y = V(() => {
      const h = r.value.split("-")[0];
      return {
        top: "rotate(225deg)",
        bottom: "rotate(45deg)",
        left: "rotate(315deg)",
        right: "rotate(135deg)"
      }[h] || "rotate(45deg)";
    }), k = V(() => {
      const h = r.value.split("-")[0];
      return {
        top: "border-b border-r",
        bottom: "border-t border-l",
        left: "border-t border-r",
        right: "border-b border-l"
      }[h] || "border-t border-l";
    });
    Zr(l, (h) => {
      if (n.referenceEl && (h.target === n.referenceEl || n.referenceEl.contains(h.target)))
        return;
      const b = h.target.closest(".z-101");
      b && b !== l.value && !(n.referenceEl && b.contains(n.referenceEl)) || o("close");
    });
    function m(h) {
      h.key === "Escape" && o("close");
    }
    return rt(() => {
      document.addEventListener("keydown", m);
    }), jt(() => {
      document.removeEventListener("keydown", m);
    }), (h, I) => (v(), Ce(Yn, { to: "body" }, [
      u("div", {
        ref_key: "floating",
        ref: l,
        style: ne(p(a)),
        class: "z-101 bg-white rounded-xl shadow-lg border border-slate-200"
      }, [
        at(h.$slots, "default"),
        u("div", {
          ref_key: "floatingArrow",
          ref: s,
          style: ne({
            position: "absolute",
            left: p(d).arrow?.x != null ? `${p(d).arrow.x}px` : "",
            top: p(d).arrow?.y != null ? `${p(d).arrow.y}px` : "",
            [f.value]: "-4px",
            transform: y.value
          }),
          class: Z(["w-2 h-2 bg-white border-slate-200", k.value])
        }, null, 6)
      ], 4)
    ]));
  }
}), Zs = { class: "flex items-center gap-1.5" }, kt = /* @__PURE__ */ ge({
  __name: "ReportedSwitch",
  props: {
    open: { type: Boolean }
  },
  emits: ["toggle"],
  setup(e, { emit: t }) {
    const n = t;
    return (o, i) => (v(), C("div", Zs, [
      u("span", {
        class: Z(["text-[10px] font-medium transition-colors whitespace-nowrap", e.open ? "text-slate-400" : "text-sky-600 font-semibold"])
      }, " Not reported ", 2),
      u("button", {
        type: "button",
        class: Z(["w-8 h-4 rounded-full relative transition-colors focus:outline-none shrink-0", e.open ? "bg-sky-500" : "bg-slate-300"]),
        onClick: i[0] || (i[0] = (l) => n("toggle"))
      }, [
        u("span", {
          class: Z(["absolute top-0.5 w-3 h-3 rounded-full bg-white shadow-sm transition-all", e.open ? "left-4.5" : "left-0.5"])
        }, null, 2)
      ], 2),
      u("span", {
        class: Z(["text-[10px] font-medium transition-colors whitespace-nowrap", e.open ? "text-sky-600 font-semibold" : "text-slate-400"])
      }, " Reported ", 2)
    ]));
  }
}), Ys = {}, Ks = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};
function Qs(e, t) {
  return v(), C("svg", Ks, [...t[0] || (t[0] = [
    u("path", { d: "M9 18l6-6-6-6" }, null, -1)
  ])]);
}
const Js = /* @__PURE__ */ Me(Ys, [["render", Qs]]), ea = { class: "w-100 max-h-[80vh] overflow-y-auto flex flex-col text-sm" }, ta = { class: "px-4 py-3 border-b border-slate-100" }, na = { class: "flex items-center justify-between mb-2" }, oa = {
  key: 0,
  class: "flex flex-col gap-0.5"
}, ia = ["onClick"], la = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-sky-500"
}, ra = { class: "text-xs text-slate-700" }, sa = { class: "px-4 py-2 border-b border-slate-100" }, aa = { class: "px-4 py-3 border-b border-slate-100" }, ua = { class: "flex items-center justify-between mb-2" }, da = {
  key: 0,
  class: "flex items-end gap-1 flex-wrap"
}, ca = {
  key: 0,
  class: "text-slate-400 font-bold text-sm pb-3.5 px-0.5"
}, fa = { class: "flex flex-col items-center gap-0.5" }, pa = ["value", "onInput"], va = ["title"], ma = { class: "px-4 py-3 border-b border-slate-100" }, ha = { class: "flex items-center justify-between mb-2" }, ga = {
  key: 0,
  class: "flex flex-col gap-0.5"
}, ba = ["onClick"], xa = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-sky-500"
}, ya = { class: "text-xs text-slate-700" }, wa = {
  key: 0,
  class: "ml-8 mt-1 p-2.5 bg-slate-50 rounded-lg border border-slate-100"
}, Ca = {
  key: 1,
  class: "ml-8 mt-1 p-2.5 bg-slate-50 rounded-lg border border-slate-100 space-y-2"
}, ka = { class: "flex flex-wrap gap-1 mb-1.5" }, $a = ["onClick"], Ia = { class: "flex gap-1.5" }, Ta = ["onKeydown"], Sa = { class: "px-4 py-3 border-b border-slate-100" }, Pa = { class: "flex items-center justify-between mb-2" }, Aa = {
  key: 0,
  class: "flex flex-col gap-0.5"
}, Ea = ["onClick"], Oa = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-sky-500"
}, Ma = { class: "text-xs text-slate-700" }, Ra = { class: "px-4 py-3 border-b border-slate-100" }, Da = { class: "flex items-center justify-between mb-2" }, La = {
  key: 0,
  class: "flex flex-col gap-0.5"
}, Ba = ["onClick"], Na = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-sky-500"
}, za = { class: "text-xs text-slate-700" }, _a = { class: "px-4 py-3 border-b border-slate-100" }, Va = { class: "flex gap-1.5 mb-2" }, Fa = {
  key: 0,
  class: "ml-1"
}, ja = { class: "flex items-center justify-between mb-1.5" }, Ha = {
  key: 0,
  class: "flex flex-col gap-0.5"
}, Ua = ["onClick"], Ga = {
  key: 0,
  class: "w-2 h-2 rounded-full bg-sky-500"
}, Wa = { class: "text-xs text-slate-700" }, Xa = {
  key: 0,
  class: "ml-8 mt-1"
}, qa = { class: "px-4 py-3 flex items-center justify-end gap-2" }, Fi = /* @__PURE__ */ ge({
  __name: "RandomizationMenu",
  props: {
    referenceEl: {},
    modelValue: {},
    groupLabels: {}
  },
  emits: ["update:modelValue", "close"],
  setup(e, { emit: t }) {
    const n = [
      { value: "randomized", label: "Randomized" },
      { value: "pseudo", label: "Pseudo-randomized" },
      { value: "non-randomized", label: "Non-randomized" }
    ], o = [
      { value: "simple", label: "Simple randomization" },
      { value: "block", label: "Block randomization" },
      { value: "stratified", label: "Stratified randomization" },
      { value: "minimization", label: "Minimization" },
      { value: "adaptive", label: "Adaptive randomization" },
      { value: "cluster", label: "Cluster randomization" }
    ], i = [
      { value: "computer", label: "Computer-generated random sequence" },
      { value: "table", label: "Random number table" },
      { value: "physical", label: "Coin toss / dice / physical randomization" }
    ], l = [
      { value: "statistician", label: "Statistician (independent)" },
      { value: "investigator", label: "Investigator / study team" },
      { value: "sponsor", label: "Sponsor / CRO" },
      { value: "other", label: "Other" }
    ], s = [
      { value: "irt", label: "Centralized randomization systems (IRT/IWRS/IVRS)" },
      { value: "envelope", label: "Sealed opaque envelope" },
      { value: "other", label: "Other" }
    ], a = e, d = t, r = Ln({ ...eo(), ...a.modelValue });
    r.allocationRatios.length !== a.groupLabels.length && (r.allocationRatios = a.groupLabels.map((L, N) => r.allocationRatios[N] ?? ""));
    const f = B(r.status !== null), y = B(!1), k = B(r.allocationRatios.some((L) => L !== "")), m = B(r.scheme !== null), h = B(r.seqMethod !== null), I = B(r.seqResp !== null), b = B(r.concealMethod !== null), w = B(""), S = B(null);
    function A() {
      f.value = !f.value, f.value || (r.status = null);
    }
    function g() {
      k.value = !k.value, k.value ? r.allocationRatios = a.groupLabels.map((L, N) => r.allocationRatios[N] || "1") : r.allocationRatios = a.groupLabels.map(() => "");
    }
    function x() {
      m.value = !m.value, m.value || (r.scheme = null, r.blockSize = "", r.stratFactors = [], r.numStrata = "");
    }
    function T() {
      h.value = !h.value, h.value || (r.seqMethod = null);
    }
    function _() {
      I.value = !I.value, I.value || (r.seqResp = null);
    }
    function W() {
      b.value = !b.value, b.value || (r.concealMethod = null, r.concealOtherSpec = "");
    }
    function U(L) {
      r.concealment = r.concealment === L ? null : L, r.concealment !== !0 && (b.value = !1, r.concealMethod = null, r.concealOtherSpec = "");
    }
    function z(L, N) {
      r.allocationRatios[L] = N.replace(/[^0-9]/g, "");
    }
    function M() {
      const L = w.value.trim();
      L && !r.stratFactors.includes(L) && (r.stratFactors.push(L), w.value = "");
    }
    function R(L) {
      r.stratFactors.splice(L, 1);
    }
    function F() {
      d("update:modelValue", { ...r, stratFactors: [...r.stratFactors] }), d("close");
    }
    return (L, N) => e.referenceEl ? (v(), Ce(xn, {
      key: 0,
      "reference-el": e.referenceEl,
      placement: "bottom",
      onClose: N[8] || (N[8] = (D) => d("close"))
    }, {
      default: Pe(() => [
        u("div", ea, [
          N[20] || (N[20] = u("div", { class: "px-4 py-3 border-b border-slate-100 flex items-center" }, [
            u("span", { class: "font-semibold text-slate-800 text-sm" }, "Randomization")
          ], -1)),
          u("div", ta, [
            u("div", na, [
              N[9] || (N[9] = u("span", { class: "text-[10px] font-semibold uppercase tracking-wide text-slate-400" }, " Randomization status ", -1)),
              K(kt, {
                open: f.value,
                onToggle: A
              }, null, 8, ["open"])
            ]),
            f.value ? (v(), C("div", oa, [
              (v(), C(se, null, pe(n, (D) => u("label", {
                key: D.value,
                class: Z(["flex items-center gap-2 px-2 py-1.5 rounded-lg cursor-pointer transition-colors", r.status === D.value ? "bg-sky-50" : "hover:bg-slate-50"]),
                onClick: (X) => r.status = D.value
              }, [
                u("span", {
                  class: Z(["w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors", r.status === D.value ? "border-sky-500" : "border-slate-300"])
                }, [
                  r.status === D.value ? (v(), C("span", la)) : H("", !0)
                ], 2),
                u("span", ra, ae(D.label), 1)
              ], 10, ia)), 64))
            ])) : H("", !0)
          ]),
          r.status === "randomized" ? (v(), C(se, { key: 0 }, [
            u("div", sa, [
              u("button", {
                type: "button",
                class: "flex items-center gap-1.5 w-full py-1 group",
                onClick: N[0] || (N[0] = (D) => y.value = !y.value)
              }, [
                K(Js, {
                  class: Z(["text-slate-400 transition-transform", y.value ? "rotate-90" : ""])
                }, null, 8, ["class"]),
                N[10] || (N[10] = u("span", { class: "text-[10px] font-semibold uppercase tracking-wide text-slate-400 group-hover:text-sky-600 transition-colors" }, " Advanced randomization details ", -1))
              ])
            ]),
            y.value ? (v(), C(se, { key: 0 }, [
              u("div", aa, [
                u("div", ua, [
                  N[11] || (N[11] = u("span", { class: "text-xs font-medium text-slate-600" }, "Allocation ratio", -1)),
                  K(kt, {
                    open: k.value,
                    onToggle: g
                  }, null, 8, ["open"])
                ]),
                k.value ? (v(), C("div", da, [
                  (v(!0), C(se, null, pe(e.groupLabels, (D, X) => (v(), C(se, { key: X }, [
                    X > 0 ? (v(), C("span", ca, ":")) : H("", !0),
                    u("div", fa, [
                      u("input", {
                        value: r.allocationRatios[X] ?? "",
                        type: "text",
                        inputmode: "numeric",
                        placeholder: "1",
                        class: "w-10 h-8 rounded-lg border border-slate-200 bg-slate-50/50 text-sm font-semibold text-center focus:bg-white focus:ring-2 focus:ring-slate-200 focus:outline-none",
                        onInput: (G) => z(X, G.target.value)
                      }, null, 40, pa),
                      u("span", {
                        class: "text-[9px] text-slate-400 max-w-10 truncate text-center",
                        title: D
                      }, ae(D), 9, va)
                    ])
                  ], 64))), 128))
                ])) : H("", !0)
              ]),
              u("div", ma, [
                u("div", ha, [
                  N[12] || (N[12] = u("span", { class: "text-xs font-medium text-slate-600" }, "Allocation scheme", -1)),
                  K(kt, {
                    open: m.value,
                    onToggle: x
                  }, null, 8, ["open"])
                ]),
                m.value ? (v(), C("div", ga, [
                  (v(), C(se, null, pe(o, (D) => u("label", {
                    key: D.value,
                    class: Z(["flex items-center gap-2 px-2 py-1.5 rounded-lg cursor-pointer transition-colors", r.scheme === D.value ? "bg-sky-50" : "hover:bg-slate-50"]),
                    onClick: (X) => r.scheme = D.value
                  }, [
                    u("span", {
                      class: Z(["w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors", r.scheme === D.value ? "border-sky-500" : "border-slate-300"])
                    }, [
                      r.scheme === D.value ? (v(), C("span", xa)) : H("", !0)
                    ], 2),
                    u("span", ya, ae(D.label), 1)
                  ], 10, ba)), 64)),
                  r.scheme === "block" ? (v(), C("div", wa, [
                    N[13] || (N[13] = u("label", { class: "text-[10px] font-medium text-slate-500 block mb-1" }, "Block size", -1)),
                    Le(u("input", {
                      "onUpdate:modelValue": N[1] || (N[1] = (D) => r.blockSize = D),
                      type: "text",
                      placeholder: "e.g. 4, 6, 8",
                      class: "w-full h-8 rounded-lg border border-slate-200 bg-white px-2.5 text-xs focus:ring-2 focus:ring-slate-200 focus:outline-none"
                    }, null, 512), [
                      [_e, r.blockSize]
                    ])
                  ])) : H("", !0),
                  r.scheme === "stratified" ? (v(), C("div", Ca, [
                    u("div", null, [
                      N[14] || (N[14] = u("label", { class: "text-[10px] font-medium text-slate-500 block mb-1" }, "Stratification factors", -1)),
                      u("div", ka, [
                        (v(!0), C(se, null, pe(r.stratFactors, (D, X) => (v(), C("span", {
                          key: X,
                          class: "inline-flex items-center gap-1 px-2 py-0.5 rounded bg-sky-50 border border-sky-200 text-sky-700 text-[10px]"
                        }, [
                          an(ae(D) + " ", 1),
                          u("button", {
                            type: "button",
                            class: "text-sky-400 hover:text-red-500 transition-colors",
                            onClick: (G) => R(X)
                          }, [
                            K(dt, { class: "size-3" })
                          ], 8, $a)
                        ]))), 128))
                      ]),
                      u("div", Ia, [
                        Le(u("input", {
                          ref_key: "newFactorInput",
                          ref: S,
                          "onUpdate:modelValue": N[2] || (N[2] = (D) => w.value = D),
                          type: "text",
                          placeholder: "e.g. Age, Site, Severity",
                          class: "flex-1 h-7 rounded-lg border border-slate-200 bg-white px-2 text-xs focus:ring-2 focus:ring-slate-200 focus:outline-none",
                          onKeydown: Et(he(M, ["prevent"]), ["enter"])
                        }, null, 40, Ta), [
                          [_e, w.value]
                        ]),
                        u("button", {
                          type: "button",
                          class: "px-2 py-1 rounded-lg border border-slate-200 bg-white text-xs font-medium text-sky-600 hover:bg-sky-50 hover:border-sky-300 transition-all",
                          onClick: M
                        }, " + Factor ")
                      ])
                    ]),
                    u("div", null, [
                      N[15] || (N[15] = u("label", { class: "text-[10px] font-medium text-slate-500 block mb-1" }, "Number of strata", -1)),
                      Le(u("input", {
                        "onUpdate:modelValue": N[3] || (N[3] = (D) => r.numStrata = D),
                        type: "text",
                        placeholder: "If reported",
                        class: "w-full h-7 rounded-lg border border-slate-200 bg-white px-2 text-xs focus:ring-2 focus:ring-slate-200 focus:outline-none"
                      }, null, 512), [
                        [_e, r.numStrata]
                      ])
                    ])
                  ])) : H("", !0)
                ])) : H("", !0)
              ]),
              u("div", Sa, [
                u("div", Pa, [
                  N[16] || (N[16] = u("span", { class: "text-xs font-medium text-slate-600" }, "Sequence generation method", -1)),
                  K(kt, {
                    open: h.value,
                    onToggle: T
                  }, null, 8, ["open"])
                ]),
                h.value ? (v(), C("div", Aa, [
                  (v(), C(se, null, pe(i, (D) => u("label", {
                    key: D.value,
                    class: Z(["flex items-center gap-2 px-2 py-1.5 rounded-lg cursor-pointer transition-colors", r.seqMethod === D.value ? "bg-sky-50" : "hover:bg-slate-50"]),
                    onClick: (X) => r.seqMethod = D.value
                  }, [
                    u("span", {
                      class: Z(["w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors", r.seqMethod === D.value ? "border-sky-500" : "border-slate-300"])
                    }, [
                      r.seqMethod === D.value ? (v(), C("span", Oa)) : H("", !0)
                    ], 2),
                    u("span", Ma, ae(D.label), 1)
                  ], 10, Ea)), 64))
                ])) : H("", !0)
              ]),
              u("div", Ra, [
                u("div", Da, [
                  N[17] || (N[17] = u("span", { class: "text-xs font-medium text-slate-600" }, "Generation responsibility", -1)),
                  K(kt, {
                    open: I.value,
                    onToggle: _
                  }, null, 8, ["open"])
                ]),
                I.value ? (v(), C("div", La, [
                  (v(), C(se, null, pe(l, (D) => u("label", {
                    key: D.value,
                    class: Z(["flex items-center gap-2 px-2 py-1.5 rounded-lg cursor-pointer transition-colors", r.seqResp === D.value ? "bg-sky-50" : "hover:bg-slate-50"]),
                    onClick: (X) => r.seqResp = D.value
                  }, [
                    u("span", {
                      class: Z(["w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors", r.seqResp === D.value ? "border-sky-500" : "border-slate-300"])
                    }, [
                      r.seqResp === D.value ? (v(), C("span", Na)) : H("", !0)
                    ], 2),
                    u("span", za, ae(D.label), 1)
                  ], 10, Ba)), 64))
                ])) : H("", !0)
              ]),
              u("div", _a, [
                N[19] || (N[19] = u("div", { class: "flex items-center gap-1.5 mb-2" }, [
                  u("span", { class: "text-xs font-medium text-slate-600" }, "Allocation concealment")
                ], -1)),
                u("div", Va, [
                  u("button", {
                    type: "button",
                    class: Z([
                      "px-3.5 py-1 rounded-md border text-xs transition-all",
                      r.concealment === !0 ? "bg-sky-50 border-sky-500 text-sky-600 font-semibold" : "bg-white border-slate-200 text-slate-500 hover:border-sky-300"
                    ]),
                    onClick: N[4] || (N[4] = (D) => U(!0))
                  }, " Yes ", 2),
                  u("button", {
                    type: "button",
                    class: Z([
                      "px-3.5 py-1 rounded-md border text-xs transition-all",
                      r.concealment === !1 ? "bg-red-50 border-red-400 text-red-600 font-semibold" : "bg-white border-slate-200 text-slate-500 hover:border-red-300"
                    ]),
                    onClick: N[5] || (N[5] = (D) => U(!1))
                  }, " No ", 2)
                ]),
                r.concealment === !0 ? (v(), C("div", Fa, [
                  u("div", ja, [
                    N[18] || (N[18] = u("span", { class: "text-xs font-medium text-slate-500" }, "Method of concealment", -1)),
                    K(kt, {
                      open: b.value,
                      onToggle: W
                    }, null, 8, ["open"])
                  ]),
                  b.value ? (v(), C("div", Ha, [
                    (v(), C(se, null, pe(s, (D) => u("label", {
                      key: D.value,
                      class: Z(["flex items-center gap-2 px-2 py-1.5 rounded-lg cursor-pointer transition-colors", r.concealMethod === D.value ? "bg-sky-50" : "hover:bg-slate-50"]),
                      onClick: (X) => r.concealMethod = D.value
                    }, [
                      u("span", {
                        class: Z([
                          "w-4 h-4 rounded-full border-2 flex items-center justify-center shrink-0 transition-colors",
                          r.concealMethod === D.value ? "border-sky-500" : "border-slate-300"
                        ])
                      }, [
                        r.concealMethod === D.value ? (v(), C("span", Ga)) : H("", !0)
                      ], 2),
                      u("span", Wa, ae(D.label), 1)
                    ], 10, Ua)), 64)),
                    r.concealMethod === "other" ? (v(), C("div", Xa, [
                      Le(u("input", {
                        "onUpdate:modelValue": N[6] || (N[6] = (D) => r.concealOtherSpec = D),
                        type: "text",
                        placeholder: "Specify method…",
                        class: "w-full h-8 rounded-lg border border-slate-200 bg-slate-50/50 px-2.5 text-xs focus:ring-2 focus:ring-slate-200 focus:outline-none"
                      }, null, 512), [
                        [_e, r.concealOtherSpec]
                      ])
                    ])) : H("", !0)
                  ])) : H("", !0)
                ])) : H("", !0)
              ])
            ], 64)) : H("", !0)
          ], 64)) : H("", !0),
          u("div", qa, [
            u("button", {
              type: "button",
              class: "px-3 py-1.5 text-sm font-medium rounded-lg text-slate-500 hover:bg-slate-50 transition-all",
              onClick: N[7] || (N[7] = (D) => d("close"))
            }, " Cancel "),
            u("button", {
              type: "button",
              class: "px-3 py-1.5 text-sm font-medium rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm transition-all",
              onClick: F
            }, " Save ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["reference-el"])) : H("", !0);
  }
}), Za = ["width", "height"], Ya = ["d"], Ka = /* @__PURE__ */ ge({
  __name: "SplittingArrow",
  props: {
    populationIconRef: {},
    armsContainerRef: {},
    armCount: {},
    color: {},
    populationId: {},
    randomization: {},
    armLabels: {},
    showAddArm: { type: Boolean }
  },
  emits: ["update:randomization", "addArm"],
  setup(e, { expose: t, emit: n }) {
    const o = e, i = n, { mode: l, scale: s } = pt(), a = B(!1), d = B(null), r = V(() => d.value), f = V(() => Ii(o.randomization)), y = B(null), k = B({ width: 0, height: 0 }), m = B(0), h = B([]), I = B(0), b = B(0), w = V(() => k.value.width), S = V(() => k.value.height), A = V(
      () => ({
        marginTop: "0px",
        flexShrink: 0,
        position: "absolute",
        left: `${I.value}px`,
        top: `${b.value}px`,
        pointerEvents: "none",
        zIndex: 1
      })
    ), g = V(() => {
      if (w.value <= 0) return { x: 0, y: 0 };
      const R = 0, F = m.value, L = Math.min(220, w.value * 0.85);
      return { x: R + L, y: F };
    }), x = V(() => {
      if (w.value <= 0) return { x: 0, y: 0 };
      const R = 0, F = m.value;
      return { x: R + Math.min(70, w.value * 0.3), y: F };
    }), T = V(() => o.armCount > 1 && k.value.width > 0), _ = V(() => ({
      position: "absolute",
      left: `${x.value.x - 16}px`,
      top: `${x.value.y}px`,
      transform: "translateY(-50%)"
    })), W = V(() => ({
      position: "absolute",
      left: `${g.value.x}px`,
      top: `${g.value.y}px`,
      transform: "translate(-50%, -50%)",
      width: "48px",
      height: "48px"
    })), U = V(() => {
      if (h.value.length === 0 || w.value <= 0) return [];
      const R = 0, F = w.value, L = m.value, N = 12;
      if (o.armCount === 1 && h.value.length === 1) {
        const G = h.value[0];
        return [`M ${R} ${L} L ${F} ${G}`];
      }
      const { x: D, y: X } = g.value;
      return h.value.map((G) => {
        const Q = G > X ? 1 : -1, ce = D - N, be = X, ye = G - N * Q, ve = D;
        return `M ${R} ${L} L ${ce} ${be} Q ${D} ${X} ${D} ${X + N * Q} L ${ve} ${ye} Q ${D} ${G} ${D + N} ${G} L ${F} ${G}`;
      });
    });
    function z() {
      if (!o.populationIconRef || !o.armsContainerRef || !y.value) return;
      const R = y.value.parentElement;
      if (!R) return;
      const F = s.value, L = o.populationIconRef.getBoundingClientRect(), N = R.getBoundingClientRect(), D = o.armsContainerRef.querySelectorAll(":scope > div"), X = [];
      if (D.forEach((le) => {
        const ue = le.querySelector("button");
        if (ue) {
          const ke = ue.getBoundingClientRect();
          X.push({ y: ke.top + ke.height / 2, left: ke.left });
        } else {
          const ke = le.getBoundingClientRect();
          X.push({ y: ke.top + ke.height / 2, left: ke.left });
        }
      }), X.length === 0 && o.armCount > 0) {
        const le = o.armsContainerRef.getBoundingClientRect();
        X.push({ y: le.top + le.height / 2, left: le.left });
      }
      if (X.length === 0) {
        k.value = { width: 0, height: 0 };
        return;
      }
      const G = L.top + L.height / 2, q = Math.min(...X.map((le) => le.left)), Q = L.right, ce = q, ye = 20 * F, ve = Math.max(ce - Q, 20 * F), xe = [G, ...X.map((le) => le.y)], Ae = Math.min(...xe), Ie = Math.max(...xe) - Ae + ye * 2;
      k.value = {
        width: ve / F,
        height: Ie / F
      }, I.value = (Q - N.left) / F, b.value = (Ae - ye - N.top) / F, m.value = (G - (Ae - ye)) / F, h.value = X.map((le) => (le.y - (Ae - ye)) / F);
    }
    let M = null;
    return rt(() => {
      Ge(() => {
        z();
      }), M = new ResizeObserver(() => {
        z();
      }), window.addEventListener("resize", z);
    }), jt(() => {
      M?.disconnect(), window.removeEventListener("resize", z);
    }), Te(s, () => {
      z();
    }), Te(
      () => o.armsContainerRef,
      (R, F) => {
        F && M?.unobserve(F), R && M?.observe(R);
      }
    ), Te(
      () => [o.populationIconRef, o.armsContainerRef, o.armCount],
      () => {
        Ge(() => {
          z();
        });
      },
      { deep: !0 }
    ), t({ recalculate: z }), (R, F) => (v(), C("div", {
      ref_key: "rootRef",
      ref: y,
      class: "pointer-events-none overflow-visible",
      style: ne(A.value)
    }, [
      (v(), C("svg", {
        class: "overflow-visible block",
        width: w.value,
        height: S.value
      }, [
        (v(!0), C(se, null, pe(U.value, (L, N) => (v(), C("path", {
          key: N,
          d: L,
          fill: "none",
          stroke: "#475569",
          "stroke-width": "4",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, Ya))), 128))
      ], 8, Za)),
      e.showAddArm ? (v(), Ce(Ht, {
        key: 0,
        label: "Add Arm",
        title: "Add Arm",
        direction: "right",
        class: "pointer-events-auto absolute z-10",
        style: ne(_.value),
        onClick: F[0] || (F[0] = (L) => i("addArm"))
      }, {
        default: Pe(() => [
          K(Lr, { class: "size-3" })
        ]),
        _: 1
      }, 8, ["style"])) : H("", !0),
      T.value ? (v(), C("button", {
        key: 1,
        ref_key: "diceButtonRef",
        ref: d,
        class: Z(["pointer-events-auto absolute flex items-center justify-center rounded-full bg-white shadow-md border-2 border-slate-600 transition-colors z-10", [
          f.value ? "text-red-500" : "text-slate-600",
          p(l) === "edit" ? "hover:bg-slate-50 cursor-pointer" : "cursor-default"
        ]]),
        style: ne(W.value),
        onClick: F[1] || (F[1] = he((L) => p(l) === "edit" ? a.value = !a.value : void 0, ["stop"])),
        title: "Randomization"
      }, [
        K(Ai)
      ], 6)) : H("", !0),
      a.value && p(l) === "edit" ? (v(), Ce(Fi, {
        key: 2,
        "reference-el": r.value,
        "model-value": o.randomization ?? p(eo)(),
        "group-labels": e.armLabels ?? [],
        "onUpdate:modelValue": F[2] || (F[2] = (L) => {
          i("update:randomization", L), a.value = !1;
        }),
        onClose: F[3] || (F[3] = (L) => a.value = !1)
      }, null, 8, ["reference-el", "model-value", "group-labels"])) : H("", !0)
    ], 4));
  }
}), Qa = /* @__PURE__ */ ge({
  __name: "TimepointArrow",
  props: {
    gray: { type: Boolean, default: !1 },
    color: { default: "#94a3b8" }
  },
  setup(e) {
    const t = e, n = V(() => ({
      backgroundColor: t.gray ? "#cbd5e1" : t.color
    })), o = V(() => ({
      borderLeftColor: t.gray ? "#cbd5e1" : t.color
    }));
    return (i, l) => (v(), C("div", {
      class: "absolute right-full translate-x-1 w-30 h-4",
      style: ne(n.value)
    }, [
      u("div", {
        class: "absolute right-0 top-1/2 -translate-y-1/2 -translate-x-5 w-0 h-0 border-t-16 border-t-transparent border-b-16 border-b-transparent border-l-16",
        style: ne(o.value)
      }, null, 4)
    ], 4));
  }
}), Ja = {
  key: 1,
  class: "absolute top-full left-1/2 -translate-x-1/2 mt-1 flex items-center gap-1 h-8 z-20"
}, eu = "#94A3B8", tu = /* @__PURE__ */ ge({
  __name: "TimepointCircle",
  props: {
    hasExposure: { type: Boolean },
    showArrow: { type: Boolean },
    label: {},
    color: {},
    canDelete: { type: Boolean },
    canEditCount: { type: Boolean },
    hoverState: {},
    isBaseline: { type: Boolean },
    participantCount: {},
    isMerged: { type: Boolean },
    secondaryColor: {},
    isSelected: { type: Boolean },
    isSelectable: { type: Boolean },
    isHighlighted: { type: Boolean },
    isMiddle: { type: Boolean },
    someTimepointSelected: { type: Boolean },
    forceCrop: { type: Boolean }
  },
  emits: ["click", "clear-exposure", "update:participant-count", "edit-name", "mouseenter", "mouseleave"],
  setup(e, { emit: t }) {
    const n = B(!1), o = V(
      () => r.isMiddle && (r.forceCrop || !n.value && r.hoverState !== "direct" && r.hoverState !== "similar" && !r.isSelected && !r.isHighlighted && (r.isSelectable !== !0 || r.someTimepointSelected))
    ), i = B(!1), l = B(""), s = B(null);
    let a = !1, d;
    const r = e, f = V(() => {
      const x = [];
      return r.isBaseline && !r.isSelected && !r.isHighlighted ? (x.push("bg-slate-300"), r.hoverState === "direct" && r.isSelectable === void 0 ? x.push("scale-110 ring-2 ring-slate-400 ring-offset-1") : r.isSelectable && x.push("hover:ring-2 hover:ring-blue-300 hover:ring-offset-1"), r.isSelectable === !1 && x.push("opacity-30 cursor-not-allowed")) : r.hasExposure ? (r.isSelected ? x.push("scale-110 ring-2 ring-blue-600 ring-offset-2") : r.isHighlighted ? x.push("hover:ring-2 hover:ring-blue-300 hover:ring-offset-1") : r.hoverState === "direct" ? x.push("scale-110 ring-2 ring-slate-400 ring-offset-1") : r.hoverState === "faded" ? x.push("opacity-50 hover:scale-105") : r.someTimepointSelected ? x.push("opacity-50") : r.isSelectable && x.push("hover:ring-2 hover:ring-blue-300 hover:ring-offset-1"), r.isSelectable === !1 && !r.isSelected && !r.isHighlighted && x.push("opacity-30 cursor-not-allowed")) : x.push("bg-slate-300 hover:bg-slate-400 opacity-0 group-hover:opacity-100"), x;
    });
    function y(x) {
      x.stopPropagation(), d = r.participantCount, oe.user("Started inline editing participant count"), i.value = !0, l.value = r.participantCount && r.participantCount > 0 ? String(r.participantCount) : "", Ge(() => {
        s.value?.focus(), s.value?.select();
      });
    }
    function k() {
      const x = parseInt(l.value, 10), T = isNaN(x) || x <= 0 ? void 0 : x;
      oe.user("Saved inline participant count", { value: T }), g("update:participant-count", T), i.value = !1;
    }
    function m() {
      const x = parseInt(l.value, 10);
      g("update:participant-count", isNaN(x) || x <= 0 ? void 0 : x);
    }
    function h() {
      a = !0, g("update:participant-count", d), i.value = !1;
    }
    function I() {
      if (a) {
        a = !1;
        return;
      }
      k();
    }
    function b(x) {
      x.key === "Enter" ? (x.preventDefault(), a = !0, k()) : x.key === "Escape" ? h() : [".", ",", "-", "e", "E"].includes(x.key) && x.preventDefault();
    }
    const w = V(() => r.isBaseline ? { backgroundColor: eu } : r.hasExposure ? { backgroundColor: r.color ?? "#94a3b8" } : { backgroundColor: "#f1f5f9" }), S = V(() => r.hasExposure ? !!(r.isSelectable === !1 && !r.isSelected && !r.isHighlighted || r.hoverState === "faded" || r.someTimepointSelected && !r.isSelected && !r.isHighlighted && r.hoverState !== "direct" && r.hoverState !== "similar") : !1), A = V(() => {
      if (!r.isMerged || !r.secondaryColor) return w.value;
      const x = w.value.backgroundColor;
      return {
        backgroundImage: `linear-gradient(90deg, ${r.secondaryColor} 0%, ${r.secondaryColor} 50%, ${x} 50%, ${x} 100%)`
      };
    }), g = t;
    return (x, T) => (v(), C("div", {
      class: "relative flex items-center group",
      onMouseenter: T[8] || (T[8] = (_) => e.isMiddle ? n.value = !0 : void 0),
      onMouseleave: T[9] || (T[9] = (_) => e.isMiddle ? n.value = !1 : void 0)
    }, [
      e.showArrow ? (v(), Ce(Qa, {
        key: 0,
        color: e.color
      }, null, 8, ["color"])) : H("", !0),
      u("div", {
        class: Z(["relative z-10 transition-[clip-path] duration-200 ease-out rounded-full group/circle", o.value ? "clip-top-half" : "clip-none"])
      }, [
        u("div", {
          class: Z([S.value ? "opacity-100" : "opacity-0", "absolute inset-0 rounded-full bg-white z-0 transition-all"])
        }, null, 2),
        u("button", {
          class: Z(["size-12 shadow-md rounded-full flex flex-col items-center justify-center z-10 cursor-pointer transition-all relative", f.value]),
          style: ne(A.value),
          onClick: T[3] || (T[3] = he((_) => e.isSelectable !== !1 ? x.$emit("click", _) : void 0, ["stop"])),
          onMouseenter: T[4] || (T[4] = (_) => x.$emit("mouseenter")),
          onMouseleave: T[5] || (T[5] = (_) => x.$emit("mouseleave"))
        }, [
          (v(), C("svg", {
            class: Z(["transition-all", { "opacity-0": o.value }]),
            width: "15",
            height: "12",
            viewBox: "0 0 15 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, [...T[10] || (T[10] = [
            Zn('<path d="M9.6 2.4C9.6 3.72548 8.52548 4.8 7.2 4.8C5.87452 4.8 4.8 3.72548 4.8 2.4C4.8 1.07452 5.87452 0 7.2 0C8.52548 0 9.6 1.07452 9.6 2.4Z" fill="white" data-v-ea947745></path><path d="M13.6 4C13.6 4.88366 12.8837 5.6 12 5.6C11.1163 5.6 10.4 4.88366 10.4 4C10.4 3.11634 11.1163 2.4 12 2.4C12.8837 2.4 13.6 3.11634 13.6 4Z" fill="white" data-v-ea947745></path><path d="M10.4 9.6C10.4 7.83269 8.96731 6.4 7.2 6.4C5.43269 6.4 4 7.83269 4 9.6V12H10.4V9.6Z" fill="white" data-v-ea947745></path><path d="M4 4C4 4.88366 3.28366 5.6 2.4 5.6C1.51634 5.6 0.8 4.88366 0.8 4C0.8 3.11634 1.51634 2.4 2.4 2.4C3.28366 2.4 4 3.11634 4 4Z" fill="white" data-v-ea947745></path><path d="M12 12V9.6C12 8.75668 11.7825 7.96416 11.4006 7.27546C11.5922 7.2262 11.793 7.2 12 7.2C13.3255 7.2 14.4 8.27452 14.4 9.6V12H12Z" fill="white" data-v-ea947745></path><path d="M2.99941 7.27546C2.61748 7.96416 2.4 8.75668 2.4 9.6V12H0V9.6C0 8.27452 1.07452 7.2 2.4 7.2C2.60697 7.2 2.80782 7.2262 2.99941 7.27546Z" fill="white" data-v-ea947745></path>', 6)
          ])], 2)),
          i.value ? Le((v(), C("input", {
            key: 0,
            ref_key: "countInputRef",
            ref: s,
            "onUpdate:modelValue": T[0] || (T[0] = (_) => l.value = _),
            type: "number",
            min: "1",
            step: "1",
            class: "w-9 text-center text-sm font-bold text-white bg-transparent border-b border-white/60 focus:outline-none focus:border-white [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none",
            onKeydown: b,
            onBlur: I,
            onInput: m,
            onClick: T[1] || (T[1] = he(() => {
            }, ["stop"]))
          }, null, 544)), [
            [_e, l.value]
          ]) : (v(), C("span", {
            key: 1,
            class: Z(["text-sm font-bold text-white", e.canEditCount ? "cursor-text" : "pointer-events-none"]),
            onClick: T[2] || (T[2] = he((_) => e.canEditCount ? y(_) : void 0, ["stop"]))
          }, ae(e.participantCount ?? 0), 3))
        ], 38)
      ], 2),
      e.label ? (v(), C("div", Ja, [
        u("button", {
          class: Z(["text-xs font-medium whitespace-nowrap hover:text-indigo-600 transition-colors", [
            e.hasExposure ? "text-slate-600" : "text-slate-400",
            (e.isSelectable, "cursor-pointer")
          ]]),
          onClick: T[6] || (T[6] = he(
            () => {
              p(oe).user("Edit timepoint name clicked"), x.$emit("edit-name");
            },
            ["stop"]
          ))
        }, ae(e.label), 3),
        e.canDelete ? (v(), C("button", {
          key: 0,
          class: "text-red-500 hover:text-red-700 flex hover:bg-red-50 hover:scale-125 opacity-0 group-hover/intervention:opacity-100 transition-all rounded-lg p-0.5",
          title: "Delete Timepoint",
          onClick: T[7] || (T[7] = he(
            () => {
              p(oe).user("Delete timepoint clicked"), x.$emit("clear-exposure");
            },
            ["stop"]
          ))
        }, [
          K(dt)
        ])) : H("", !0)
      ])) : H("", !0)
    ], 32));
  }
}), Wn = /* @__PURE__ */ Me(tu, [["__scopeId", "data-v-ea947745"]]), nu = {}, ou = {
  width: "14",
  height: "14",
  viewBox: "0 0 14 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function iu(e, t) {
  return v(), C("svg", ou, [...t[0] || (t[0] = [
    u("path", {
      d: "M7 1.40039C10.0928 1.40039 12.5996 3.90721 12.5996 7C12.5996 10.0928 10.0928 12.5996 7 12.5996C3.90721 12.5996 1.40039 10.0928 1.40039 7C1.40039 3.90721 3.90721 1.40039 7 1.40039ZM7 3.2002C6.44772 3.2002 6 3.64791 6 4.2002V7C6.00005 7.2651 6.10554 7.51955 6.29297 7.70703L8.27246 9.6875C8.66283 10.0778 9.29599 10.0775 9.68652 9.6875C10.077 9.29701 10.077 8.66397 9.68652 8.27344L8 6.58594V4.2002C8 3.64791 7.55228 3.2002 7 3.2002Z",
      fill: "currentColor"
    }, null, -1)
  ])]);
}
const Wt = /* @__PURE__ */ Me(nu, [["render", iu]]), Xn = /* @__PURE__ */ ge({
  __name: "AddTimepointButton",
  props: {
    direction: { default: "left" }
  },
  setup(e) {
    return (t, n) => (v(), Ce(Ht, {
      label: "Add Timepoint",
      title: "Add Timepoint",
      direction: e.direction
    }, {
      default: Pe(() => [
        K(Wt, { class: "size-4" })
      ]),
      _: 1
    }, 8, ["direction"]));
  }
});
function Ue(e) {
  return e.timepoints.find((t) => t.isEnd) ?? Fn(e.timepoints).at(-1);
}
function ji() {
  const e = B(ze.EXACT), t = B(0), n = B(0), o = B("days");
  function i(l) {
    l ? (e.value = l.operator, t.value = l.value1 ?? 0, n.value = l.value2 ?? 0, o.value = l.unit ?? "days") : (e.value = ze.EXACT, t.value = 0, n.value = 0, o.value = "days");
  }
  return { durationOperator: e, durationValue1: t, durationValue2: n, durationUnit: o, hydrateDurationEditor: i };
}
const Hi = ["minutes", "hours", "days", "weeks", "months", "years"];
function Dt(e) {
  return e.operator === ze.EXACT ? `${e.value1} ${e.unit}` : `${e.value1}-${e.value2} ${e.unit}`;
}
function lu(e, t) {
  return e.timepoints.find((n) => n.id === t);
}
function ru(e) {
  const t = B(null), { durationOperator: n, durationValue1: o, durationValue2: i, durationUnit: l, hydrateDurationEditor: s } = ji(), a = V(() => {
    if (!t.value) return null;
    if (t.value === "interventionStart")
      return e.interventionGapLineRef.value;
    const h = e.sortedTimepoints.value.find(
      (I) => I.id === t.value
    )?.id;
    return h ? e.lineSegmentRefs.value.get(h) ?? null : null;
  });
  function d(h) {
    const I = e.sortedTimepoints.value.find((b) => b.id === h);
    I && (t.value = I.id, s(I.duration));
  }
  function r() {
    e.nextPeriod.value ? (t.value = "interventionStart", s(Ue(e.period.value)?.duration)) : e.previousPeriod.value && (t.value = "interventionStart", s(Ue(e.previousPeriod.value)?.duration));
  }
  function f(h, I, b) {
    e.updatePeriod(h.id, {
      timepoints: h.timepoints.map((w) => w.id === I ? { ...w, duration: b } : w)
    });
  }
  function y() {
    if (!t.value || t.value !== "interventionStart" && (n.value === ze.EXACT && o.value === 0 || n.value === ze.BETWEEN && o.value === 0 && i.value === 0))
      return;
    const h = {
      operator: n.value,
      value1: o.value,
      value2: n.value === ze.BETWEEN ? i.value : void 0,
      unit: l.value
    };
    if (t.value === "interventionStart") {
      if (e.nextPeriod.value) {
        const I = Ue(e.period.value);
        I && f(e.period.value, I.id, h);
      } else if (e.previousPeriod.value) {
        const I = Ue(e.previousPeriod.value);
        I && f(e.previousPeriod.value, I.id, h);
      }
    } else
      f(e.period.value, t.value, h);
    oe.user("Saved duration", {
      segment: t.value,
      duration: Dt(h)
    }), t.value = null;
  }
  function k() {
    if (t.value) {
      if (oe.user("Cleared duration", { segment: t.value }), t.value === "interventionStart") {
        if (e.nextPeriod.value) {
          const h = Ue(e.period.value);
          h && f(e.period.value, h.id, void 0);
        } else if (e.previousPeriod.value) {
          const h = Ue(e.previousPeriod.value);
          h && f(e.previousPeriod.value, h.id, void 0);
        }
      } else {
        const h = lu(e.period.value, t.value);
        h && f(e.period.value, h.id, void 0);
      }
      t.value = null;
    }
  }
  function m() {
    t.value = null;
  }
  return {
    editingDurationForSegment: t,
    durationOperator: n,
    durationValue1: o,
    durationValue2: i,
    durationUnit: l,
    durationEditReferenceEl: a,
    handleLineClick: d,
    handleInterventionGapClick: r,
    handleSaveDuration: y,
    handleClearDuration: k,
    handleCancelDuration: m
  };
}
function su(e) {
  const t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t ? { r: parseInt(t[1], 16), g: parseInt(t[2], 16), b: parseInt(t[3], 16) } : { r: 0, g: 0, b: 0 };
}
function au(e, t) {
  const { r: n, g: o, b: i } = su(e);
  return `rgba(${n}, ${o}, ${i}, ${t})`;
}
const uu = { class: "relative flex items-center flex-1 h-full" }, du = {
  key: 0,
  class: "absolute left-2",
  style: { top: "-44px" }
}, cu = {
  key: 1,
  class: "flex flex-col items-start justify-center gap-1 p-1 relative"
}, fu = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  class: "size-2.5 shrink-0 opacity-60"
}, pu = { class: "flex items-center gap-1.5" }, vu = { class: "relative" }, mu = {
  key: 1,
  class: "w-0 overflow-visible z-30 relative"
}, hu = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  class: "size-2.5 shrink-0 opacity-60"
}, gu = {
  key: 0,
  class: "relative flex items-center group/add-tp"
}, bu = ["onClick"], xu = {
  key: 0,
  class: "text-white whitespace-nowrap text-xs font-medium flex items-center justify-center absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 z-20 transition-all rounded-full group-hover/dur:scale-125 group-hover/dur:text-gray-600 group-hover/dur:bg-white p-1"
}, yu = {
  key: 1,
  class: "size-6 text-white rounded-full flex items-center justify-center absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 z-20 transition-all group-hover/dur:scale-150 group-hover/dur:text-gray-600 group-hover/dur:bg-white"
}, Zo = /* @__PURE__ */ ge({
  __name: "InterventionBranch",
  props: {
    intervention: {},
    definition: {},
    sortedTimepoints: {},
    branchIndex: {},
    totalBranches: {},
    mode: {},
    isSelected: { type: Boolean },
    isHighlighted: { type: Boolean },
    isLinked: { type: Boolean },
    canSelect: { type: Boolean },
    isTimepointSelected: { type: Function },
    isTimepointHighlighted: { type: Function },
    getTimepointSimilarityState: { type: Function },
    someTimepointHovered: { type: Boolean },
    someTimepointSelected: { type: Boolean },
    timepointSelectable: { type: Boolean },
    registerTimepointCircleRef: { type: Function },
    registerLineSegmentRef: { type: Function }
  },
  emits: ["edit", "branchClick", "timepointCircleClick", "addTimepointBetween", "deleteIntervention", "lineClick", "timepointHover", "timepointLeave", "update:participantCount"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = B(null), l = B(!1);
    function s(b) {
      i.value = b, o("timepointHover", b);
    }
    function a() {
      i.value = null, o("timepointLeave");
    }
    function d(b) {
      return i.value === b ? "direct" : n.getTimepointSimilarityState(b) ?? "default";
    }
    const r = V(() => n.totalBranches > 1), f = V(() => n.branchIndex === n.totalBranches - 1), y = V(
      () => n.sortedTimepoints.length === 1 ? n.sortedTimepoints[0] : null
    ), k = V(() => au(n.definition.color, 0.15)), m = V(
      () => to(n.definition) ?? "Unnamed"
    );
    function h(b) {
      return b > 0 && b < n.sortedTimepoints.length - 1;
    }
    function I(b) {
      n.mode === "edit" ? (b.stopPropagation(), o("edit")) : r.value && n.canSelect && (b.stopPropagation(), o("branchClick"));
    }
    return (b, w) => (v(), C("div", {
      class: Z(["flex items-center h-16 relative group/branch", [
        e.mode === "edit" ? "cursor-pointer" : "",
        r.value && e.mode === "select" && (e.isSelected || e.canSelect || e.isHighlighted) ? "cursor-pointer" : ""
      ]]),
      onClick: I
    }, [
      u("div", uu, [
        !r.value && e.mode === "edit" && e.branchIndex === 0 && e.sortedTimepoints.length === 1 ? (v(), C("div", du, [
          at(b.$slots, "add-parallel-button")
        ])) : H("", !0),
        y.value ? (v(), C("div", cu, [
          e.mode === "edit" ? (v(), C("div", {
            key: 0,
            class: "absolute inset-0 rounded-md opacity-0 group-hover/branch:opacity-100 transition-opacity pointer-events-none z-10",
            style: ne({ backgroundColor: k.value })
          }, null, 4)) : H("", !0),
          u("span", {
            class: "text-[10px] font-medium truncate max-w-20 flex items-center gap-0.5",
            style: ne({ color: e.definition.color })
          }, [
            an(ae(m.value) + " ", 1),
            e.isLinked ? (v(), C("svg", fu, [...w[9] || (w[9] = [
              u("path", { d: "M12.232 4.232a2.5 2.5 0 0 1 3.536 3.536l-1.225 1.224a.75.75 0 0 0 1.061 1.06l1.224-1.224a4 4 0 0 0-5.656-5.656l-3 3a4 4 0 0 0 .225 5.865.75.75 0 0 0 .977-1.138 2.5 2.5 0 0 1-.142-3.667l3-3Z" }, null, -1),
              u("path", { d: "M11.603 7.963a.75.75 0 0 0-.977 1.138 2.5 2.5 0 0 1 .142 3.667l-3 3a2.5 2.5 0 0 1-3.536-3.536l1.225-1.224a.75.75 0 0 0-1.061-1.06l-1.224 1.224a4 4 0 1 0 5.656 5.656l3-3a4 4 0 0 0-.225-5.865Z" }, null, -1)
            ])])) : H("", !0)
          ], 4),
          u("div", pu, [
            u("div", vu, [
              K(Wn, {
                ref: (S) => n.sortedTimepoints[0] && n.registerTimepointCircleRef(n.sortedTimepoints[0].id, S),
                "has-exposure": !0,
                "show-arrow": !1,
                color: e.definition.color,
                "can-edit-count": e.mode === "edit",
                "hover-state": d(y.value.id),
                "is-baseline": !1,
                "participant-count": y.value.participantCount ?? 0,
                "is-selected": e.isTimepointSelected(y.value.id),
                "is-selectable": e.timepointSelectable,
                "is-highlighted": e.isTimepointHighlighted(y.value.id),
                "is-middle": !1,
                "some-timepoint-selected": e.someTimepointSelected,
                onClick: w[0] || (w[0] = he((S) => o("timepointCircleClick", y.value.id), ["stop"])),
                "onUpdate:participantCount": w[1] || (w[1] = (S) => o("update:participantCount", y.value.id, S)),
                onMouseenter: w[2] || (w[2] = (S) => e.mode === "edit" ? s(y.value.id) : void 0),
                onMouseleave: w[3] || (w[3] = (S) => e.mode === "edit" ? a() : void 0)
              }, null, 8, ["color", "can-edit-count", "hover-state", "participant-count", "is-selected", "is-selectable", "is-highlighted", "some-timepoint-selected"])
            ]),
            e.mode === "edit" && r.value ? (v(), C("button", {
              key: 0,
              class: "flex items-center justify-center text-red-500 hover:text-red-700 hover:bg-red-50 hover:scale-125 opacity-0 group-hover/branch:opacity-100 transition-all rounded-lg p-0.5 shrink-0 z-30",
              title: "Delete intervention",
              onClick: w[4] || (w[4] = he((S) => o("deleteIntervention"), ["stop"]))
            }, [
              K(dt)
            ])) : H("", !0),
            !r.value && f.value && e.mode === "edit" ? (v(), C("div", mu, [
              K(Xn, {
                direction: "right",
                onClick: w[5] || (w[5] = (S) => o("addTimepointBetween", y.value.id))
              })
            ])) : H("", !0)
          ])
        ])) : (v(), C(se, { key: 2 }, [
          u("div", {
            class: "absolute bottom-10 left-6 right-6 h-4 hover:h-7 hover:text-sm text-xs flex items-center justify-center overflow-hidden rounded-t-md transition-all",
            style: ne({ backgroundColor: k.value }),
            onMouseenter: w[6] || (w[6] = (S) => e.mode === "select" ? l.value = !0 : void 0),
            onMouseleave: w[7] || (w[7] = (S) => e.mode === "select" ? l.value = !1 : void 0)
          }, [
            u("span", {
              class: "font-medium truncate px-2 flex items-center gap-0.5",
              style: ne({ color: e.definition.color })
            }, [
              an(ae(m.value) + " ", 1),
              e.isLinked ? (v(), C("svg", hu, [...w[10] || (w[10] = [
                u("path", { d: "M12.232 4.232a2.5 2.5 0 0 1 3.536 3.536l-1.225 1.224a.75.75 0 0 0 1.061 1.06l1.224-1.224a4 4 0 0 0-5.656-5.656l-3 3a4 4 0 0 0 .225 5.865.75.75 0 0 0 .977-1.138 2.5 2.5 0 0 1-.142-3.667l3-3Z" }, null, -1),
                u("path", { d: "M11.603 7.963a.75.75 0 0 0-.977 1.138 2.5 2.5 0 0 1 .142 3.667l-3 3a2.5 2.5 0 0 1-3.536-3.536l1.225-1.224a.75.75 0 0 0-1.061-1.06l-1.224 1.224a4 4 0 1 0 5.656 5.656l3-3a4 4 0 0 0-.225-5.865Z" }, null, -1)
              ])])) : H("", !0)
            ], 4)
          ], 36),
          (v(!0), C(se, null, pe(e.sortedTimepoints, (S, A) => (v(), C(se, {
            key: S.id
          }, [
            u("div", {
              class: Z(["relative", h(A) ? "group/middle-tp" : ""])
            }, [
              K(Wn, {
                ref_for: !0,
                ref: (g) => n.registerTimepointCircleRef(S.id, g),
                "has-exposure": !0,
                "show-arrow": !1,
                color: e.definition.color,
                "can-edit-count": e.mode === "edit",
                "hover-state": d(S.id),
                "is-baseline": !1,
                "participant-count": S.participantCount ?? 0,
                "is-selected": e.isTimepointSelected(S.id),
                "is-selectable": e.timepointSelectable,
                "is-highlighted": e.isTimepointHighlighted(S.id),
                "is-middle": h(A),
                "some-timepoint-selected": e.someTimepointSelected,
                "force-crop": e.mode === "select" && l.value && h(A),
                onClick: he((g) => o("timepointCircleClick", S.id), ["stop"]),
                "onUpdate:participantCount": (g) => o("update:participantCount", S.id, g),
                onMouseenter: (g) => e.mode === "edit" ? s(S.id) : void 0,
                onMouseleave: w[8] || (w[8] = (g) => e.mode === "edit" ? a() : void 0)
              }, null, 8, ["color", "can-edit-count", "hover-state", "participant-count", "is-selected", "is-selectable", "is-highlighted", "is-middle", "some-timepoint-selected", "force-crop", "onClick", "onUpdate:participantCount", "onMouseenter"])
            ], 2),
            A < e.sortedTimepoints.length - 1 ? (v(), C("div", gu, [
              u("button", {
                ref_for: !0,
                ref: (g) => n.registerLineSegmentRef(S.id, g),
                class: Z(["w-24 h-4 transition-all relative group/dur", [
                  e.mode === "edit" ? "cursor-pointer" : "cursor-default",
                  e.mode === "edit" && n.someTimepointHovered ? "opacity-50" : "",
                  e.mode === "select" && n.someTimepointSelected ? "opacity-50" : ""
                ]]),
                onClick: (g) => e.mode === "edit" ? (o("lineClick", S.id), g.stopPropagation()) : void 0
              }, [
                S.duration ? (v(), C("div", xu, ae(p(Dt)(S.duration)), 1)) : e.mode === "edit" ? (v(), C("div", yu, [
                  K(Wt)
                ])) : H("", !0),
                u("div", {
                  class: "absolute w-[120%] h-full top-0 -left-2 z-1",
                  style: ne({ backgroundColor: e.definition.color })
                }, null, 4)
              ], 10, bu)
            ])) : H("", !0)
          ], 64))), 128))
        ], 64))
      ])
    ], 2));
  }
}), wu = { class: "p-4 w-[320px] space-y-3" }, Cu = { class: "flex flex-col gap-3" }, ku = ["value"], $u = ["value"], Iu = {
  for: "duration-value1",
  class: "text-xs font-medium text-slate-600 mb-1 block"
}, Tu = { key: 0 }, Su = ["min"], Pu = ["value"], Au = { class: "flex items-center justify-between pt-2 border-t border-slate-100" }, Eu = { class: "flex gap-2" }, Ui = /* @__PURE__ */ ge({
  __name: "InterventionDurationMenu",
  props: {
    referenceEl: {},
    canMergeDuration: { type: Boolean },
    operator: {},
    value1: {},
    value2: {},
    unit: {},
    units: {}
  },
  emits: ["update:operator", "update:value1", "update:value2", "update:unit", "save", "cancel", "clear"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = V({
      get: () => n.operator,
      set: (d) => o("update:operator", d)
    }), l = V({
      get: () => n.value1,
      set: (d) => o("update:value1", d)
    }), s = V({
      get: () => n.value2,
      set: (d) => o("update:value2", d)
    }), a = V({
      get: () => n.unit,
      set: (d) => o("update:unit", d)
    });
    return (d, r) => e.referenceEl ? (v(), Ce(xn, {
      key: 0,
      "reference-el": e.referenceEl,
      onClose: r[7] || (r[7] = (f) => o("cancel"))
    }, {
      default: Pe(() => [
        u("div", wu, [
          r[11] || (r[11] = u("h3", { class: "text-sm font-semibold text-slate-800" }, "Set Duration", -1)),
          u("div", Cu, [
            u("div", null, [
              r[8] || (r[8] = u("label", {
                for: "duration-operator",
                class: "text-xs font-medium text-slate-600 mb-1 block"
              }, "Operator", -1)),
              Le(u("select", {
                id: "duration-operator",
                "onUpdate:modelValue": r[0] || (r[0] = (f) => i.value = f),
                class: "w-full h-9 rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm focus:bg-white focus:ring-2 focus:ring-slate-200"
              }, [
                u("option", {
                  value: p(ze).EXACT
                }, "Is exactly", 8, ku),
                u("option", {
                  value: p(ze).BETWEEN
                }, "Is between", 8, $u)
              ], 512), [
                [$o, i.value]
              ])
            ]),
            u("div", {
              class: Z(["grid gap-2", i.value === p(ze).BETWEEN ? "grid-cols-2" : "grid-cols-1"])
            }, [
              u("div", null, [
                u("label", Iu, ae(i.value === p(ze).BETWEEN ? "From" : "Value"), 1),
                Le(u("input", {
                  id: "duration-value1",
                  "onUpdate:modelValue": r[1] || (r[1] = (f) => l.value = f),
                  type: "number",
                  min: 0,
                  step: "1",
                  class: "w-full h-9 rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-slate-200"
                }, null, 512), [
                  [
                    _e,
                    l.value,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ]),
              i.value === p(ze).BETWEEN ? (v(), C("div", Tu, [
                r[9] || (r[9] = u("label", {
                  for: "duration-value2",
                  class: "text-xs font-medium text-slate-600 mb-1 block"
                }, "To", -1)),
                Le(u("input", {
                  id: "duration-value2",
                  "onUpdate:modelValue": r[2] || (r[2] = (f) => s.value = f),
                  type: "number",
                  min: e.canMergeDuration ? 0 : 0.1,
                  step: "0.1",
                  class: "w-full h-9 rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-slate-200"
                }, null, 8, Su), [
                  [
                    _e,
                    s.value,
                    void 0,
                    { number: !0 }
                  ]
                ])
              ])) : H("", !0)
            ], 2),
            u("div", null, [
              r[10] || (r[10] = u("label", {
                for: "duration-unit",
                class: "text-xs font-medium text-slate-600 mb-1 block"
              }, "Unit", -1)),
              Le(u("select", {
                id: "duration-unit",
                "onUpdate:modelValue": r[3] || (r[3] = (f) => a.value = f),
                class: "w-full h-9 rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm focus:bg-white focus:ring-2 focus:ring-slate-200"
              }, [
                (v(!0), C(se, null, pe(e.units, (f) => (v(), C("option", {
                  key: f,
                  value: f
                }, ae(f), 9, Pu))), 128))
              ], 512), [
                [$o, a.value]
              ])
            ])
          ]),
          u("div", Au, [
            u("button", {
              type: "button",
              class: "px-3 py-1.5 text-sm font-medium rounded-lg text-red-600 hover:bg-red-50 transition-all",
              onClick: r[4] || (r[4] = (f) => o("clear"))
            }, " Clear "),
            u("div", Eu, [
              u("button", {
                type: "button",
                class: "px-3 py-1.5 text-sm font-medium rounded-lg border border-slate-200 text-slate-600 hover:bg-slate-50 hover:text-slate-900 transition-all",
                onClick: r[5] || (r[5] = (f) => o("cancel"))
              }, " Cancel "),
              u("button", {
                type: "button",
                class: "px-3 py-1.5 text-sm font-medium rounded-lg bg-indigo-600 text-white hover:bg-indigo-700 shadow-sm transition-all",
                onClick: r[6] || (r[6] = (f) => o("save"))
              }, " Save ")
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["reference-el"])) : H("", !0);
  }
});
function Ou(e) {
  const t = B(null), n = B(""), o = B(""), i = B(!1), l = B(null), s = B("");
  function a(A) {
    return e.period.value.timepoints.find((g) => g.id === A);
  }
  function d(A) {
    let g = 0;
    for (const x of e.allPeriods.value)
      for (const T of x.timepoints)
        T.name === A && g++;
    return g;
  }
  function r(A) {
    const g = a(A);
    g && e.setHoveredTimepoint(g.name, e.period.value.id);
  }
  function f() {
    e.setHoveredTimepoint(null, null);
  }
  function y(A) {
    if (!e.hoveredTimepointId.value) return null;
    const g = a(A);
    return !g || g.name !== e.hoveredTimepointId.value ? "faded" : e.hoveredTimepointPeriodId.value === e.period.value.id ? "similar" : "cross-period";
  }
  function k(A) {
    const g = a(A);
    g && (oe.user("Started editing timepoint name", { timepointId: A, name: g.name }), t.value = A, n.value = g.name, o.value = g.name);
  }
  function m() {
    if (!t.value || !n.value.trim()) {
      w();
      return;
    }
    const A = n.value.trim(), g = o.value;
    if (A === g) {
      w();
      return;
    }
    d(g) - 1 > 0 ? (l.value = t.value, s.value = A, t.value = null, n.value = "", i.value = !0) : (oe.user("Saved timepoint name", {
      timepointId: t.value,
      newName: A,
      applyToAll: !1
    }), e.updateTimepointName(e.period.value.id, t.value, A, !1), t.value = null, n.value = "", o.value = "");
  }
  function h() {
    l.value && (oe.user("Saved timepoint name (rename all)", {
      timepointId: l.value,
      newName: s.value,
      applyToAll: !0
    }), e.updateTimepointName(
      e.period.value.id,
      l.value,
      s.value,
      !0
    )), b();
  }
  function I() {
    l.value && (oe.user("Saved timepoint name (keep unique)", {
      timepointId: l.value,
      newName: s.value,
      applyToAll: !1
    }), e.updateTimepointName(
      e.period.value.id,
      l.value,
      s.value,
      !1
    )), b();
  }
  function b() {
    i.value = !1, l.value = null, s.value = "", o.value = "";
  }
  function w() {
    t.value = null, n.value = "", o.value = "";
  }
  function S(A, g) {
    oe.user("Updated participant count", { timepointId: A, count: g });
    const x = e.period.value.timepoints.map(
      (T) => T.id === A ? { ...T, participantCount: g } : T
    );
    e.updatePeriod(e.period.value.id, { timepoints: x });
  }
  return {
    editingTimepointId: t,
    editingTimepointName: n,
    originalTimepointName: o,
    showRenameAllDialog: i,
    pendingRenameNewName: s,
    handleTimepointHover: r,
    handleTimepointLeave: f,
    getTimepointSimilarityState: y,
    handleTimepointClick: k,
    handleSaveTimepointName: m,
    handleConfirmRenameAll: h,
    handleCancelRenameAll: I,
    handleCancelEdit: w,
    handleUpdateParticipantCount: S
  };
}
function Mu(e) {
  const {
    period: t,
    sortedInterventions: n,
    sortedTimepoints: o,
    mode: i,
    selectedAnchor: l,
    selectedInterventionTimepoints: s,
    selectablePeriodIds: a,
    selectedTimepointNames: d,
    allTimepointNamesInSelectedPeriod: r,
    commonTimepointNamesInSelectedPeriods: f,
    selectedInterventionIds: y,
    selectedInterventionIdsByArm: k,
    expandableArmIds: m,
    toggleInterventionTimepointSelection: h,
    removeInterventionTimepoints: I
  } = e, b = V(
    () => (l.value ? 1 : 0) + d.value.size
  ), w = V(() => a.value.has(t.value.id));
  function S() {
    return [...d.value].every(
      (G) => o.value.some((q) => q.name === G)
    );
  }
  function A() {
    return o.value.some(
      (G) => r.value.has(G.name)
    );
  }
  function g() {
    return l.value ? !1 : b.value === 0 ? !0 : !(y.value.size >= 2 || !A() || !S());
  }
  function x(G, q) {
    return i.value !== "select" ? !1 : s.value.some(
      (Q) => Q.interventionId === G && Q.timepointId === q
    );
  }
  function T(G) {
    return s.value.some((q) => q.interventionId === G);
  }
  function _(G, q) {
    if (i.value !== "select" || !w.value || x(G, q) || b.value === 0 || l.value) return !1;
    const Q = o.value.find((ce) => ce.id === q);
    return Q ? T(G) ? d.value.has(Q.name) ? !0 : d.value.size >= 2 ? !1 : y.value.size >= 2 ? f.value.has(Q.name) : !0 : y.value.size >= 2 && !m.value.has(t.value.armId) || !S() && !m.value.has(t.value.armId) || !r.value.has(Q.name) && !m.value.has(t.value.armId) ? !1 : d.value.size >= 2 ? d.value.has(Q.name) : !0 : !1;
  }
  const W = V(
    () => n.value.some((G) => T(G.id))
  ), U = V(() => i.value !== "select" || W.value || !w.value || b.value === 0 || l.value ? !1 : m.value.has(t.value.armId) ? !0 : !(y.value.size >= 2 || !A() || !S())), z = V(() => i.value !== "select" || n.value.length > 1 || !w.value ? !1 : W.value || m.value.has(t.value.armId) ? !0 : g());
  function M(G) {
    return i.value !== "select" || l.value || !w.value ? !1 : T(G) || b.value === 0 ? !0 : !(y.value.size >= 2 && !y.value.has(G) && !m.value.has(t.value.armId) || !l.value && !W.value && (!A() || !S()));
  }
  function R(G) {
    if (i.value === "select" && !l.value)
      return !!w.value;
  }
  function F(G, q) {
    if (i.value === "select" && w.value) {
      if (x(G, q)) {
        h(G, q);
        return;
      }
      (b.value === 0 || _(G, q)) && h(G, q);
    }
  }
  function L(G) {
    if (d.value.size > 0) {
      const Q = o.value.filter(
        (ce) => d.value.has(ce.name)
      );
      if (Q.length > 0) {
        if (Q.every((be) => x(G, be.id))) {
          const be = k.value, ye = be.size > 1 ? (
            // Multi-arm (AB/BA): deselect the whole arm the clicked intervention belongs to
            be.get(t.value.armId) ?? [G]
          ) : (
            // Single-arm: deselect only the clicked intervention
            [G]
          );
          for (const ve of ye)
            I(ve);
          return;
        }
        for (const be of Q)
          x(G, be.id) || F(G, be.id);
        return;
      }
    }
    const q = o.value[0];
    q && F(G, q.id);
  }
  function N() {
    const G = n.value[0];
    !G || !z.value || L(G.id);
  }
  function D(G) {
    L(G);
  }
  const X = V(
    () => n.value.some((G) => M(G.id))
  );
  return {
    isPeriodSelected: W,
    isPeriodHighlighted: U,
    canSelectPeriod: z,
    canSelectAnyBranch: X,
    canSelectBranch: M,
    isTimepointSelected: x,
    isTimepointHighlighted: _,
    isInterventionTimepointSelected: T,
    getTimepointSelectable: R,
    handleTimepointCircleClick: F,
    handlePeriodClick: N,
    handleBranchClick: D
  };
}
const Ru = { class: "flex items-center gap-3 mb-4" }, Du = { class: "text-lg font-semibold text-slate-900" }, Lu = { class: "text-sm text-slate-600 mb-6" }, Bu = { class: "flex justify-end gap-3" }, qn = /* @__PURE__ */ ge({
  __name: "ConfirmDialog",
  props: {
    show: { type: Boolean },
    title: {},
    message: {},
    variant: { default: "danger" },
    confirmText: { default: "Confirm" },
    cancelText: { default: "Cancel" }
  },
  emits: ["confirm", "cancel"],
  setup(e) {
    const t = e, n = V(() => {
      switch (t.variant) {
        case "danger":
          return "bg-red-600 hover:bg-red-700";
        case "warning":
          return "bg-orange-600 hover:bg-orange-700";
        case "info":
          return "bg-blue-600 hover:bg-blue-700";
        default:
          return "bg-red-600 hover:bg-red-700";
      }
    });
    return (o, i) => (v(), Ce(Yn, { to: "body" }, [
      e.show ? (v(), C("div", {
        key: 0,
        class: "fixed inset-0 z-101 flex items-center justify-center bg-black/50",
        onClick: i[3] || (i[3] = (l) => o.$emit("cancel"))
      }, [
        u("div", {
          class: "bg-white rounded-xl shadow-xl p-6 max-w-md mx-4",
          onClick: i[2] || (i[2] = he(() => {
          }, ["stop"]))
        }, [
          u("div", Ru, [
            u("h3", Du, ae(e.title), 1)
          ]),
          u("p", Lu, ae(e.message), 1),
          u("div", Bu, [
            u("button", {
              class: "px-4 py-2 text-sm font-medium text-slate-700 hover:bg-slate-100 rounded-lg transition-colors",
              onClick: i[0] || (i[0] = (l) => o.$emit("cancel"))
            }, ae(e.cancelText), 1),
            u("button", {
              class: Z(["px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors", n.value]),
              onClick: i[1] || (i[1] = (l) => o.$emit("confirm"))
            }, ae(e.confirmText), 3)
          ])
        ])
      ])) : H("", !0)
    ]));
  }
}), Nu = {}, zu = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "20px",
  viewBox: "0 -960 960 960",
  width: "20px",
  fill: "currentColor"
};
function _u(e, t) {
  return v(), C("svg", zu, [...t[0] || (t[0] = [
    u("path", { d: "M407-735.54q-30-29.53-30-72.5Q377-851 407.12-881q30.11-30 73-30Q523-911 553-880.88q30 30.11 30 73.07 0 42.97-30.12 72.39-30.11 29.42-73 29.42Q437-706 407-735.54ZM334-91v-447H132v-113h696v113H626v447H514l-9-238h-49L446-91H334Z" }, null, -1)
  ])]);
}
const Vu = /* @__PURE__ */ Me(Nu, [["render", _u]]), sn = /* @__PURE__ */ ge({
  __name: "AddParallelInterventionButton",
  setup(e) {
    return (t, n) => (v(), Ce(Ht, {
      label: "Add body site",
      title: "Add body site"
    }, {
      default: Pe(() => [
        K(Vu, { class: "size-4" })
      ]),
      _: 1
    }));
  }
}), Fu = { class: "flex items-start shrink-0" }, ju = {
  class: "relative grid pt-2 gap-2",
  style: { "grid-template-columns": "max-content" }
}, Hu = ["contenteditable", "onClick", "onKeydown"], Uu = ["height"], Gu = ["d"], Wu = ["d"], Xu = ["d"], zt = 64, Pn = 8, An = 8, qu = 32, Yo = 38, Zu = 24, st = 112, $t = 32, et = 8, Ko = 12, Yu = /* @__PURE__ */ ge({
  __name: "ParallelInterventionConnector",
  props: {
    interventions: {},
    randomization: {},
    mode: {}
  },
  emits: ["update:randomization", "update:bodyPartName", "add"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = B(!1), l = B(null), s = V(() => l.value), a = V(() => Ii(n.randomization)), d = B(null), r = B("");
    function f(U, z) {
      d.value = U.id, r.value = U.bodyPartName ?? "", z && Ge(() => {
        z.focus();
        const M = document.createRange();
        M.selectNodeContents(z);
        const R = window.getSelection();
        R?.removeAllRanges(), R?.addRange(M);
      });
    }
    function y() {
      if (!d.value) return;
      const U = r.value.trim();
      o("update:bodyPartName", d.value, U || void 0), d.value = null;
    }
    function k() {
      d.value = null;
    }
    const m = st / 2 - $t / 2, h = st / 2 + $t / 2, I = m - Ko, b = h + Ko, w = I - et, S = b + et, A = V(
      () => n.interventions.map((U, z) => An + z * (zt + Pn) + zt / 2)
    ), g = V(
      () => An + n.interventions.length * zt + (n.interventions.length - 1) * Pn + Zu
    ), x = V(() => {
      const U = A.value;
      return ((U[0] ?? 0) + (U[U.length - 1] ?? 0)) / 2;
    }), T = V(
      () => A.value.map((U) => {
        const z = x.value;
        if (Math.abs(U - z) < 1)
          return `M 0 ${U} L ${m} ${z}`;
        const M = U < z ? 1 : -1;
        return [
          `M 0 ${U}`,
          `L ${w - et} ${U}`,
          `Q ${w} ${U} ${w} ${U + et * M}`,
          `L ${w} ${z - et * M}`,
          `Q ${w} ${z} ${w + et} ${z}`,
          `L ${m} ${z}`
        ].join(" ");
      })
    ), _ = V(
      () => A.value.map((U) => {
        const z = x.value;
        if (Math.abs(U - z) < 1)
          return `M ${h} ${z} L ${st} ${U}`;
        const M = U > z ? 1 : -1;
        return [
          `M ${h} ${z}`,
          `L ${b} ${z}`,
          `Q ${S} ${z} ${S} ${z + et * M}`,
          `L ${S} ${U - et * M}`,
          `Q ${S} ${U} ${S + et} ${U}`,
          `L ${st} ${U}`
        ].join(" ");
      })
    ), W = V(
      () => A.value.map((U) => `M 0 ${U} L ${st} ${U}`)
    );
    return (U, z) => (v(), C("div", Fu, [
      u("div", ju, [
        e.mode === "edit" ? (v(), C("div", {
          key: 0,
          class: "absolute z-20 pointer-events-auto",
          style: ne({ top: `-${Yo + 10}px`, left: "calc(50% - 16px)" })
        }, [
          K(sn, {
            onClick: z[0] || (z[0] = (M) => o("add"))
          })
        ], 4)) : H("", !0),
        e.mode === "edit" ? (v(), C("div", {
          key: 1,
          class: "absolute border-l-2 border-dashed border-[#555E69] opacity-30 pointer-events-none z-0",
          style: ne({
            left: "50%",
            transform: "translateX(-50%)",
            top: "-32px",
            height: `${Yo + 10 - qu / 2 + An + (e.interventions.length - 1) * (zt + Pn) + zt / 2}px`
          })
        }, null, 4)) : H("", !0),
        (v(!0), C(se, null, pe(e.interventions, (M) => (v(), C("div", {
          key: M.id,
          class: "h-16 flex items-center justify-center px-1 relative z-10"
        }, [
          u("span", {
            contenteditable: e.mode === "edit" && d.value === M.id,
            ref_for: !0,
            ref: (R) => {
              R && d.value === M.id && R.focus();
            },
            class: Z(["w-full text-center text-xs font-semibold whitespace-nowrap rounded-full px-2.5 py-1.5 outline-none border-[1.5px] border-[#555E69] text-[#555E69] bg-white transition-colors tracking-[0.06px]", [
              d.value === M.id ? "ring-2 ring-slate-300 cursor-text" : "",
              e.mode === "edit" && d.value !== M.id ? "cursor-pointer hover:bg-slate-50" : ""
            ]]),
            onClick: he((R) => e.mode === "edit" && d.value !== M.id ? f(M, R.currentTarget) : void 0, ["stop"]),
            onBlur: y,
            onKeydown: [
              z[1] || (z[1] = Et(he((R) => R.target.blur(), ["prevent"]), ["enter"])),
              Et(he(k, ["stop"]), ["esc"])
            ],
            onInput: z[2] || (z[2] = (R) => r.value = R.target.textContent ?? "")
          }, ae(M.bodyPartName ?? "Site"), 43, Hu)
        ]))), 128))
      ]),
      u("div", {
        class: "relative shrink-0",
        style: ne({ width: `${st}px`, height: `${g.value}px` })
      }, [
        (v(), C("svg", {
          width: st,
          height: g.value,
          class: "absolute inset-0 overflow-visible",
          style: { "pointer-events": "none" }
        }, [
          a.value ? (v(), C(se, { key: 0 }, [
            (v(!0), C(se, null, pe(T.value, (M, R) => (v(), C("path", {
              key: `in-${R}`,
              d: M,
              fill: "none",
              stroke: "#475569",
              "stroke-width": "4",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Gu))), 128)),
            (v(!0), C(se, null, pe(_.value, (M, R) => (v(), C("path", {
              key: `out-${R}`,
              d: M,
              fill: "none",
              stroke: "#475569",
              "stroke-width": "4",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, null, 8, Wu))), 128))
          ], 64)) : (v(!0), C(se, { key: 1 }, pe(W.value, (M, R) => (v(), C("path", {
            key: `straight-${R}`,
            d: M,
            fill: "none",
            stroke: "#475569",
            "stroke-width": "4",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, Xu))), 128))
        ], 8, Uu)),
        u("button", {
          ref_key: "diceButtonRef",
          ref: l,
          class: Z(["absolute flex items-center justify-center rounded-full bg-white shadow-md border-2 transition-colors z-10", [
            a.value ? "text-red-500 border-red-400" : "text-slate-400 border-slate-400",
            e.mode === "edit" ? "cursor-pointer hover:bg-slate-50" : "cursor-default pointer-events-none"
          ]]),
          style: ne({
            width: `${$t}px`,
            height: `${$t}px`,
            top: `${x.value - $t / 2}px`,
            left: `${st / 2 - $t / 2}px`
          }),
          title: "Randomization",
          onClick: z[3] || (z[3] = he((M) => e.mode === "edit" ? i.value = !i.value : void 0, ["stop"]))
        }, [
          K(Ai, { class: "size-4" })
        ], 6),
        i.value && e.mode === "edit" ? (v(), Ce(Fi, {
          key: 0,
          "reference-el": s.value,
          "model-value": n.randomization ?? p(eo)(),
          "group-labels": e.interventions.map((M) => M.bodyPartName ?? "Site"),
          "onUpdate:modelValue": z[4] || (z[4] = (M) => {
            o("update:randomization", M), i.value = !1;
          }),
          onClose: z[5] || (z[5] = (M) => i.value = !1)
        }, null, 8, ["reference-el", "model-value", "group-labels"])) : H("", !0)
      ], 4)
    ]));
  }
}), Ku = { class: "flex flex-col gap-2 group" }, Qu = {
  key: 0,
  class: "absolute z-20 pointer-events-auto",
  style: { top: "-45px", right: "87px" }
}, Ju = { class: "flex flex-col pt-2 pr-2 pb-4 gap-2" }, ed = { class: "flex items-center" }, td = { class: "w-12 flex justify-center" }, nd = { class: "flex items-center gap-1 relative" }, od = ["onClick"], id = ["onClick"], ld = {
  key: 0,
  class: "w-24"
}, rd = {
  key: 1,
  class: "relative flex flex-col p-2 -mb-6"
}, sd = {
  key: 0,
  class: "absolute z-20 pointer-events-auto",
  style: { top: "-76px", left: "0" }
}, ad = {
  key: 1,
  class: "absolute z-20 pointer-events-auto",
  style: { top: "-36px", right: "87px" }
}, ud = {
  key: 2,
  class: "absolute border-l-2 border-dashed border-[#555E69] opacity-30 pointer-events-none z-0",
  style: { right: "103px", top: "-20px", height: "60px" }
}, dd = {
  key: 2,
  class: "flex items-center pl-2 pt-4"
}, cd = { class: "w-12 flex justify-center" }, fd = { class: "flex items-center gap-1 relative" }, pd = ["onClick"], vd = ["onClick"], md = {
  key: 0,
  class: "w-24"
}, hd = {
  key: 0,
  class: "relative flex items-center group/inter-gap group/dur shrink-0"
}, gd = { class: "bg-white shadow rounded-full flex flex-col items-center justify-center absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 z-20 min-h-4.5 p-0.5 transition-all group-hover/dur:scale-150 group-hover/dur:bg-white group-hover/dur:text-gray-900" }, bd = {
  key: 0,
  class: "text-xs font-medium text-slate-500 px-2 whitespace-nowrap"
}, xd = {
  key: 1,
  class: "flex flex-col items-center justify-center text-gray-600"
}, Qo = 64, yd = 8, wd = 8, Cd = 32, kd = 42, $d = /* @__PURE__ */ ge({
  __name: "InterventionPeriod",
  props: {
    period: {},
    previousPeriod: {},
    nextPeriod: {}
  },
  emits: ["edit", "remove", "add-parallel"],
  setup(e, { emit: t }) {
    const n = e, o = t, {
      addTimepointToPeriod: i,
      removeTimepointFromPeriod: l,
      removeInterventionFromPeriod: s,
      hoveredTimepointId: a,
      hoveredTimepointPeriodId: d,
      setHoveredTimepoint: r,
      updateTimepointName: f,
      updatePeriod: y,
      updateIntervention: k,
      mode: m,
      periodsDataEntity: h,
      selectedAnchor: I,
      selectedInterventionTimepoints: b,
      toggleInterventionTimepointSelection: w,
      removeInterventionTimepoints: S,
      selectablePeriodIds: A,
      selectedTimepointNames: g,
      allTimepointNamesInSelectedPeriod: x,
      commonTimepointNamesInSelectedPeriods: T,
      selectedInterventionIds: _,
      selectedInterventionIdsByArm: W,
      expandableArmIds: U,
      getDefinitionUsageCount: z,
      getDefinitionById: M
    } = pt(), R = V(() => Fn(n.period.interventions)), F = V(() => Fn(n.period.timepoints)), L = V(() => b.value.length > 0);
    function N(fe) {
      return z(fe.definitionId) > 1;
    }
    function D(fe) {
      return M(fe.definitionId);
    }
    const X = V(() => {
      const fe = F.value;
      return fe.length === 0 ? null : fe[Math.max(0, fe.length - 2)]?.id ?? null;
    }), {
      isPeriodSelected: G,
      isPeriodHighlighted: q,
      canSelectPeriod: Q,
      canSelectAnyBranch: ce,
      canSelectBranch: be,
      isTimepointSelected: ye,
      isTimepointHighlighted: ve,
      isInterventionTimepointSelected: xe,
      getTimepointSelectable: Ae,
      handleTimepointCircleClick: Re,
      handlePeriodClick: Ie,
      handleBranchClick: le
    } = Mu({
      period: Tt(n, "period"),
      sortedInterventions: R,
      sortedTimepoints: F,
      mode: m,
      selectedAnchor: I,
      selectedInterventionTimepoints: b,
      selectablePeriodIds: A,
      selectedTimepointNames: g,
      allTimepointNamesInSelectedPeriod: x,
      commonTimepointNamesInSelectedPeriods: T,
      selectedInterventionIds: _,
      selectedInterventionIdsByArm: W,
      expandableArmIds: U,
      toggleInterventionTimepointSelection: w,
      removeInterventionTimepoints: S
    }), ue = B(null), ke = V(
      () => ue.value?.type === "period" ? "Delete period?" : "Delete intervention?"
    ), re = V(
      () => ue.value?.type === "period" ? "This will remove the entire period and its intervention." : "This will remove the intervention from this period."
    );
    function P() {
      ue.value && (ue.value.type === "period" ? (oe.user("Deleting period via last timepoint", { periodId: n.period.id }), o("remove")) : (oe.user("Deleting intervention via last timepoint", {
        periodId: n.period.id,
        interventionId: ue.value.id
      }), s(n.period.id, ue.value.id)), ue.value = null);
    }
    function O() {
      ue.value = null;
    }
    function c(fe) {
      ue.value = { type: "intervention", id: fe };
    }
    const {
      editingTimepointId: $,
      editingTimepointName: E,
      originalTimepointName: j,
      showRenameAllDialog: Y,
      pendingRenameNewName: ee,
      handleTimepointHover: de,
      handleTimepointLeave: ie,
      getTimepointSimilarityState: Ee,
      handleTimepointClick: me,
      handleSaveTimepointName: $e,
      handleConfirmRenameAll: vt,
      handleCancelRenameAll: mt,
      handleCancelEdit: Se,
      handleUpdateParticipantCount: Be
    } = Ou({
      period: Tt(n, "period"),
      allPeriods: h,
      hoveredTimepointId: a,
      hoveredTimepointPeriodId: d,
      setHoveredTimepoint: r,
      updateTimepointName: f,
      updatePeriod: y
    }), qe = B(/* @__PURE__ */ new Map());
    function Fe(fe) {
      me(fe), Ge(() => {
        const J = qe.value.get(fe);
        J?.focus(), J?.select();
      });
    }
    function Qe(fe) {
      fe.key === "Enter" ? $e() : fe.key === "Escape" && Se();
    }
    const fo = B(/* @__PURE__ */ new Map()), yn = B(/* @__PURE__ */ new Map()), wn = B(null);
    function po(fe, J) {
      J && typeof J == "object" ? fo.value.set(fe, J) : fo.value.delete(fe);
    }
    function vo(fe, J) {
      J instanceof HTMLElement ? yn.value.set(fe, J) : yn.value.delete(fe);
    }
    function Wi(fe) {
      fe instanceof HTMLElement ? wn.value = fe : wn.value = null;
    }
    const {
      editingDurationForSegment: Xi,
      durationOperator: mo,
      durationValue1: ho,
      durationValue2: go,
      durationUnit: bo,
      durationEditReferenceEl: qi,
      handleLineClick: xo,
      handleInterventionGapClick: Zi,
      handleSaveDuration: Yi,
      handleClearDuration: Ki,
      handleCancelDuration: Qi
    } = ru({
      period: Tt(n, "period"),
      previousPeriod: Tt(n, "previousPeriod"),
      nextPeriod: Tt(n, "nextPeriod"),
      sortedTimepoints: F,
      interventionGapLineRef: wn,
      lineSegmentRefs: yn,
      updatePeriod: y
    }), yo = V(() => Ue(n.period)?.duration ?? null);
    function wo(fe) {
      const J = F.value[fe];
      return J ? J.isStart ? F.value.length === 1 && R.value.length === 1 : J.isEnd ? F.value.length === 2 : F.value[fe + 1]?.isEnd === !0 : !1;
    }
    function Xt(fe) {
      oe.user("Adding timepoint to period", { periodId: n.period.id, afterTimepointId: fe }), i(n.period.id, fe);
    }
    function Co(fe) {
      if (F.value.find((te) => te.id === fe)?.isStart && F.value.length === 1) {
        ue.value = { type: "period" };
        return;
      }
      oe.user("Deleting timepoint from period", { periodId: n.period.id, timepointId: fe }), l(n.period.id, fe);
    }
    return (fe, J) => (v(), C("div", {
      class: Z(["flex items-center relative group/intervention transition-all", [
        p(m) !== "select" ? "" : p(G) || p(Q) || p(ce) || p(q) ? "cursor-pointer" : "opacity-40 pointer-events-none"
      ]]),
      onClick: J[25] || (J[25] = (te) => R.value.length === 1 && p(m) === "select" && (p(Q) || p(G)) ? p(Ie)() : void 0)
    }, [
      u("div", Ku, [
        R.value.length > 1 ? (v(), C("div", {
          key: 0,
          class: Z(["relative flex border bg-white pl-2 border-gray-600 rounded-lg", p(m) === "edit" ? "mt-10" : ""])
        }, [
          p(m) === "edit" ? (v(), C("div", Qu, [
            K(Xn, {
              onClick: J[0] || (J[0] = (te) => Xt(X.value))
            })
          ])) : H("", !0),
          p(m) === "edit" ? (v(), C("div", {
            key: 1,
            class: "absolute border-l-2 border-dashed border-[#555E69] opacity-30 pointer-events-none z-0",
            style: ne({
              right: "103px",
              top: "-26px",
              height: `${kd - Cd / 2 + wd + (R.value.length - 1) * (Qo + yd) + Qo / 2}px`
            })
          }, null, 4)) : H("", !0),
          K(Yu, {
            interventions: R.value,
            randomization: e.period.randomization,
            mode: p(m),
            "onUpdate:randomization": J[1] || (J[1] = (te) => p(y)(e.period.id, { randomization: te })),
            "onUpdate:bodyPartName": J[2] || (J[2] = (te, je) => p(k)(e.period.id, te, { bodyPartName: je })),
            onAdd: J[3] || (J[3] = (te) => o("add-parallel"))
          }, null, 8, ["interventions", "randomization", "mode"]),
          u("div", Ju, [
            (v(!0), C(se, null, pe(R.value, (te, je) => (v(), Ce(Zo, {
              key: te.id,
              intervention: te,
              definition: D(te),
              "sorted-timepoints": F.value,
              "branch-index": je,
              "total-branches": R.value.length,
              mode: p(m),
              "is-selected": p(xe)(te.id),
              "is-highlighted": p(q) && !p(G),
              "is-linked": N(te),
              "can-select": p(be)(te.id),
              "is-timepoint-selected": (we) => p(ye)(te.id, we),
              "is-timepoint-highlighted": (we) => p(ve)(te.id, we),
              "get-timepoint-similarity-state": p(Ee),
              "some-timepoint-hovered": p(a) !== null,
              "some-timepoint-selected": L.value,
              "timepoint-selectable": p(Ae)(te.id),
              "register-timepoint-circle-ref": po,
              "register-line-segment-ref": vo,
              onEdit: (we) => o("edit", te.id),
              onBranchClick: (we) => p(le)(te.id),
              onTimepointCircleClick: (we) => p(Re)(te.id, we),
              onAddTimepointBetween: Xt,
              onDeleteIntervention: (we) => c(te.id),
              onLineClick: p(xo),
              onTimepointHover: p(de),
              onTimepointLeave: p(ie),
              "onUpdate:participantCount": J[5] || (J[5] = (we, Ji) => p(Be)(we, Ji))
            }, {
              "add-parallel-button": Pe(() => [
                K(sn, {
                  onClick: J[4] || (J[4] = (we) => o("add-parallel"))
                })
              ]),
              _: 1
            }, 8, ["intervention", "definition", "sorted-timepoints", "branch-index", "total-branches", "mode", "is-selected", "is-highlighted", "is-linked", "can-select", "is-timepoint-selected", "is-timepoint-highlighted", "get-timepoint-similarity-state", "some-timepoint-hovered", "some-timepoint-selected", "timepoint-selectable", "onEdit", "onBranchClick", "onTimepointCircleClick", "onDeleteIntervention", "onLineClick", "onTimepointHover", "onTimepointLeave"]))), 128)),
            u("div", ed, [
              (v(!0), C(se, null, pe(F.value, (te, je) => (v(), C(se, {
                key: te.id + "-label"
              }, [
                u("div", td, [
                  u("div", nd, [
                    p($) === te.id ? Le((v(), C("input", {
                      key: 0,
                      ref_for: !0,
                      ref: (we) => {
                        we && qe.value.set(te.id, we);
                      },
                      "onUpdate:modelValue": J[6] || (J[6] = (we) => Io(E) ? E.value = we : null),
                      class: "absolute left-1/2 -translate-x-1/2 text-xs font-medium text-slate-900 bg-white border border-indigo-400 rounded px-1 py-0.5 outline-none ring-2 ring-indigo-200 w-20 text-center z-10",
                      onBlur: J[7] || (J[7] = (we) => p($e)()),
                      onKeydown: Qe,
                      onClick: J[8] || (J[8] = he(() => {
                      }, ["stop"]))
                    }, null, 544)), [
                      [_e, p(E)]
                    ]) : H("", !0),
                    u("button", {
                      class: Z([
                        "text-xs font-medium whitespace-nowrap transition-colors cursor-pointer",
                        p($) === te.id ? "invisible" : "text-slate-600 hover:text-indigo-600"
                      ]),
                      onClick: he((we) => p(m) === "edit" ? Fe(te.id) : void 0, ["stop"])
                    }, ae(te.name), 11, od),
                    p(m) === "edit" && wo(je) && p($) !== te.id ? (v(), C("button", {
                      key: 1,
                      class: "text-red-500 absolute -right-8 hover:text-red-700 flex hover:scale-125 opacity-0 group-hover/intervention:opacity-100 transition-all rounded-lg p-0.5",
                      title: "Delete Timepoint",
                      onClick: he((we) => Co(te.id), ["stop"])
                    }, [
                      K(dt)
                    ], 8, id)) : H("", !0)
                  ])
                ]),
                je < F.value.length - 1 ? (v(), C("div", ld)) : H("", !0)
              ], 64))), 128))
            ])
          ])
        ], 2)) : (v(), C("div", rd, [
          p(m) === "edit" && F.value.length > 1 ? (v(), C("div", sd, [
            K(sn, {
              onClick: J[9] || (J[9] = (te) => o("add-parallel"))
            })
          ])) : H("", !0),
          p(m) === "edit" && F.value.length > 1 ? (v(), C("div", ad, [
            K(Xn, {
              onClick: J[10] || (J[10] = (te) => Xt(X.value))
            })
          ])) : H("", !0),
          p(m) === "edit" && F.value.length > 1 ? (v(), C("div", ud)) : H("", !0),
          K(Zo, {
            intervention: R.value[0],
            definition: D(R.value[0]),
            "sorted-timepoints": F.value,
            "branch-index": 0,
            "total-branches": 1,
            mode: p(m),
            "is-selected": p(xe)(R.value[0].id),
            "is-highlighted": p(q) && !p(G),
            "is-linked": N(R.value[0]),
            "can-select": p(be)(R.value[0].id),
            "is-timepoint-selected": (te) => p(ye)(R.value[0].id, te),
            "is-timepoint-highlighted": (te) => p(ve)(R.value[0].id, te),
            "get-timepoint-similarity-state": p(Ee),
            "some-timepoint-hovered": p(a) !== null,
            "some-timepoint-selected": L.value,
            "timepoint-selectable": p(Ae)(R.value[0].id),
            "register-timepoint-circle-ref": po,
            "register-line-segment-ref": vo,
            onEdit: J[12] || (J[12] = (te) => o("edit", R.value[0].id)),
            onBranchClick: J[13] || (J[13] = (te) => p(le)(R.value[0].id)),
            onTimepointCircleClick: J[14] || (J[14] = (te) => p(Re)(R.value[0].id, te)),
            onAddTimepointBetween: Xt,
            onDeleteIntervention: J[15] || (J[15] = (te) => c(R.value[0].id)),
            onLineClick: p(xo),
            onTimepointHover: p(de),
            onTimepointLeave: p(ie),
            "onUpdate:participantCount": J[16] || (J[16] = (te, je) => p(Be)(te, je))
          }, {
            "add-parallel-button": Pe(() => [
              K(sn, {
                onClick: J[11] || (J[11] = (te) => o("add-parallel"))
              })
            ]),
            _: 1
          }, 8, ["intervention", "definition", "sorted-timepoints", "mode", "is-selected", "is-highlighted", "is-linked", "can-select", "is-timepoint-selected", "is-timepoint-highlighted", "get-timepoint-similarity-state", "some-timepoint-hovered", "some-timepoint-selected", "timepoint-selectable", "onLineClick", "onTimepointHover", "onTimepointLeave"])
        ])),
        R.value.length === 1 ? (v(), C("div", dd, [
          (v(!0), C(se, null, pe(F.value, (te, je) => (v(), C(se, {
            key: te.id + "-label"
          }, [
            u("div", cd, [
              u("div", fd, [
                p($) === te.id ? Le((v(), C("input", {
                  key: 0,
                  ref_for: !0,
                  ref: (we) => {
                    we && qe.value.set(te.id, we);
                  },
                  "onUpdate:modelValue": J[17] || (J[17] = (we) => Io(E) ? E.value = we : null),
                  class: "absolute left-1/2 -translate-x-1/2 text-xs font-medium text-slate-900 bg-white border border-indigo-400 rounded px-1 py-0.5 outline-none ring-2 ring-indigo-200 w-20 text-center z-10",
                  onBlur: J[18] || (J[18] = (we) => p($e)()),
                  onKeydown: Qe,
                  onClick: J[19] || (J[19] = he(() => {
                  }, ["stop"]))
                }, null, 544)), [
                  [_e, p(E)]
                ]) : H("", !0),
                u("button", {
                  class: Z([
                    "text-xs font-medium whitespace-nowrap transition-colors cursor-pointer",
                    p($) === te.id ? "invisible" : "text-slate-600 hover:text-indigo-600"
                  ]),
                  onClick: he((we) => p(m) === "edit" ? Fe(te.id) : void 0, ["stop"])
                }, ae(te.name), 11, pd),
                p(m) === "edit" && wo(je) && p($) !== te.id ? (v(), C("button", {
                  key: 1,
                  class: "text-red-500 absolute -right-8 hover:text-red-700 flex hover:scale-125 opacity-0 group-hover/intervention:opacity-100 transition-all rounded-lg p-0.5",
                  title: "Delete Timepoint",
                  onClick: he((we) => Co(te.id), ["stop"])
                }, [
                  K(dt)
                ], 8, vd)) : H("", !0)
              ])
            ]),
            je < F.value.length - 1 ? (v(), C("div", md)) : H("", !0)
          ], 64))), 128))
        ])) : H("", !0)
      ]),
      e.nextPeriod ? (v(), C("div", hd, [
        u("button", {
          ref: (te) => Wi(te),
          class: Z(["w-24 h-1 transition-all bg-transparent border-t-4 border-gray-600 relative flex items-center justify-center", p(m) === "edit" ? "cursor-pointer" : "cursor-default"]),
          onClick: J[20] || (J[20] = (te) => p(m) === "edit" ? p(Zi)() : void 0)
        }, [
          u("div", gd, [
            yo.value ? (v(), C("div", bd, ae(p(Dt)(yo.value)), 1)) : (v(), C("div", xd, [
              K(Wt)
            ]))
          ])
        ], 2)
      ])) : H("", !0),
      p(Xi) && p(m) === "edit" ? (v(), Ce(Ui, {
        key: 1,
        "reference-el": p(qi),
        "can-merge-duration": !1,
        operator: p(mo),
        value1: p(ho),
        value2: p(go),
        unit: p(bo),
        units: p(Hi),
        "onUpdate:operator": J[21] || (J[21] = (te) => mo.value = te),
        "onUpdate:value1": J[22] || (J[22] = (te) => ho.value = te),
        "onUpdate:value2": J[23] || (J[23] = (te) => go.value = te),
        "onUpdate:unit": J[24] || (J[24] = (te) => bo.value = te),
        onSave: p(Yi),
        onClear: p(Ki),
        onCancel: p(Qi)
      }, null, 8, ["reference-el", "operator", "value1", "value2", "unit", "units", "onSave", "onClear", "onCancel"])) : H("", !0),
      K(qn, {
        show: ue.value !== null,
        title: ke.value,
        message: re.value,
        variant: "danger",
        "confirm-text": "Delete",
        onConfirm: P,
        onCancel: O
      }, null, 8, ["show", "title", "message"]),
      K(qn, {
        show: p(Y),
        title: "Rename all matching timepoints?",
        message: `Rename all timepoints named '${p(j)}' to '${p(ee)}'?`,
        variant: "info",
        "confirm-text": "Rename All",
        "cancel-text": "Keep Unique",
        onConfirm: p(vt),
        onCancel: p(mt)
      }, null, 8, ["show", "message", "onConfirm", "onCancel"])
    ], 2));
  }
}), Id = {
  key: 0,
  class: "bg-white shadow rounded-full flex flex-col items-center justify-center absolute left-1/2 -translate-x-1/2 -translate-y-1/2 top-1/2 z-20 min-h-4.5 p-0.5 transition-all group-hover/dur:scale-150 group-hover/dur:bg-white group-hover/dur:text-gray-900"
}, Td = {
  key: 0,
  class: "text-xs font-medium text-slate-500 px-2 whitespace-nowrap"
}, Sd = {
  key: 1,
  class: "flex flex-col items-center justify-center text-gray-600"
}, Pd = {
  key: 1,
  class: "absolute w-full top-1/2 -translate-y-1/2 border-t-4 border-gray-600"
}, Jo = /* @__PURE__ */ ge({
  __name: "AnchorGapLine",
  props: {
    duration: {},
    mode: {},
    isClickable: { type: Boolean },
    fullWidth: { type: Boolean }
  },
  emits: ["click"],
  setup(e, { emit: t }) {
    const n = t;
    return (o, i) => e.isClickable ? (v(), C("button", {
      key: 0,
      class: Z(["h-1 bg-transparent border-t-4 border-gray-600 relative flex items-center justify-center group/dur", [e.fullWidth ? "w-full" : "w-24", e.mode === "edit" ? "cursor-pointer" : "cursor-default"]]),
      onClick: i[0] || (i[0] = (l) => n("click"))
    }, [
      e.duration || e.mode === "edit" ? (v(), C("div", Id, [
        e.duration ? (v(), C("div", Td, ae(p(Dt)(e.duration)), 1)) : e.mode === "edit" ? (v(), C("div", Sd, [
          K(Wt)
        ])) : H("", !0)
      ])) : H("", !0)
    ], 2)) : (v(), C("div", Pd));
  }
}), Ad = { class: "p-4 w-75 space-y-4" }, Ed = { class: "flex gap-2 pt-2" }, Od = /* @__PURE__ */ ge({
  __name: "ArmMenu",
  props: {
    armId: {},
    armName: {},
    referenceEl: {}
  },
  emits: ["close", "save", "delete"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = B(n.armName);
    Te(
      () => n.armName,
      (s) => {
        i.value = s;
      }
    );
    function l() {
      o("save", i.value.trim()), o("close");
    }
    return (s, a) => (v(), Ce(xn, {
      "reference-el": e.referenceEl,
      onClose: a[2] || (a[2] = (d) => s.$emit("close"))
    }, {
      default: Pe(() => [
        u("div", Ad, [
          u("div", null, [
            a[3] || (a[3] = u("label", {
              for: "arm-name",
              class: "block text-sm font-medium text-slate-700 mb-1"
            }, "Name", -1)),
            Le(u("input", {
              id: "arm-name",
              "onUpdate:modelValue": a[0] || (a[0] = (d) => i.value = d),
              type: "text",
              class: "h-9 w-full rounded-lg border border-slate-200 bg-slate-50/50 px-3 text-sm placeholder:text-slate-400 focus:bg-white focus:ring-2 focus:ring-slate-200",
              placeholder: "Enter name..."
            }, null, 512), [
              [_e, i.value]
            ])
          ]),
          u("div", Ed, [
            u("button", {
              class: "flex-1 h-9 rounded-lg bg-blue-600 text-white font-medium text-sm hover:bg-blue-700 transition-colors",
              onClick: l
            }, " Save "),
            u("button", {
              class: "h-9 px-4 rounded-lg bg-red-600 text-white font-medium text-sm hover:bg-red-700 transition-colors",
              onClick: a[1] || (a[1] = (d) => s.$emit("delete"))
            }, " Delete ")
          ])
        ])
      ]),
      _: 1
    }, 8, ["reference-el"]));
  }
}), Md = {}, Rd = {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 -960 960 960",
  width: "24px",
  fill: "currentColor"
};
function Dd(e, t) {
  return v(), C("svg", Rd, [...t[0] || (t[0] = [
    u("path", { d: "M543.43-68.71q-115.21 0-192.79-80.86-77.57-80.87-77.57-194.3v-26.78q-89.24-13.27-149.13-81.29-59.88-68.02-59.88-160.31v-237.79h127.17v-41.92h75.91v159.74h-75.91v-41.91h-51.26v161.67q0 70.66 49.62 119.69 49.63 49.02 120.16 49.02 70.54 0 120.23-49.02 49.7-49.03 49.7-119.69v-161.67h-51.42v41.91h-75.75v-159.74h75.75v41.92h127.17v237.79q0 91.74-59.2 159.59-59.21 67.86-147.41 81.54v27.25q0 82.19 55.55 140.72t139.1 58.53q79.68 0 137-58.2 57.33-58.2 57.33-141.21v-71.67q-36.12-11.95-59.26-43.06-23.13-31.12-23.13-71.1 0-50.11 34.99-85.19 34.99-35.07 85.27-35.07 50.28 0 85.27 35.07 35 35.08 35 85.19 0 39.98-23.14 71.1-23.13 31.11-59.25 43.06v71.83q0 114.64-79.12 194.9-79.13 80.26-191 80.26Zm264.97-428.3q13.38-13.26 13.38-32.73 0-19.46-13.26-32.84-13.26-13.38-32.73-13.38-19.46 0-32.84 13.26-13.38 13.26-13.38 32.73 0 19.46 13.26 32.84 13.26 13.38 32.73 13.38 19.46 0 32.84-13.26Zm-32.73-32.85Z" }, null, -1)
  ])]);
}
const Ld = /* @__PURE__ */ Me(Md, [["render", Dd]]), Qt = /* @__PURE__ */ ge({
  __name: "AddInterventionButton",
  setup(e) {
    return (t, n) => (v(), Ce(Ht, {
      label: "Add Intervention",
      title: "Add Intervention"
    }, {
      default: Pe(() => [
        K(Ld, { class: "size-4" })
      ]),
      _: 1
    }));
  }
});
function Bd(e) {
  const t = B(null), { durationOperator: n, durationValue1: o, durationValue2: i, durationUnit: l, hydrateDurationEditor: s } = ji(), a = V(() => t.value ? e.gapLineRefs.value.get(t.value) ?? null : null);
  function d(w) {
    return e.arm.value.anchorPoints?.find((S) => S.anchorId === w);
  }
  function r(w) {
    const S = e.sortedTimelineItems.value, A = S.findIndex((x) => x.type === "anchor" && x.data.id === w);
    if (A <= 0) return;
    const g = S[A - 1];
    return g?.type === "period" ? g.data : void 0;
  }
  function f(w) {
    const S = r(w);
    if (S)
      return Ue(S)?.duration;
  }
  function y(w) {
    return d(w)?.duration;
  }
  function k(w) {
    const S = r(w);
    S && (t.value = `before-${w}`, s(Ue(S)?.duration));
  }
  function m(w) {
    t.value = `after-${w}`, s(d(w)?.duration);
  }
  function h() {
    if (!t.value) return;
    const w = {
      operator: n.value,
      value1: o.value,
      value2: n.value === ze.BETWEEN ? i.value : void 0,
      unit: l.value
    };
    if (t.value.startsWith("after-")) {
      const S = t.value.slice(6);
      e.updateArmAnchorPoint(e.arm.value.id, S, { duration: w }), oe.user("Saved anchor after-gap duration", {
        anchorId: S,
        duration: Dt(w)
      });
    } else if (t.value.startsWith("before-")) {
      const S = t.value.slice(7), A = r(S);
      if (A) {
        const g = Ue(A);
        g && (e.updatePeriod(A.id, {
          timepoints: A.timepoints.map(
            (x) => x.id === g.id ? { ...x, duration: w } : x
          )
        }), oe.user("Saved anchor before-gap duration", {
          anchorId: S,
          duration: Dt(w)
        }));
      }
    }
    t.value = null;
  }
  function I() {
    if (t.value) {
      if (t.value.startsWith("after-")) {
        const w = t.value.slice(6);
        e.updateArmAnchorPoint(e.arm.value.id, w, { duration: void 0 }), oe.user("Cleared anchor after-gap duration", { anchorId: w });
      } else if (t.value.startsWith("before-")) {
        const w = t.value.slice(7), S = r(w);
        if (S) {
          const A = Ue(S);
          A && (e.updatePeriod(S.id, {
            timepoints: S.timepoints.map(
              (g) => g.id === A.id ? { ...g, duration: void 0 } : g
            )
          }), oe.user("Cleared anchor before-gap duration", { anchorId: w }));
        }
      }
      t.value = null;
    }
  }
  function b() {
    t.value = null;
  }
  return {
    editingGapKey: t,
    durationOperator: n,
    durationValue1: o,
    durationValue2: i,
    durationUnit: l,
    durationEditReferenceEl: a,
    getBeforeGapDuration: f,
    getAfterGapDuration: y,
    handleBeforeGapClick: k,
    handleAfterGapClick: m,
    handleSave: h,
    handleClear: I,
    handleCancel: b
  };
}
const Nd = ["data-arm-id"], zd = ["title"], _d = { class: "flex items-center" }, Vd = {
  key: 0,
  class: "w-0 overflow-visible relative z-20"
}, Fd = ["data-anchor-circle"], jd = {
  key: 1,
  class: "w-24 h-4 relative flex items-center shrink-0"
}, Hd = {
  key: 2,
  class: "w-0 overflow-visible relative z-20"
}, Ud = /* @__PURE__ */ ge({
  __name: "Arm",
  props: {
    arm: {},
    showArmName: { type: Boolean }
  },
  emits: ["delete"],
  setup(e) {
    const t = e, {
      getPeriodsForArm: n,
      removePeriod: o,
      updatePeriod: i,
      updateArm: l,
      openInterventionDrawer: s,
      mode: a,
      selectedAnchor: d,
      toggleAnchorSelection: r,
      anchors: f,
      selectedTimepointNames: y,
      updateArmAnchorPoint: k,
      anchorGaps: m,
      getDefinitionById: h
    } = pt(), I = V(() => n(t.arm.id)), b = V(() => [
      ...I.value.map((O) => ({ type: "period", data: O })),
      ...f.value.map((O) => ({ type: "anchor", data: O }))
    ].sort((O, c) => O.data.globalOrder.localeCompare(c.data.globalOrder)));
    function w(P) {
      const O = b.value[P - 1];
      if (O?.type === "period") return O.data;
    }
    function S(P) {
      const O = b.value[P + 1];
      if (O?.type === "period") return O.data;
    }
    function A(P) {
      return b.value[P + 1]?.type === "period";
    }
    function g(P) {
      return b.value[P - 1]?.type === "period";
    }
    const x = V(() => {
      const P = I.value[0]?.interventions[0];
      if (P)
        return h(P.definitionId)?.color;
    }), T = B(/* @__PURE__ */ new Map());
    function _(P, O) {
      const c = O instanceof HTMLElement ? O : O && typeof O == "object" && "$el" in O ? O.$el : null;
      c instanceof HTMLElement ? T.value.set(P, c) : T.value.delete(P);
    }
    const {
      editingGapKey: W,
      durationOperator: U,
      durationValue1: z,
      durationValue2: M,
      durationUnit: R,
      durationEditReferenceEl: F,
      getBeforeGapDuration: L,
      getAfterGapDuration: N,
      handleBeforeGapClick: D,
      handleAfterGapClick: X,
      handleSave: G,
      handleClear: q,
      handleCancel: Q
    } = Bd({
      arm: Tt(t, "arm"),
      sortedTimelineItems: b,
      gapLineRefs: T,
      updateArmAnchorPoint: k,
      updatePeriod: i
    });
    function ce(P) {
      return t.arm.anchorPoints?.find((O) => O.anchorId === P)?.participantCount ?? 0;
    }
    function be(P) {
      if (a.value === "select")
        return y.value.size > 0 ? !1 : d.value === null ? !0 : d.value.anchorId === P && d.value.armId === t.arm.id;
    }
    function ye(P) {
      return !1;
    }
    function ve(P) {
      a.value === "select" && (oe.user("Anchor circle clicked", { anchorId: P, armId: t.arm.id }), r(P, t.arm.id));
    }
    const xe = B(!1), Ae = B(null);
    function Re(P) {
      P && P !== t.arm.name && l(t.arm.id, { name: P });
    }
    function Ie(P) {
      s(t.arm.id, void 0, void 0, P);
    }
    function le(P) {
      s(t.arm.id, void 0, void 0, void 0, P);
    }
    function ue(P, O) {
      const c = P.interventions.find(($) => $.id === O);
      s(t.arm.id, P.id, c);
    }
    function ke(P) {
      oe.user("Remove period clicked", { periodId: P, armId: t.arm.id }), o(P);
    }
    function re(P) {
      s(t.arm.id, P);
    }
    return (P, O) => (v(), C("div", {
      class: "flex items-center py-8",
      "data-arm-id": e.arm.id
    }, [
      u("button", {
        ref_key: "armNameButtonRef",
        ref: Ae,
        class: Z(["text-xs w-11 truncate font-medium text-slate-600 mr-2 px-1.5 py-0.5 rounded transition-colors", p(a) === "edit" ? "hover:bg-slate-100 cursor-pointer" : "cursor-default"]),
        onClick: O[0] || (O[0] = he((c) => p(a) === "edit" ? xe.value = !0 : void 0, ["stop"])),
        title: e.arm.name
      }, ae(e.arm.name), 11, zd),
      u("div", _d, [
        (v(!0), C(se, null, pe(b.value, (c, $) => (v(), C(se, {
          key: c.data.id
        }, [
          c.type === "period" ? (v(), C(se, { key: 0 }, [
            K($d, {
              period: c.data,
              "previous-period": w($),
              "next-period": S($),
              onEdit: (E) => ue(c.data, E),
              onRemove: (E) => ke(c.data.id),
              onAddParallel: (E) => re(c.data.id)
            }, null, 8, ["period", "previous-period", "next-period", "onEdit", "onRemove", "onAddParallel"]),
            p(a) === "edit" && $ === b.value.length - 1 ? (v(), C("div", Vd, [
              K(Qt, {
                class: "absolute top-1/2 -translate-y-1/2",
                style: { left: "44px" },
                onClick: Ie
              })
            ])) : H("", !0)
          ], 64)) : c.type === "anchor" ? (v(), C("div", {
            key: 1,
            class: "flex items-center shrink-0",
            style: ne({ marginLeft: `${p(m).get(`${c.data.id}-${e.arm.id}`) ?? 0}px` })
          }, [
            $ > 0 ? (v(), C("div", {
              key: 0,
              class: "h-4 relative flex items-center shrink-0",
              style: ne({
                width: `${96 + (p(m).get(`${c.data.id}-${e.arm.id}`) ?? 0)}px`,
                marginLeft: `-${p(m).get(`${c.data.id}-${e.arm.id}`) ?? 0}px`
              })
            }, [
              K(Jo, {
                ref_for: !0,
                ref: (E) => _(`before-${c.data.id}`, E),
                duration: p(L)(c.data.id),
                mode: p(a),
                "is-clickable": g($),
                "full-width": !0,
                onClick: (E) => p(a) === "edit" ? p(D)(c.data.id) : void 0
              }, null, 8, ["duration", "mode", "is-clickable", "onClick"]),
              p(a) === "edit" && c.data.type === "followup" ? (v(), C(se, { key: 0 }, [
                O[7] || (O[7] = u("div", {
                  class: "absolute left-1/2 -translate-x-1/2 w-0 border-l-2 border-dashed border-[#555E69] opacity-40 pointer-events-none z-10",
                  style: { top: "-28px", height: "36px" }
                }, null, -1)),
                K(Qt, {
                  class: "absolute left-1/2 -translate-x-1/2 z-30",
                  style: { top: "-44px" },
                  onClick: (E) => le(c.data.globalOrder)
                }, null, 8, ["onClick"])
              ], 64)) : H("", !0)
            ], 4)) : H("", !0),
            u("div", {
              "data-anchor-circle": c.data.id,
              class: "relative flex items-center justify-center"
            }, [
              K(Wn, {
                "has-exposure": !0,
                "show-arrow": !1,
                color: x.value ?? "#94a3b8",
                "is-baseline": !0,
                "can-edit-count": p(a) === "edit",
                "participant-count": ce(c.data.id),
                "is-selected": p(d)?.anchorId === c.data.id && p(d)?.armId === e.arm.id,
                "is-selectable": be(c.data.id),
                "is-highlighted": ye(c.data.id),
                onClick: (E) => ve(c.data.id),
                "onUpdate:participantCount": (E) => p(k)(e.arm.id, c.data.id, { participantCount: E })
              }, null, 8, ["color", "can-edit-count", "participant-count", "is-selected", "is-selectable", "is-highlighted", "onClick", "onUpdate:participantCount"])
            ], 8, Fd),
            $ < b.value.length - 1 ? (v(), C("div", jd, [
              K(Jo, {
                ref_for: !0,
                ref: (E) => _(`after-${c.data.id}`, E),
                duration: p(N)(c.data.id),
                mode: p(a),
                "is-clickable": A($),
                onClick: (E) => p(a) === "edit" ? p(X)(c.data.id) : void 0
              }, null, 8, ["duration", "mode", "is-clickable", "onClick"])
            ])) : H("", !0),
            p(a) === "edit" && (c.data.type === "baseline" || c.data.type === "followup") && $ === b.value.length - 1 ? (v(), C("div", Hd, [
              K(Qt, {
                onClick: (E) => Ie(c.data.globalOrder)
              }, null, 8, ["onClick"])
            ])) : H("", !0)
          ], 4)) : H("", !0)
        ], 64))), 128)),
        b.value.length === 0 && p(a) === "edit" ? (v(), Ce(Qt, {
          key: 0,
          onClick: Ie
        })) : H("", !0),
        O[8] || (O[8] = u("div", {
          "data-arm-end": "",
          class: "w-0 shrink-0"
        }, null, -1))
      ]),
      xe.value && p(a) === "edit" ? (v(), Ce(Od, {
        key: 0,
        "arm-id": e.arm.id,
        "arm-name": e.arm.name,
        "reference-el": Ae.value,
        onClose: O[1] || (O[1] = (c) => xe.value = !1),
        onSave: Re,
        onDelete: O[2] || (O[2] = (c) => P.$emit("delete"))
      }, null, 8, ["arm-id", "arm-name", "reference-el"])) : H("", !0),
      p(W) !== null ? (v(), Ce(Ui, {
        key: 1,
        "reference-el": p(F),
        "can-merge-duration": !1,
        operator: p(U),
        value1: p(z),
        value2: p(M),
        unit: p(R),
        units: p(Hi),
        "onUpdate:operator": O[3] || (O[3] = (c) => U.value = c),
        "onUpdate:value1": O[4] || (O[4] = (c) => z.value = c),
        "onUpdate:value2": O[5] || (O[5] = (c) => M.value = c),
        "onUpdate:unit": O[6] || (O[6] = (c) => R.value = c),
        onSave: p(G),
        onClear: p(q),
        onCancel: p(Q)
      }, null, 8, ["reference-el", "operator", "value1", "value2", "unit", "units", "onSave", "onClear", "onCancel"])) : H("", !0)
    ], 8, Nd));
  }
}), Gd = { class: "flex items-center w-full" }, Wd = { class: "relative flex items-center w-full gap-48" }, Xd = { class: "flex flex-col items-center z-10" }, qd = /* @__PURE__ */ ge({
  __name: "PopulationSet",
  props: {
    population: {}
  },
  setup(e) {
    const t = e, {
      removePopulation: n,
      updatePopulation: o,
      addArm: i,
      removeArm: l,
      getPeriodsForArm: s,
      armsDataEntity: a,
      anchors: d,
      mode: r,
      openPopulationDrawer: f
    } = pt(), y = B(null), k = B(null), m = B(null), h = V(() => y.value?.$el?.querySelector(".size-48") ?? null);
    Te(
      () => t.population.arms?.length,
      () => {
        Ge(() => {
          m.value?.recalculate();
        });
      }
    );
    const I = V(() => !t.population.arms || t.population.arms.length === 0 ? !1 : t.population.arms.some((A) => s(A.id).length > 0)), b = V(() => {
      const A = d.value.find((g) => g.type === "baseline");
      return A ? a.value.filter((g) => g.populationId === t.population.id).reduce((g, x) => {
        const T = x.anchorPoints.find((_) => _.anchorId === A.id);
        return g + (T?.participantCount ?? 0);
      }, 0) : 0;
    });
    function w() {
      oe.user("Clicked Add Arm", { parentId: t.population.id }), i({
        id: Date.now().toString(),
        name: "",
        participantsCount: 0,
        populationId: t.population.id,
        anchorPoints: []
      });
    }
    function S(A) {
      oe.user("Clicked Delete Arm", { armId: A, parentId: t.population.id }), l(A);
    }
    return (A, g) => (v(), C("div", Gd, [
      u("div", Wd, [
        u("div", Xd, [
          K(pr, {
            ref_key: "populationIconRef",
            ref: y,
            name: e.population.name,
            count: b.value,
            color: e.population.color,
            "show-delete": p(r) === "edit",
            onDelete: g[0] || (g[0] = () => {
              p(oe).user("Clicked Delete Population", { id: e.population.id }), p(n)(e.population.id);
            }),
            onClick: g[1] || (g[1] = () => {
              p(r) === "edit" && (p(oe).user("Opened Population Drawer", { id: e.population.id }), p(f)(e.population.id));
            })
          }, null, 8, ["name", "count", "color", "show-delete"])
        ]),
        K(Ka, {
          ref_key: "splittingArrowRef",
          ref: m,
          "population-icon-ref": h.value,
          "arms-container-ref": k.value,
          "arm-count": e.population.arms?.length ?? 1,
          color: e.population.color,
          "population-id": e.population.id,
          randomization: e.population.randomization,
          "arm-labels": e.population.arms?.map((x) => x.name) ?? [],
          "show-add-arm": p(r) === "edit",
          "onUpdate:randomization": g[2] || (g[2] = (x) => p(o)(e.population.id, { randomization: x })),
          onAddArm: w
        }, null, 8, ["population-icon-ref", "arms-container-ref", "arm-count", "color", "population-id", "randomization", "arm-labels", "show-add-arm"]),
        u("div", {
          ref_key: "armsContainerRef",
          ref: k,
          class: Z(e.population.arms && e.population.arms.length > 1 ? "space-y-24" : "")
        }, [
          (v(!0), C(se, null, pe(e.population.arms, (x, T) => (v(), Ce(Ud, {
            key: x.id,
            arm: x,
            "show-arm-name": I.value && e.population.arms && e.population.arms.length > 1,
            onDelete: (_) => S(x.id)
          }, null, 8, ["arm", "show-arm-name", "onDelete"]))), 128))
        ], 2)
      ])
    ]));
  }
});
function Zd(e) {
  const { containerRef: t, anchors: n, periodsDataEntity: o, anchorGaps: i, scale: l } = e, s = B(/* @__PURE__ */ new Map()), a = B(0), d = B(0), r = B(0), f = B(0), y = V(() => {
    let I = f.value > 0 ? f.value : r.value;
    if (s.value.size > 0) {
      const b = Math.max(...s.value.values());
      I = Math.max(I, b);
    }
    return I + 100;
  });
  async function k() {
    if (await Ge(), !t.value) return;
    const I = l.value, b = t.value.getBoundingClientRect(), w = /* @__PURE__ */ new Map(), S = /* @__PURE__ */ new Map(), A = Pt(n.value), g = /* @__PURE__ */ new Map();
    for (const x of A) {
      const T = t.value.querySelectorAll(
        `[data-anchor-circle="${x.id}"]`
      ), _ = [];
      for (const W of T) {
        const z = W.closest("[data-arm-id]")?.getAttribute("data-arm-id");
        if (!z) continue;
        const M = W.getBoundingClientRect(), R = (M.left - b.left + M.width / 2) / I;
        let F = 0;
        for (const D of A) {
          if (D.globalOrder.localeCompare(x.globalOrder) > 0) break;
          F += i.value.get(`${D.id}-${z}`) ?? 0;
        }
        const L = R - F, N = g.get(z) ?? 0;
        _.push({ armId: z, adjustedX: L + N });
      }
      if (_.length > 0) {
        const W = Math.max(..._.map((U) => U.adjustedX));
        w.set(x.id, W);
        for (const { armId: U, adjustedX: z } of _) {
          const M = Math.max(0, W - z);
          S.set(`${x.id}-${U}`, M), g.set(U, (g.get(U) ?? 0) + M);
        }
      }
    }
    s.value = w, i.value = S;
  }
  async function m() {
    if (await Ge(), !t.value) return;
    const I = l.value, b = t.value.getBoundingClientRect();
    d.value = b.height / I, r.value = b.width / I;
    const w = t.value.querySelector(".absolute.top-5");
    a.value = w ? (w.getBoundingClientRect().bottom - b.top) / I : 50;
    const S = t.value.querySelectorAll(
      "[data-arm-end]"
    );
    let A = 0;
    for (const g of S) {
      const x = g.getBoundingClientRect();
      A = Math.max(A, (x.left - b.left) / I);
    }
    f.value = A, await k();
  }
  let h = null;
  return rt(() => {
    m(), t.value && (h = new ResizeObserver(m), h.observe(t.value));
  }), jt(() => {
    h?.disconnect();
  }), Te(n, k, { deep: !0 }), Te(o, k, { deep: !0 }), {
    anchorLinePositions: s,
    pillRowBottom: a,
    containerHeight: d,
    containerWidth: r,
    armEndMaxX: f,
    addFollowUpButtonLeft: y,
    measureLayout: m
  };
}
const Yd = { class: "flex-1" }, Kd = ["onClick"], Qd = {
  key: 1,
  class: "line-clamp-2"
}, Jd = ["onClick"], ec = {
  key: 1,
  class: "w-30"
}, tc = {
  key: 0,
  class: "flex items-center gap-4 mt-24"
}, nc = /* @__PURE__ */ ge({
  __name: "Population",
  setup(e) {
    const {
      populations: t,
      addPopulation: n,
      mode: o,
      anchors: i,
      addAnchor: l,
      removeAnchor: s,
      updateAnchor: a,
      periodsDataEntity: d,
      anchorGaps: r,
      scale: f
    } = pt(), y = V(() => Pt(i.value)), k = B(null), m = B(/* @__PURE__ */ new Map());
    function h(z, M) {
      z ? m.value.set(M, z) : m.value.delete(M);
    }
    const {
      anchorLinePositions: I,
      pillRowBottom: b,
      containerHeight: w,
      addFollowUpButtonLeft: S,
      measureLayout: A
    } = Zd({
      containerRef: k,
      anchors: i,
      periodsDataEntity: d,
      anchorGaps: r,
      scale: f
    });
    Te(
      t,
      (z) => {
        oe.computed("Populations updated", {
          count: z.length,
          totalArms: z.reduce((M, R) => M + (R.arms?.length || 1), 0)
        }), A();
      },
      { deep: !0 }
    );
    const g = B(null), x = B(""), T = B(null);
    function _(z) {
      const M = i.value.find((R) => R.id === z);
      x.value = M?.name ?? "", g.value = z, Ge(() => {
        T.value?.focus(), T.value?.select();
      });
    }
    function W() {
      const z = x.value.trim();
      z && g.value !== null && a(g.value, { name: z }), g.value = null;
    }
    function U() {
      oe.user("Clicked Add Population"), n({ id: Date.now().toString(), name: "" });
    }
    return (z, M) => (v(), C("div", null, [
      u("div", null, [
        u("div", {
          class: "flex items-start relative",
          ref_key: "populationsContainerRef",
          ref: k
        }, [
          u("div", Yd, [
            (v(!0), C(se, null, pe(p(t), (R) => (v(), C("div", {
              key: R.id,
              class: "border-b border-slate-300 pt-24 pb-8"
            }, [
              K(qd, { population: R }, null, 8, ["population"])
            ]))), 128))
          ]),
          (v(!0), C(se, null, pe(y.value, (R) => (v(), C(se, {
            key: R.id
          }, [
            p(I).get(R.id) !== void 0 ? (v(), C(se, { key: 0 }, [
              u("div", {
                class: "absolute pointer-events-none",
                style: ne({
                  left: `${p(I).get(R.id) - 1}px`,
                  top: `${p(b) + 20}px`,
                  width: "2px",
                  height: `${p(w) - p(b) - 20}px`,
                  background: "repeating-linear-gradient(to bottom, #555e69 0, #555e69 10px, transparent 10px, transparent 20px)"
                })
              }, null, 4),
              u("div", {
                ref_for: !0,
                ref: (F) => h(F, R.id),
                class: Z([
                  "absolute top-5 -translate-x-1/2 rounded-full font-semibold bg-white drop-shadow-md px-3.5 py-3 z-10 uppercase flex items-center gap-2",
                  p(o) === "edit" && g.value !== R.id ? "cursor-pointer hover:bg-slate-50" : "cursor-default"
                ]),
                style: ne({ left: `${p(I).get(R.id)}px` }),
                onClick: (F) => p(o) === "edit" && g.value !== R.id ? _(R.id) : void 0
              }, [
                g.value === R.id ? Le((v(), C("input", {
                  key: 0,
                  ref_for: !0,
                  ref: (F) => {
                    F && (T.value = F);
                  },
                  "onUpdate:modelValue": M[0] || (M[0] = (F) => x.value = F),
                  class: "bg-transparent outline-none border-b-2 border-indigo-400 text-center font-semibold uppercase w-full min-w-16",
                  onBlur: M[1] || (M[1] = (F) => W()),
                  onKeydown: [
                    M[2] || (M[2] = Et((F) => W(), ["enter"])),
                    M[3] || (M[3] = Et((F) => g.value = null, ["escape"]))
                  ],
                  onClick: M[4] || (M[4] = he(() => {
                  }, ["stop"]))
                }, null, 544)), [
                  [_e, x.value]
                ]) : (v(), C("span", Qd, ae(R.name), 1)),
                p(o) === "edit" && R.type === "followup" && g.value !== R.id ? (v(), C("span", {
                  key: 2,
                  class: "text-slate-400 hover:text-red-500 transition-colors text-xs leading-none",
                  title: "Remove Longitudinal time point",
                  onClick: he((F) => p(s)(R.id), ["stop"])
                }, "✕", 8, Jd)) : H("", !0)
              ], 14, Kd)
            ], 64)) : H("", !0)
          ], 64))), 128)),
          p(o) === "edit" && p(t).length > 0 ? (v(), C(se, { key: 0 }, [
            p(w) > 0 ? (v(), C("div", {
              key: 0,
              class: "absolute pointer-events-none z-0",
              style: ne({
                left: `${p(S) - 1}px`,
                top: `${p(b) + 20}px`,
                width: "2px",
                height: `${p(w) - p(b) - 20}px`,
                background: "repeating-linear-gradient(to bottom, #cbd5e1 0, #cbd5e1 8px, transparent 8px, transparent 16px)"
              })
            }, null, 4)) : H("", !0),
            K(Ht, {
              label: "Add longitudinal point / Follow-up",
              title: "Add longitudinal point / Follow-up",
              class: "absolute top-11 z-10",
              style: ne({ left: `${p(S) - 16}px` }),
              onClick: M[5] || (M[5] = (R) => p(l)("followup"))
            }, {
              default: Pe(() => [
                K(Wt, { class: "size-4" })
              ]),
              _: 1
            }, 8, ["style"])
          ], 64)) : H("", !0),
          p(t).length ? H("", !0) : (v(), C("div", ec))
        ], 512)
      ]),
      p(o) === "edit" ? (v(), C("div", tc, [
        u("button", {
          class: "size-48 rounded-full flex flex-col items-center justify-center gap-4 bg-gray-100 border-2 border-dashed border-gray-300 text-slate-400 hover:bg-gray-200 hover:border-slate-400 hover:text-slate-500 hover:scale-105 transition-all cursor-pointer",
          title: "Add Population",
          onClick: U
        }, [
          K($i),
          K(oo, { class: "size-5" })
        ])
      ])) : H("", !0)
    ]));
  }
}), oc = {}, ic = { class: "shrink-0 relative border-gray-200 rounded-full border-x-3 mr-10 mt-5" };
function lc(e, t) {
  return v(), C("div", ic, [...t[0] || (t[0] = [
    u("div", { class: "absolute -left-15 top-0 rounded-full font-semibold bg-white drop-shadow-md px-3.5 py-3 whitespace-nowrap" }, " STUDY START ", -1)
  ])]);
}
const rc = /* @__PURE__ */ Me(oc, [["render", lc]]), sc = {
  key: 0,
  class: "absolute inset-y-0 right-0 z-50 w-110 max-w-full bg-white border-l border-slate-200 shadow-xl flex flex-col"
}, ac = { class: "flex items-center justify-between border-b border-slate-200" }, uc = {
  key: 0,
  class: "px-4 py-3 text-sm font-semibold text-slate-800"
}, dc = { class: "flex-1 overflow-y-auto p-4" }, cc = {
  key: 0,
  class: "border-t border-slate-200 px-4 py-3"
}, Gi = /* @__PURE__ */ ge({
  __name: "DrawerPanel",
  props: {
    show: { type: Boolean },
    title: {}
  },
  emits: ["close"],
  setup(e) {
    return (t, n) => (v(), Ce(ol, {
      "enter-active-class": "transition-transform duration-300 ease-out",
      "enter-from-class": "translate-x-full",
      "enter-to-class": "translate-x-0",
      "leave-active-class": "transition-transform duration-200 ease-in",
      "leave-from-class": "translate-x-0",
      "leave-to-class": "translate-x-full"
    }, {
      default: Pe(() => [
        e.show ? (v(), C("div", sc, [
          u("div", ac, [
            at(t.$slots, "header", {}, () => [
              e.title ? (v(), C("h2", uc, ae(e.title), 1)) : H("", !0)
            ]),
            u("button", {
              class: "size-8 mr-2 flex items-center justify-center rounded-lg text-slate-400 hover:text-slate-600 hover:bg-slate-100 transition-colors cursor-pointer shrink-0",
              onClick: n[0] || (n[0] = (o) => t.$emit("close"))
            }, [
              K(dt)
            ])
          ]),
          u("div", dc, [
            at(t.$slots, "default")
          ]),
          t.$slots.footer ? (v(), C("div", cc, [
            at(t.$slots, "footer")
          ])) : H("", !0)
        ])) : H("", !0)
      ]),
      _: 3
    }));
  }
}), fc = {}, pc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor"
};
function vc(e, t) {
  return v(), C("svg", pc, [...t[0] || (t[0] = [
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15M14.25 3.104c.251.023.501.05.75.082M19.8 15a2.25 2.25 0 01.45 1.317c0 1.02-.71 1.933-1.757 2.028a48.18 48.18 0 01-3.493.248 48.18 48.18 0 01-3.493-.248C4.91 17.98 4.2 17.067 4.2 16.047a2.25 2.25 0 01.45-1.317L9 9.75m10.8 5.25H4.2"
    }, null, -1)
  ])]);
}
const mc = /* @__PURE__ */ Me(fc, [["render", vc]]), hc = {}, gc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor"
};
function bc(e, t) {
  return v(), C("svg", gc, [...t[0] || (t[0] = [
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 3v17.25m0 0c-1.472 0-2.882.265-4.185.75M12 20.25c1.472 0 2.882.265 4.185.75M18.75 4.97A48.416 48.416 0 0012 4.5c-2.291 0-4.545.16-6.75.47m13.5 0c1.01.143 2.01.317 3 .52m-3-.52l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.988 5.988 0 01-2.031.352 5.988 5.988 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L18.75 4.97zm-16.5.52c.99-.203 1.99-.377 3-.52m0 0l2.62 10.726c.122.499-.106 1.028-.589 1.202a5.989 5.989 0 01-2.031.352 5.989 5.989 0 01-2.031-.352c-.483-.174-.711-.703-.59-1.202L5.25 4.97z"
    }, null, -1)
  ])]);
}
const xc = /* @__PURE__ */ Me(hc, [["render", bc]]), yc = {}, wc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor"
};
function Cc(e, t) {
  return v(), C("svg", wc, [...t[0] || (t[0] = [
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
    }, null, -1)
  ])]);
}
const kc = /* @__PURE__ */ Me(yc, [["render", Cc]]), $c = {}, Ic = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor"
};
function Tc(e, t) {
  return v(), C("svg", Ic, [...t[0] || (t[0] = [
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6.75 3v3a3 3 0 003 3h.75a3 3 0 003-3V3"
    }, null, -1),
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M6 3h6"
    }, null, -1),
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.75 9v3.75A5.25 5.25 0 0015 18v0a5.25 5.25 0 005.25-5.25V11.25"
    }, null, -1)
  ])]);
}
const Sc = /* @__PURE__ */ Me($c, [["render", Tc]]), Pc = {}, Ac = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor"
};
function Ec(e, t) {
  return v(), C("svg", Ac, [...t[0] || (t[0] = [
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0z"
    }, null, -1),
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z"
    }, null, -1),
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M12 13.5v3m-1.5-1.5h3"
    }, null, -1)
  ])]);
}
const Oc = /* @__PURE__ */ Me(Pc, [["render", Ec]]), Mc = {}, Rc = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "1.5",
  stroke: "currentColor"
};
function Dc(e, t) {
  return v(), C("svg", Rc, [...t[0] || (t[0] = [
    u("path", {
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M19.5 4.5l-1.5 1.5m0 0l-3-3m3 3l-3 3m3-3H21M3 21l5.25-5.25m0 0l6-6m-6 6l-1.5-1.5m1.5 1.5l1.5 1.5M8.25 15.75L14.25 9.75m0 0l1.5 1.5m-1.5-1.5l-1.5-1.5"
    }, null, -1)
  ])]);
}
const Lc = /* @__PURE__ */ Me(Mc, [["render", Dc]]), Bc = { class: "flex flex-col gap-1 mb-1" }, Nc = { class: "w-3.5 text-center text-[10px] font-bold text-slate-400 shrink-0" }, zc = { class: "flex-1 flex items-center gap-1.5 bg-slate-100 border border-slate-200 rounded-md px-2 py-1" }, _c = { class: "flex items-center gap-1 shrink-0 bg-white border border-slate-200 rounded px-1.5 py-0.5" }, Vc = { class: "text-[10px] font-semibold text-slate-500 whitespace-nowrap" }, Fc = ["value", "placeholder", "onInput"], jc = ["onClick"], Hc = { class: "flex gap-1" }, Uc = ["onClick"], ei = /* @__PURE__ */ ge({
  __name: "ItemBuilder",
  props: {
    items: {}
  },
  emits: ["add", "update", "remove"],
  setup(e) {
    const t = [
      {
        key: rn.DEVICE,
        label: "Medical device",
        icon: Sc,
        placeholder: "Device name…"
      },
      {
        key: rn.PROCEDURE,
        label: "Medical procedure",
        icon: Oc,
        placeholder: "Procedure name…"
      },
      {
        key: rn.MEDICATION,
        label: "Medication",
        icon: Lc,
        placeholder: "Medication name…"
      }
    ];
    function n(o) {
      return t.find((i) => i.key === o);
    }
    return (o, i) => (v(), C("div", null, [
      u("div", Bc, [
        (v(!0), C(se, null, pe(e.items, (l, s) => (v(), C("div", {
          key: l.id,
          class: "flex items-center gap-1"
        }, [
          u("div", Nc, ae(s > 0 ? "+" : ""), 1),
          u("div", zc, [
            u("div", _c, [
              (v(), Ce(di(n(l.type).icon), { class: "size-3 text-slate-500" })),
              u("span", Vc, ae(n(l.type).label), 1)
            ]),
            u("input", {
              value: l.name,
              placeholder: n(l.type).placeholder,
              class: "flex-1 bg-transparent border-none outline-none text-xs text-slate-800 min-w-0",
              onInput: (a) => o.$emit("update", l.id, a.target.value)
            }, null, 40, Fc)
          ]),
          u("button", {
            class: "p-0.5 text-slate-400 hover:text-slate-700 cursor-pointer shrink-0 transition-colors",
            onClick: (a) => o.$emit("remove", l.id)
          }, [...i[0] || (i[0] = [
            u("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              fill: "none",
              viewBox: "0 0 24 24",
              "stroke-width": "2",
              stroke: "currentColor",
              class: "size-3"
            }, [
              u("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                d: "M6 18L18 6M6 6l12 12"
              })
            ], -1)
          ])], 8, jc)
        ]))), 128))
      ]),
      u("div", Hc, [
        (v(), C(se, null, pe(t, (l) => u("button", {
          key: l.key,
          class: "flex-1 flex items-center justify-center gap-1 bg-white border border-dashed border-slate-300 rounded-md px-2 py-1.5 text-[11px] text-slate-400 hover:border-orange-400 hover:text-orange-500 transition-all cursor-pointer",
          onClick: (s) => o.$emit("add", l.key)
        }, [
          i[1] || (i[1] = u("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            fill: "none",
            viewBox: "0 0 24 24",
            "stroke-width": "2",
            stroke: "currentColor",
            class: "size-3"
          }, [
            u("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              d: "M12 4.5v15m7.5-7.5h-15"
            })
          ], -1)),
          u("span", null, ae(l.label), 1)
        ], 8, Uc)), 64))
      ])
    ]));
  }
}), Gc = {
  key: 0,
  class: "text-[11px] text-slate-400 italic leading-snug"
}, Wc = {
  key: 1,
  class: "flex items-center gap-1 mt-1"
}, Xc = { class: "space-y-0" }, qc = {
  key: 0,
  class: "grid grid-cols-2 gap-1 mb-1"
}, Zc = { class: "text-[10px] text-slate-400" }, Yc = {
  key: 1,
  class: "flex flex-col gap-0.5 pt-1"
}, Kc = ["onClick"], Qc = { class: "flex items-center gap-2" }, Jc = { class: "text-xs text-slate-800" }, ef = { class: "flex items-center gap-1" }, tf = {
  key: 0,
  class: "text-[9px] font-bold uppercase tracking-wide text-slate-500 bg-slate-100 border border-slate-200 rounded px-1 py-px"
}, nf = {
  key: 0,
  class: "text-xs text-slate-400 px-1 py-2"
}, of = { class: "flex flex-col gap-0.5" }, lf = ["onClick"], rf = { class: "text-[10px] text-slate-400" }, sf = { class: "grid grid-cols-2 gap-1 mb-1" }, af = {
  key: 0,
  class: "flex flex-col gap-0.5 mt-1"
}, uf = ["onClick"], df = { class: "text-xs" }, cf = { class: "text-[10px] text-slate-400" }, ff = {
  key: 1,
  class: "mt-1"
}, pf = { class: "flex items-center justify-between mb-1.5" }, vf = { class: "flex items-center gap-1.5" }, mf = {
  key: 2,
  class: "flex flex-col gap-0.5"
}, hf = { class: "flex items-center justify-between mb-1.5" }, gf = { class: "flex items-center gap-1.5" }, bf = {
  key: 3,
  class: "flex flex-col gap-0.5"
}, xf = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "3",
  stroke: "white",
  class: "size-2.5"
}, yf = ["onClick"], wf = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  "stroke-width": "3",
  stroke: "white",
  class: "size-2.5"
}, Cf = { class: "text-[10px] text-slate-400" }, kf = { class: "flex gap-1.5 flex-wrap" }, $f = ["onClick"], If = {
  key: 0,
  class: "flex gap-1.5"
}, Tf = ["disabled"], Sf = {
  key: 1,
  class: "flex gap-1.5"
}, Pf = { class: "flex flex-col gap-2" }, Af = /* @__PURE__ */ ge({
  __name: "InterventionMenu",
  props: {
    show: { type: Boolean },
    armId: {},
    intervention: {},
    definition: {}
  },
  emits: ["close", "save", "import", "delete"],
  setup(e, { emit: t }) {
    const n = e, o = t, { periodsDataEntity: i, getDefinitionUsageCount: l, getDefinitionById: s, interventionDefinitions: a } = pt(), d = [
      {
        key: De.EXPERIMENTAL,
        label: "Experimental",
        desc: "The intervention being tested",
        icon: mc
      },
      {
        key: De.COMPARATOR,
        label: "Comparator",
        desc: "The control or reference intervention",
        icon: xc
      },
      {
        key: De.NO_COMPARISON,
        label: "No reference intervention",
        desc: "None of the interventions serves as experimental or control",
        icon: kc
      }
    ], r = [
      { key: tt.PLACEBO, label: "Placebo", desc: "Inert substance" },
      { key: tt.SHAM, label: "Sham", desc: "Simulated procedure" },
      {
        key: tt.NO_INTERVENTION,
        label: "No intervention",
        desc: "Untreated control"
      }
    ], f = [
      {
        key: "participants",
        label: "Participants",
        desc: "Participants are unaware of treatment assignment"
      },
      {
        key: "careProviders",
        label: "Care providers",
        desc: "Care providers are unaware of treatment assignment"
      },
      {
        key: "assessors",
        label: "Outcome assessors",
        desc: "Outcome assessors are unaware of treatment assignment"
      }
    ], y = {
      [De.EXPERIMENTAL]: "Experimental",
      [De.COMPARATOR]: "Comparator",
      [De.NO_COMPARISON]: "No reference"
    }, k = B(null), m = B(null), h = B(null), I = B(Oe.NON_ACTIVE), b = B(tt.PLACEBO), w = B(void 0), S = B(!0), A = B(!1), g = B({}), x = B(
      ot[Math.floor(Math.random() * ot.length)]
    ), T = V(() => x.value + "1a"), _ = V(() => x.value + "33"), W = B([]), U = B(!1), z = B(!1), M = V(() => !!n.intervention), R = V(() => n.intervention ? l(n.intervention.definitionId) > 1 : !1), F = V(() => a.value), L = V(
      () => F.value.some((re) => re.role !== De.NO_COMPARISON)
    ), N = V(() => {
      if (!h.value) return null;
      if (h.value === De.COMPARATOR) {
        if (I.value === Oe.NON_ACTIVE && b.value)
          return r.find((O) => O.key === b.value)?.label ?? null;
        if (I.value === Oe.ACTIVE) {
          const P = W.value.filter((O) => O.name.trim()).map((O) => O.name.trim());
          return P.length > 0 ? P.join(" + ") : null;
        }
        return null;
      }
      const re = W.value.filter((P) => P.name.trim()).map((P) => P.name.trim());
      return re.length > 0 ? re.join(" + ") : null;
    }), D = V(() => M.value ? "Save Changes" : "Save Intervention");
    Te(
      () => n.show,
      (re) => {
        re && X(n.intervention, n.definition);
      }
    ), Te(
      () => n.intervention,
      (re, P) => {
        n.show && re?.id !== P?.id && X(re, n.definition);
      }
    );
    function X(re, P) {
      if (re && P)
        k.value = "new", m.value = null, h.value = P.role, I.value = P.comparatorType ?? Oe.NON_ACTIVE, b.value = P.nonActiveType ?? tt.PLACEBO, w.value = P.assignment, S.value = P.assignment !== void 0, g.value = P.blinding ?? {}, A.value = P.blinding !== void 0, x.value = P.color, W.value = P.items.length > 0 ? P.items.map((O) => ({ ...O, id: it.now() })) : [], U.value = !0;
      else {
        k.value = null, m.value = null, h.value = null, I.value = Oe.NON_ACTIVE, b.value = tt.PLACEBO, w.value = void 0, S.value = !0, g.value = {}, A.value = !1;
        const O = new Set(a.value.map(($) => $.color)), c = ot.find(($) => !O.has($));
        x.value = c ?? ot[Math.floor(Math.random() * ot.length)], W.value = [], U.value = !1;
      }
    }
    function G(re) {
      return to(re) ?? "Unnamed";
    }
    function q(re) {
      k.value = re, re === "new" && (m.value = null);
    }
    function Q(re) {
      h.value !== re && (h.value = re, W.value = [], I.value = Oe.NON_ACTIVE, b.value = tt.PLACEBO);
    }
    function ce(re) {
      I.value = re, b.value = tt.PLACEBO, W.value = [];
    }
    function be(re) {
      W.value = [...W.value, { id: it.now(), type: re, name: "" }];
    }
    function ye(re, P) {
      W.value = W.value.map((O) => O.id === re ? { ...O, name: P } : O);
    }
    function ve(re) {
      W.value = W.value.filter((P) => P.id !== re);
    }
    function xe() {
      S.value = !S.value, S.value || (w.value = void 0);
    }
    function Ae() {
      A.value = !A.value, A.value || (g.value = {});
    }
    function Re(re, P) {
      re === "openLabel" && P ? g.value = { openLabel: !0 } : g.value = { ...g.value, openLabel: void 0, [re]: P || void 0 };
    }
    function Ie() {
      const re = F.value.find((P) => P.id === m.value);
      re && o("import", { id: "", definitionId: re.id, order: "" });
    }
    function le() {
      if (M.value && R.value) {
        z.value = !0;
        return;
      }
      ke(!1);
    }
    function ue(re) {
      z.value = !1, ke(re);
    }
    function ke(re) {
      const P = !(h.value === De.COMPARATOR && I.value === Oe.NON_ACTIVE);
      o("save", {
        role: h.value ?? De.EXPERIMENTAL,
        items: P ? W.value.filter((O) => O.name.trim()) : [],
        comparatorType: h.value === De.COMPARATOR ? I.value : void 0,
        nonActiveType: h.value === De.COMPARATOR && I.value === Oe.NON_ACTIVE ? b.value : void 0,
        assignment: S.value ? w.value : void 0,
        blinding: A.value ? g.value : void 0,
        color: x.value,
        updateAll: re
      }), U.value = !0;
    }
    return (re, P) => (v(), C(se, null, [
      K(Gi, {
        show: e.show,
        onClose: P[10] || (P[10] = (O) => re.$emit("close"))
      }, {
        header: Pe(() => [
          u("div", {
            class: "flex-1 min-w-0 px-4 py-3 border-l-4 transition-colors duration-150",
            style: ne({ borderLeftColor: x.value })
          }, [
            u("div", {
              class: Z(["text-base font-bold leading-tight mb-1 transition-colors duration-150", N.value ? "text-slate-900 tracking-tight" : "text-slate-400 italic"])
            }, ae(N.value ?? "Unnamed intervention"), 3),
            N.value ? H("", !0) : (v(), C("div", Gc, " Intervention name will be generated automatically from the details you enter. ")),
            M.value && R.value ? (v(), C("div", Wc, [...P[16] || (P[16] = [
              u("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 20 20",
                fill: "currentColor",
                class: "size-3 text-slate-400"
              }, [
                u("path", { d: "M12.232 4.232a2.5 2.5 0 0 1 3.536 3.536l-1.225 1.224a.75.75 0 0 0 1.061 1.06l1.224-1.224a4 4 0 0 0-5.656-5.656l-3 3a4 4 0 0 0 .225 5.865.75.75 0 0 0 .977-1.138 2.5 2.5 0 0 1-.142-3.667l3-3Z" }),
                u("path", { d: "M11.603 7.963a.75.75 0 0 0-.977 1.138 2.5 2.5 0 0 1 .142 3.667l-3 3a2.5 2.5 0 0 1-3.536-3.536l1.225-1.224a.75.75 0 0 0-1.061-1.06l-1.224 1.224a4 4 0 1 0 5.656 5.656l3-3a4 4 0 0 0-.225-5.865Z" })
              ], -1),
              u("span", { class: "text-[10px] text-slate-400" }, "Linked across arms", -1)
            ])])) : H("", !0)
          ], 4)
        ]),
        footer: Pe(() => [
          k.value === "import" ? (v(), C("div", If, [
            u("button", {
              type: "button",
              class: "flex-1 px-3 py-1.5 text-xs font-medium rounded-md bg-white border border-slate-200 text-slate-600 hover:border-slate-300 transition-all cursor-pointer",
              onClick: P[7] || (P[7] = (O) => re.$emit("close"))
            }, " Cancel "),
            u("button", {
              type: "button",
              class: "flex-2 px-3 py-1.5 text-xs font-semibold rounded-md text-white hover:opacity-90 transition-all cursor-pointer disabled:opacity-40 disabled:cursor-not-allowed",
              style: ne({ backgroundColor: x.value }),
              disabled: !m.value,
              onClick: Ie
            }, " Save Intervention ", 12, Tf)
          ])) : H("", !0),
          k.value === "new" ? (v(), C("div", Sf, [
            M.value ? (v(), C("button", {
              key: 0,
              type: "button",
              class: "px-3 py-1.5 text-xs font-medium rounded-md text-red-500 hover:bg-red-50 transition-all cursor-pointer",
              onClick: P[8] || (P[8] = (O) => re.$emit("delete"))
            }, " Delete ")) : H("", !0),
            u("button", {
              type: "button",
              class: "flex-1 px-3 py-1.5 text-xs font-medium rounded-md bg-white border border-slate-200 text-slate-600 hover:border-slate-300 transition-all cursor-pointer",
              onClick: P[9] || (P[9] = (O) => re.$emit("close"))
            }, " Cancel "),
            u("button", {
              type: "button",
              class: "flex-2 px-3 py-1.5 text-xs font-semibold rounded-md text-white hover:opacity-90 transition-all cursor-pointer",
              style: ne({ backgroundColor: x.value }),
              onClick: le
            }, ae(D.value), 5)
          ])) : H("", !0)
        ]),
        default: Pe(() => [
          u("div", Xc, [
            M.value ? H("", !0) : (v(), C("div", qc, [
              u("button", {
                class: Z(["text-left px-2.5 py-2 rounded-md border transition-all cursor-pointer", k.value === "import" ? "" : "bg-white border-slate-200 hover:border-slate-300"]),
                style: ne(k.value === "import" ? { backgroundColor: T.value, borderColor: x.value } : {}),
                onClick: P[0] || (P[0] = (O) => q("import"))
              }, [
                u("div", {
                  class: Z(["text-xs font-semibold mb-0.5", k.value === "import" ? "" : "text-slate-800"]),
                  style: ne(k.value === "import" ? { color: x.value } : {})
                }, " Use existing ", 6),
                P[17] || (P[17] = u("div", { class: "text-[10px] text-slate-400" }, "Link to a previously defined intervention", -1))
              ], 6),
              u("button", {
                class: Z(["text-left px-2.5 py-2 rounded-md border transition-all cursor-pointer", k.value === "new" ? "" : "bg-white border-slate-200 hover:border-slate-300"]),
                style: ne(k.value === "new" ? { backgroundColor: T.value, borderColor: x.value } : {}),
                onClick: P[1] || (P[1] = (O) => q("new"))
              }, [
                u("div", {
                  class: Z(["text-xs font-semibold mb-0.5", k.value === "new" ? "" : "text-slate-800"]),
                  style: ne(k.value === "new" ? { color: x.value } : {})
                }, ae(U.value ? "Edit" : "Define new"), 7),
                u("div", Zc, ae(U.value ? "Modify your current definition" : "Specify from scratch"), 1)
              ], 6)
            ])),
            k.value === "import" ? (v(), C("div", Yc, [
              (v(!0), C(se, null, pe(F.value, (O) => (v(), C("button", {
                key: O.id,
                class: Z(["w-full text-left px-2.5 py-1.5 rounded-md border flex items-center justify-between gap-2 transition-all cursor-pointer", m.value === O.id ? "" : "bg-white border-slate-200 hover:border-slate-300"]),
                style: ne(m.value === O.id ? { backgroundColor: T.value, borderColor: x.value } : {}),
                onClick: (c) => m.value = O.id
              }, [
                u("div", Qc, [
                  u("div", {
                    class: "w-2 h-2 rounded-full shrink-0",
                    style: ne({ backgroundColor: O.color })
                  }, null, 4),
                  u("span", Jc, ae(G(O)), 1)
                ]),
                u("div", ef, [
                  L.value ? (v(), C("span", tf, ae(y[O.role]), 1)) : H("", !0),
                  m.value === O.id ? (v(), C("svg", {
                    key: 1,
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    "stroke-width": "2.5",
                    stroke: "currentColor",
                    class: "size-3",
                    style: ne({ color: x.value })
                  }, [...P[18] || (P[18] = [
                    u("path", {
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round",
                      d: "M4.5 12.75l6 6 9-13.5"
                    }, null, -1)
                  ])], 4)) : H("", !0)
                ])
              ], 14, Kc))), 128)),
              F.value.length === 0 ? (v(), C("div", nf, " No interventions yet. ")) : H("", !0)
            ])) : H("", !0),
            k.value === "new" ? (v(), C(se, { key: 2 }, [
              P[33] || (P[33] = u("div", { class: "text-[11px] font-bold uppercase tracking-wide text-slate-500 mb-1.5" }, "Role", -1)),
              u("div", of, [
                (v(), C(se, null, pe(d, (O) => u("button", {
                  key: O.key,
                  class: Z(["w-full text-left px-2.5 py-2 rounded-md border flex items-center gap-2.5 transition-all cursor-pointer", h.value === O.key ? "" : "bg-white border-slate-200 hover:border-slate-300"]),
                  style: ne(h.value === O.key ? { backgroundColor: T.value, borderColor: x.value } : {}),
                  onClick: (c) => Q(O.key)
                }, [
                  u("div", {
                    class: Z(["w-6.5 h-6.5 rounded-md flex items-center justify-center shrink-0 transition-colors", h.value === O.key ? "" : "bg-slate-100"]),
                    style: ne(h.value === O.key ? { backgroundColor: _.value } : {})
                  }, [
                    (v(), Ce(di(O.icon), {
                      class: Z(["size-3.5 transition-colors", h.value === O.key ? "" : "text-slate-600"]),
                      style: ne(h.value === O.key ? { color: x.value } : {})
                    }, null, 8, ["class", "style"]))
                  ], 6),
                  u("div", null, [
                    u("div", {
                      class: Z(["text-xs font-semibold mb-0.5 transition-colors", h.value === O.key ? "" : "text-slate-800"]),
                      style: ne(h.value === O.key ? { color: x.value } : {})
                    }, ae(O.label), 7),
                    u("div", rf, ae(O.desc), 1)
                  ])
                ], 14, lf)), 64))
              ]),
              h.value !== null ? (v(), C(se, { key: 0 }, [
                P[27] || (P[27] = u("div", { class: "h-px bg-slate-200 my-3.5" }, null, -1)),
                P[28] || (P[28] = u("div", { class: "text-[11px] font-bold uppercase tracking-wide text-slate-500 mb-1.5" }, " Composition ", -1)),
                h.value === p(De).COMPARATOR ? (v(), C(se, { key: 0 }, [
                  u("div", sf, [
                    u("button", {
                      class: Z([
                        "px-2.5 py-1.5 rounded-md border text-xs transition-all cursor-pointer",
                        I.value === p(Oe).NON_ACTIVE ? "font-semibold" : "bg-white border-slate-200 text-slate-700 hover:border-slate-300"
                      ]),
                      style: ne(
                        I.value === p(Oe).NON_ACTIVE ? { backgroundColor: T.value, borderColor: x.value, color: x.value } : {}
                      ),
                      onClick: P[2] || (P[2] = (O) => ce(p(Oe).NON_ACTIVE))
                    }, " Non-active comparator ", 6),
                    u("button", {
                      class: Z([
                        "px-2.5 py-1.5 rounded-md border text-xs transition-all cursor-pointer",
                        I.value === p(Oe).ACTIVE ? "font-semibold" : "bg-white border-slate-200 text-slate-700 hover:border-slate-300"
                      ]),
                      style: ne(
                        I.value === p(Oe).ACTIVE ? { backgroundColor: T.value, borderColor: x.value, color: x.value } : {}
                      ),
                      onClick: P[3] || (P[3] = (O) => ce(p(Oe).ACTIVE))
                    }, " Active comparator ", 6)
                  ]),
                  I.value === p(Oe).NON_ACTIVE ? (v(), C("div", af, [
                    (v(), C(se, null, pe(r, (O) => u("button", {
                      key: O.key,
                      class: Z([
                        "w-full text-left px-2.5 py-1.5 rounded-md border flex items-center justify-between transition-all cursor-pointer",
                        b.value === O.key ? "font-semibold" : "bg-white border-slate-200 hover:border-slate-300"
                      ]),
                      style: ne(
                        b.value === O.key ? { backgroundColor: T.value, borderColor: x.value, color: x.value } : {}
                      ),
                      onClick: (c) => b.value = O.key
                    }, [
                      u("span", df, ae(O.label), 1),
                      u("span", cf, ae(O.desc), 1)
                    ], 14, uf)), 64))
                  ])) : H("", !0),
                  I.value === p(Oe).ACTIVE ? (v(), C("div", ff, [
                    K(ei, {
                      items: W.value,
                      onAdd: be,
                      onUpdate: ye,
                      onRemove: ve
                    }, null, 8, ["items"])
                  ])) : H("", !0)
                ], 64)) : (v(), Ce(ei, {
                  key: 1,
                  items: W.value,
                  onAdd: be,
                  onUpdate: ye,
                  onRemove: ve
                }, null, 8, ["items"])),
                P[29] || (P[29] = u("div", { class: "h-px bg-slate-200 my-3.5" }, null, -1)),
                u("div", pf, [
                  P[19] || (P[19] = u("div", { class: "text-[11px] font-bold uppercase tracking-wide text-slate-500" }, " Assignment ", -1)),
                  u("div", vf, [
                    u("span", {
                      class: Z(["text-[11px] transition-colors", S.value ? "font-semibold" : "text-slate-400"]),
                      style: ne(S.value ? { color: x.value } : {})
                    }, ae(S.value ? "Reported" : "Not reported"), 7),
                    u("button", {
                      class: "relative w-7 h-4 rounded-full transition-colors cursor-pointer",
                      style: ne({ backgroundColor: S.value ? x.value : "#E2E8F0" }),
                      onClick: xe
                    }, [
                      u("span", {
                        class: Z(["absolute top-0.5 size-3 rounded-full bg-white shadow transition-all", S.value ? "left-3.5" : "left-0.5"])
                      }, null, 2)
                    ], 4)
                  ])
                ]),
                S.value ? (v(), C("div", mf, [
                  u("button", {
                    class: Z([
                      "w-full text-left px-2.5 py-2 rounded-md border transition-all cursor-pointer",
                      w.value === p(He).PROTOCOL ? "" : "bg-white border-slate-200 hover:border-slate-300"
                    ]),
                    style: ne(
                      w.value === p(He).PROTOCOL ? { backgroundColor: T.value, borderColor: x.value } : {}
                    ),
                    onClick: P[4] || (P[4] = (O) => w.value = p(He).PROTOCOL)
                  }, [
                    u("div", {
                      class: Z(["text-xs font-semibold mb-0.5", w.value === p(He).PROTOCOL ? "" : "text-slate-800"]),
                      style: ne(w.value === p(He).PROTOCOL ? { color: x.value } : {})
                    }, " Per study protocol (interventional study) ", 6),
                    P[20] || (P[20] = u("div", { class: "text-[10px] text-slate-400" }, "Assigned by the study", -1))
                  ], 6),
                  u("button", {
                    class: Z([
                      "w-full text-left px-2.5 py-2 rounded-md border transition-all cursor-pointer",
                      w.value === p(He).ROUTINE ? "" : "bg-white border-slate-200 hover:border-slate-300"
                    ]),
                    style: ne(
                      w.value === p(He).ROUTINE ? { backgroundColor: T.value, borderColor: x.value } : {}
                    ),
                    onClick: P[5] || (P[5] = (O) => w.value = p(He).ROUTINE)
                  }, [
                    u("div", {
                      class: Z(["text-xs font-semibold mb-0.5", w.value === p(He).ROUTINE ? "" : "text-slate-800"]),
                      style: ne(w.value === p(He).ROUTINE ? { color: x.value } : {})
                    }, " Per routine care (observational study) ", 6),
                    P[21] || (P[21] = u("div", { class: "text-[10px] text-slate-400" }, "Assigned independent of study", -1))
                  ], 6)
                ])) : H("", !0),
                P[30] || (P[30] = u("div", { class: "h-px bg-slate-200 my-3.5" }, null, -1)),
                u("div", hf, [
                  P[22] || (P[22] = u("div", { class: "text-[11px] font-bold uppercase tracking-wide text-slate-500" }, "Blinding", -1)),
                  u("div", gf, [
                    u("span", {
                      class: Z(["text-[11px] transition-colors", A.value ? "font-semibold" : "text-slate-400"]),
                      style: ne(A.value ? { color: x.value } : {})
                    }, ae(A.value ? "Reported" : "Not reported"), 7),
                    u("button", {
                      class: "relative w-7 h-4 rounded-full transition-colors cursor-pointer",
                      style: ne({ backgroundColor: A.value ? x.value : "#E2E8F0" }),
                      onClick: Ae
                    }, [
                      u("span", {
                        class: Z(["absolute top-0.5 size-3 rounded-full bg-white shadow transition-all", A.value ? "left-3.5" : "left-0.5"])
                      }, null, 2)
                    ], 4)
                  ])
                ]),
                A.value ? (v(), C("div", bf, [
                  u("button", {
                    class: Z(["w-full text-left px-2.5 py-2 rounded-md border flex items-start gap-2.5 transition-all cursor-pointer", g.value.openLabel ? "" : "bg-white border-slate-200 hover:border-slate-300"]),
                    style: ne(g.value.openLabel ? { backgroundColor: T.value, borderColor: x.value } : {}),
                    onClick: P[6] || (P[6] = (O) => Re("openLabel", !g.value.openLabel))
                  }, [
                    u("div", {
                      class: Z(["mt-0.5 size-3.5 rounded shrink-0 border flex items-center justify-center transition-colors", g.value.openLabel ? "" : "bg-white border-slate-300"]),
                      style: ne(g.value.openLabel ? { backgroundColor: x.value, borderColor: x.value } : {})
                    }, [
                      g.value.openLabel ? (v(), C("svg", xf, [...P[23] || (P[23] = [
                        u("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M4.5 12.75l6 6 9-13.5"
                        }, null, -1)
                      ])])) : H("", !0)
                    ], 6),
                    u("div", null, [
                      u("div", {
                        class: Z(["text-xs font-semibold mb-0.5 transition-colors", g.value.openLabel ? "" : "text-slate-800"]),
                        style: ne(g.value.openLabel ? { color: x.value } : {})
                      }, " Open label ", 6),
                      P[24] || (P[24] = u("div", { class: "text-[10px] text-slate-400" }, " No blinding — all parties aware of treatment assignment ", -1))
                    ])
                  ], 6),
                  P[26] || (P[26] = u("div", { class: "h-px bg-slate-200 my-1" }, null, -1)),
                  (v(), C(se, null, pe(f, (O) => u("button", {
                    key: O.key,
                    class: Z(["w-full text-left px-2.5 py-2 rounded-md border flex items-start gap-2.5 transition-all cursor-pointer", g.value[O.key] ? "" : "bg-white border-slate-200 hover:border-slate-300"]),
                    style: ne(g.value[O.key] ? { backgroundColor: T.value, borderColor: x.value } : {}),
                    onClick: (c) => Re(O.key, !g.value[O.key])
                  }, [
                    u("div", {
                      class: Z(["mt-0.5 size-3.5 rounded shrink-0 border flex items-center justify-center transition-colors", g.value[O.key] ? "" : "bg-white border-slate-300"]),
                      style: ne(g.value[O.key] ? { backgroundColor: x.value, borderColor: x.value } : {})
                    }, [
                      g.value[O.key] ? (v(), C("svg", wf, [...P[25] || (P[25] = [
                        u("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M4.5 12.75l6 6 9-13.5"
                        }, null, -1)
                      ])])) : H("", !0)
                    ], 6),
                    u("div", null, [
                      u("div", {
                        class: Z(["text-xs font-semibold mb-0.5 transition-colors", g.value[O.key] ? "" : "text-slate-800"]),
                        style: ne(g.value[O.key] ? { color: x.value } : {})
                      }, ae(O.label), 7),
                      u("div", Cf, ae(O.desc), 1)
                    ])
                  ], 14, yf)), 64))
                ])) : H("", !0),
                P[31] || (P[31] = u("div", { class: "h-px bg-slate-200 my-3.5" }, null, -1)),
                P[32] || (P[32] = u("div", { class: "text-[11px] font-bold uppercase tracking-wide text-slate-500 mb-1.5" }, " Color ", -1)),
                u("div", kf, [
                  (v(!0), C(se, null, pe(p(ot), (O) => (v(), C("button", {
                    key: O,
                    class: Z([
                      "size-5.5 rounded-full border-2 transition-all cursor-pointer",
                      x.value === O ? "border-slate-800 scale-110" : "border-transparent hover:scale-105"
                    ]),
                    style: ne({ backgroundColor: O }),
                    onClick: (c) => x.value = O
                  }, null, 14, $f))), 128))
                ])
              ], 64)) : H("", !0)
            ], 64)) : H("", !0)
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      (v(), Ce(Yn, { to: "body" }, [
        z.value ? (v(), C("div", {
          key: 0,
          class: "fixed inset-0 z-101 flex items-center justify-center bg-black/50",
          onClick: P[15] || (P[15] = (O) => z.value = !1)
        }, [
          u("div", {
            class: "bg-white rounded-xl shadow-xl p-6 max-w-sm mx-4",
            onClick: P[14] || (P[14] = he(() => {
            }, ["stop"]))
          }, [
            P[36] || (P[36] = u("h3", { class: "text-sm font-semibold text-slate-900 mb-2" }, "This intervention is linked", -1)),
            P[37] || (P[37] = u("p", { class: "text-xs text-slate-600 mb-4" }, " This intervention is shared across multiple arms. How would you like to apply your changes? ", -1)),
            u("div", Pf, [
              u("button", {
                class: "w-full px-3 py-2 text-xs font-medium rounded-md border border-slate-200 text-slate-800 hover:bg-slate-50 transition-colors text-left cursor-pointer",
                onClick: P[11] || (P[11] = (O) => ue(!0))
              }, [...P[34] || (P[34] = [
                u("div", { class: "font-semibold" }, "Update all linked", -1),
                u("div", { class: "text-slate-500 mt-0.5" }, " Apply changes to all arms using this intervention ", -1)
              ])]),
              u("button", {
                class: "w-full px-3 py-2 text-xs font-medium rounded-md border border-slate-200 text-slate-800 hover:bg-slate-50 transition-colors text-left cursor-pointer",
                onClick: P[12] || (P[12] = (O) => ue(!1))
              }, [...P[35] || (P[35] = [
                u("div", { class: "font-semibold" }, "Make independent", -1),
                u("div", { class: "text-slate-500 mt-0.5" }, "Detach this copy and edit it separately", -1)
              ])]),
              u("button", {
                class: "w-full px-3 py-1.5 text-xs text-slate-500 hover:text-slate-700 transition-colors cursor-pointer",
                onClick: P[13] || (P[13] = (O) => z.value = !1)
              }, " Cancel ")
            ])
          ])
        ])) : H("", !0)
      ]))
    ], 64));
  }
}), Ef = ["for"], Of = { class: "border border-[#e5e7eb] rounded-[10px] p-2.5 flex flex-wrap gap-2" }, Mf = { class: "text-sm font-medium text-gray-900" }, Rf = ["onClick"], Df = { class: "relative" }, Lf = ["id", "placeholder", "onKeydown"], Bf = { class: "p-2 w-90 max-h-40 overflow-y-auto" }, Nf = ["disabled", "onClick"], zf = {
  key: 1,
  class: "px-3 py-2 text-sm text-slate-400 text-center"
}, ti = /* @__PURE__ */ ge({
  __name: "CriteriaEditor",
  props: {
    modelValue: {},
    globalOptions: {},
    type: {},
    label: {},
    placeholder: {},
    emptyMessage: {}
  },
  emits: ["update:modelValue", "add", "remove"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = B(""), l = B(!1), s = B(null), a = V(() => n.type === "inclusion" ? "bg-[#cdffdf]" : "bg-[#ffc0b9]"), d = V(() => n.type === "inclusion" ? "hover:bg-green-50 text-green-600" : "hover:bg-red-50 text-red-600"), r = V(() => {
      const k = i.value.toLowerCase();
      return n.globalOptions.filter(
        (m) => m.toLowerCase().includes(k) && !n.modelValue.includes(m)
      );
    });
    function f() {
      i.value && !n.modelValue.includes(i.value) && (o("add", i.value), i.value = "");
    }
    function y(k) {
      n.modelValue.includes(k) || (o("update:modelValue", [...n.modelValue, k]), i.value = "");
    }
    return (k, m) => (v(), C("div", null, [
      u("label", {
        for: `${e.type}-input`,
        class: "block text-sm font-medium text-slate-600 mb-2.5"
      }, ae(e.label), 9, Ef),
      u("div", Of, [
        (v(!0), C(se, null, pe(e.modelValue, (h, I) => (v(), C("div", {
          key: `${e.type}-${I}`,
          class: Z(["inline-flex items-center gap-2 px-3 py-2 rounded-[10px] self-start", a.value])
        }, [
          u("span", Mf, ae(h), 1),
          u("button", {
            class: "text-gray-600 hover:text-gray-900 transition-colors",
            onClick: (b) => k.$emit("remove", I)
          }, [
            K(dt, { class: "size-3" })
          ], 8, Rf)
        ], 2))), 128)),
        u("div", Df, [
          Le(u("input", {
            id: `${e.type}-input`,
            ref_key: "inputRef",
            ref: s,
            "onUpdate:modelValue": m[0] || (m[0] = (h) => i.value = h),
            type: "text",
            class: "w-full text-sm font-medium text-gray-900 placeholder:text-slate-300 outline-none",
            placeholder: e.placeholder,
            onFocus: m[1] || (m[1] = (h) => l.value = !0),
            onKeydown: Et(he(f, ["prevent"]), ["enter"])
          }, null, 40, Lf), [
            [_e, i.value]
          ]),
          l.value && (r.value.length > 0 || i.value) ? (v(), Ce(xn, {
            key: 0,
            "reference-el": s.value,
            onClose: m[2] || (m[2] = (h) => l.value = !1)
          }, {
            default: Pe(() => [
              u("div", Bf, [
                i.value && !e.globalOptions.includes(i.value) ? (v(), C("button", {
                  key: 0,
                  type: "button",
                  class: Z(["w-full px-3 py-2 text-left text-sm rounded flex items-center gap-2", d.value]),
                  onClick: f
                }, [
                  K(oo),
                  an(' Create "' + ae(i.value) + '" ', 1)
                ], 2)) : H("", !0),
                (v(!0), C(se, null, pe(r.value, (h) => (v(), C("button", {
                  key: h,
                  type: "button",
                  class: Z(["w-full px-3 py-2 text-left text-sm hover:bg-slate-50 rounded", { "opacity-50": e.modelValue.includes(h) }]),
                  disabled: e.modelValue.includes(h),
                  onClick: (I) => y(h)
                }, ae(h), 11, Nf))), 128)),
                i.value && e.globalOptions.includes(i.value) && r.value.length === 0 ? (v(), C("div", zf, ae(e.emptyMessage), 1)) : H("", !0)
              ])
            ]),
            _: 1
          }, 8, ["reference-el"])) : H("", !0)
        ])
      ])
    ]));
  }
}), _f = { class: "space-y-5" }, Vf = /* @__PURE__ */ ge({
  __name: "PopulationMenu",
  props: {
    show: { type: Boolean },
    populationId: {}
  },
  emits: ["close"],
  setup(e, { emit: t }) {
    const n = e, o = t, {
      getPopulationById: i,
      updatePopulation: l,
      populationsDataEntity: s,
      findPopulationWithSameCriteria: a,
      mergePopulations: d
    } = pt(), r = V(() => {
      const M = /* @__PURE__ */ new Set();
      for (const R of s.value)
        if (R.id !== n.populationId) {
          for (const F of R.inclusionCriteria ?? []) M.add(F);
          for (const F of R.exclusionCriteria ?? []) M.add(F);
        }
      return [...M];
    }), f = B(""), y = B([]), k = B([]), m = B(null), h = B(!1), I = B(null), b = B(""), w = V(() => i(n.populationId));
    function S() {
      if (!w.value) return;
      m.value = null;
      const M = a(
        n.populationId,
        y.value,
        k.value
      );
      if (M) {
        I.value = M.id, b.value = M.name, h.value = !0;
        return;
      }
      A();
    }
    function A() {
      const M = {
        name: f.value,
        inclusionCriteria: y.value,
        exclusionCriteria: k.value
      };
      l(n.populationId, M), o("close");
    }
    function g() {
      I.value && (d(n.populationId, I.value), h.value = !1, o("close"));
    }
    function x() {
      h.value = !1, A();
    }
    function T(M) {
      M && !y.value.includes(M) && y.value.push(M);
    }
    function _(M) {
      y.value.splice(M, 1);
    }
    function W(M) {
      M && !k.value.includes(M) && k.value.push(M);
    }
    function U(M) {
      k.value.splice(M, 1);
    }
    function z() {
      const M = i(n.populationId);
      M && (f.value = M.name, y.value = [...M.inclusionCriteria || []], k.value = [...M.exclusionCriteria || []]);
    }
    return rt(z), Te(
      () => n.show,
      (M) => {
        M && z();
      }
    ), Te(() => n.populationId, z), (M, R) => (v(), C(se, null, [
      K(Gi, {
        show: e.show,
        onClose: R[3] || (R[3] = (F) => M.$emit("close"))
      }, {
        header: Pe(() => [...R[4] || (R[4] = [
          u("h2", { class: "px-4 py-5 text-2xl font-bold text-gray-900" }, "Population", -1)
        ])]),
        footer: Pe(() => [
          u("button", {
            class: "w-full bg-blue-800 text-white font-semibold text-base rounded-lg px-4 py-3 hover:bg-blue-900 transition-colors",
            onClick: S
          }, " Save population ")
        ]),
        default: Pe(() => [
          u("div", _f, [
            u("div", null, [
              R[5] || (R[5] = u("label", {
                for: "population-name",
                class: "block text-sm font-medium text-slate-600 mb-2.5"
              }, "Name", -1)),
              Le(u("input", {
                id: "population-name",
                "onUpdate:modelValue": R[0] || (R[0] = (F) => f.value = F),
                type: "text",
                class: "w-full border border-[#e5e7eb] rounded-lg p-3 text-sm font-medium text-gray-900 placeholder:text-slate-300 outline-none focus:ring-2 focus:ring-slate-200",
                placeholder: "Enter name..."
              }, null, 512), [
                [_e, f.value]
              ])
            ]),
            K(ti, {
              modelValue: y.value,
              "onUpdate:modelValue": R[1] || (R[1] = (F) => y.value = F),
              "global-options": r.value,
              type: "inclusion",
              label: "Inclusion Criteria",
              placeholder: "Type and press Enter...",
              "empty-message": "Criteria already added",
              onAdd: T,
              onRemove: _
            }, null, 8, ["modelValue", "global-options"]),
            K(ti, {
              modelValue: k.value,
              "onUpdate:modelValue": R[2] || (R[2] = (F) => k.value = F),
              "global-options": r.value,
              type: "exclusion",
              label: "Exclusion Criteria",
              placeholder: "Type and press Enter...",
              "empty-message": "Criteria already added",
              onAdd: W,
              onRemove: U
            }, null, 8, ["modelValue", "global-options"])
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      K(qn, {
        show: h.value,
        title: "Merge Populations",
        message: `A population with the same criteria already exists (${b.value}). Do you want to merge the current population into it?`,
        variant: "warning",
        "confirm-text": "Merge",
        "cancel-text": "Keep Separate",
        onConfirm: g,
        onCancel: x
      }, null, 8, ["show", "message"])
    ], 64));
  }
}), Ff = ["viewBox"], jf = ["d"], Hf = ["y1", "x2", "y2"], Uf = ["x", "y", "width", "fill", "rx", "ry"], Gf = ["x", "y"], Wf = ["cy", "fill"], Xf = ["transform"], ni = 520, En = 200, Jt = 16, On = 36, oi = 30, ht = 104, It = 22, Mn = 6, ii = 3, li = 10, Rn = 150, ri = 5.5, qf = /* @__PURE__ */ ge({
  __name: "StudyDesignThumbnail",
  props: {
    populations: {},
    arms: {},
    periods: {},
    interventionDefinitions: {}
  },
  setup(e) {
    const t = e, n = On + oi, o = Math.round((n + ht) / 2), i = V(() => new Map(t.interventionDefinitions.map((g) => [g.id, g])));
    function l(g) {
      return i.value.get(g.definitionId);
    }
    function s(g) {
      const x = l(g);
      return x ? to(x) ?? "Unnamed" : "Unnamed";
    }
    function a(g) {
      return l(g)?.color ?? "#94a3b8";
    }
    function d(g) {
      return t.periods.filter((x) => x.armId === g).sort((x, T) => x.globalOrder < T.globalOrder ? -1 : x.globalOrder > T.globalOrder ? 1 : 0);
    }
    const r = V(() => (En - 2 * Jt) / (t.populations.length || 1));
    function f(g) {
      return t.arms.filter((x) => x.populationId === g);
    }
    function y(g, x, T) {
      const _ = f(T), W = r.value / Math.max(_.length, 1);
      return Jt + g * r.value + (x + 0.5) * W;
    }
    function k(g) {
      const x = t.populations[g];
      if (!x) return Jt + (g + 0.5) * r.value;
      const T = f(x.id);
      if (T.length === 0) return Jt + (g + 0.5) * r.value;
      const _ = T.map((W, U) => y(g, U, x.id));
      return _.reduce((W, U) => W + U, 0) / _.length;
    }
    const m = V(() => {
      const g = [];
      for (let x = 0; x < t.populations.length; x++) {
        const T = t.populations[x];
        if (!T) continue;
        const _ = f(T.id);
        for (let W = 0; W < _.length; W++)
          g.push({ id: _[W].id, y: y(x, W, T.id) });
      }
      return g;
    }), h = V(() => {
      const g = /* @__PURE__ */ new Map();
      for (const x of m.value) g.set(x.id, { y: x.y });
      return g;
    });
    function I(g) {
      const x = g.length * ri + 2 * li;
      if (x <= Rn) return { w: x, text: g };
      const T = Math.floor((Rn - 2 * li) / ri);
      return { w: Rn, text: g.slice(0, Math.max(T - 1, 1)) + "…" };
    }
    function b(g) {
      return g.interventions.length === 0 ? 0 : Math.max(...g.interventions.map((x) => I(s(x)).w));
    }
    const w = V(() => {
      const g = /* @__PURE__ */ new Map();
      for (const x of m.value) {
        const T = d(x.id);
        if (T.length === 0) {
          g.set(x.id, ht);
          continue;
        }
        let _ = ht;
        for (const W of T)
          _ += b(W) + Mn;
        g.set(x.id, _ - Mn);
      }
      return g;
    }), S = V(() => {
      const g = [];
      for (const x of m.value) {
        const T = d(x.id);
        let _ = ht;
        for (const W of T) {
          const U = b(W), z = W.interventions.length, M = z * It + (z - 1) * ii, R = x.y - M / 2;
          for (let F = 0; F < z; F++) {
            const L = W.interventions[F], { text: N } = I(s(L));
            g.push({
              x: _,
              y: R + F * (It + ii),
              w: U,
              color: a(L),
              label: N
            });
          }
          _ += U + Mn;
        }
      }
      return g;
    }), A = V(() => {
      const g = [], x = o;
      for (let T = 0; T < t.populations.length; T++) {
        const _ = t.populations[T];
        if (!_) continue;
        const W = f(_.id), U = k(T);
        if (W.length !== 0)
          for (const z of W) {
            const M = h.value.get(z.id);
            if (!M) continue;
            const R = M.y;
            g.push({
              d: `M ${n} ${U} C ${x} ${U} ${x} ${R} ${ht} ${R}`
            });
          }
      }
      return g;
    });
    return (g, x) => (v(), C("svg", {
      viewBox: `0 0 ${ni} ${En}`,
      preserveAspectRatio: "xMidYMid meet",
      class: "w-full h-full",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      x[1] || (x[1] = u("defs", null, [
        u("pattern", {
          id: "sdthumb-dots",
          x: "0",
          y: "0",
          width: "12",
          height: "12",
          patternUnits: "userSpaceOnUse"
        }, [
          u("circle", {
            cx: "1.5",
            cy: "1.5",
            r: "0.8",
            fill: "#cbd5e1"
          })
        ])
      ], -1)),
      u("rect", {
        width: ni,
        height: En,
        fill: "url(#sdthumb-dots)"
      }),
      (v(!0), C(se, null, pe(A.value, ({ d: T }, _) => (v(), C("path", {
        key: `conn-${_}`,
        d: T,
        stroke: "#475569",
        "stroke-width": "3",
        fill: "none",
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, jf))), 128)),
      (v(!0), C(se, null, pe(m.value, (T) => (v(), C("line", {
        key: `track-${T.id}`,
        x1: ht,
        y1: T.y,
        x2: w.value.get(T.id) ?? ht,
        y2: T.y,
        stroke: "#cbd5e1",
        "stroke-width": "2",
        "stroke-linecap": "round"
      }, null, 8, Hf))), 128)),
      (v(!0), C(se, null, pe(S.value, (T, _) => (v(), C("g", {
        key: `pill-${_}`
      }, [
        u("rect", {
          x: T.x,
          y: T.y,
          width: T.w,
          height: It,
          fill: T.color,
          rx: It / 2,
          ry: It / 2
        }, null, 8, Uf),
        u("text", {
          x: T.x + T.w / 2,
          y: T.y + It / 2,
          "dominant-baseline": "middle",
          "text-anchor": "middle",
          fill: "white",
          "font-size": "9",
          "font-family": "system-ui, sans-serif",
          "font-weight": "600"
        }, ae(T.label), 9, Gf)
      ]))), 128)),
      (v(!0), C(se, null, pe(e.populations, (T, _) => (v(), C("g", {
        key: `pop-${T.id}`
      }, [
        u("circle", {
          cx: On,
          cy: k(_),
          r: oi,
          fill: p(Ti)(_),
          filter: "drop-shadow(0 2px 4px rgba(0,0,0,0.25))"
        }, null, 8, Wf),
        u("g", {
          transform: `translate(${On - 10}, ${k(_) - 8}) scale(0.56)`
        }, [...x[0] || (x[0] = [
          Zn('<path d="M24 6C24 9.31371 21.3137 12 18 12C14.6863 12 12 9.31371 12 6C12 2.68629 14.6863 0 18 0C21.3137 0 24 2.68629 24 6Z" fill="white"></path><path d="M34 10C34 12.2091 32.2091 14 30 14C27.7909 14 26 12.2091 26 10C26 7.79086 27.7909 6 30 6C32.2091 6 34 7.79086 34 10Z" fill="white"></path><path d="M26 24C26 19.5817 22.4183 16 18 16C13.5817 16 10 19.5817 10 24V30H26V24Z" fill="white"></path><path d="M10 10C10 12.2091 8.20914 14 6 14C3.79086 14 2 12.2091 2 10C2 7.79086 3.79086 6 6 6C8.20914 6 10 7.79086 10 10Z" fill="white"></path><path d="M30 30V24C30 21.8917 29.4563 19.9104 28.5015 18.1886C28.9805 18.0655 29.4826 18 30 18C33.3137 18 36 20.6863 36 24V30H30Z" fill="white"></path><path d="M7.49853 18.1886C6.5437 19.9104 6 21.8917 6 24V30H0V24C0 20.6863 2.68629 18 6 18C6.51742 18 7.01954 18.0655 7.49853 18.1886Z" fill="white"></path>', 6)
        ])], 8, Xf)
      ]))), 128))
    ], 8, Ff));
  }
});
function si(e) {
  const t = /* @__PURE__ */ new Map();
  function n(d) {
    return t.has(d) || t.set(d, it.now()), t.get(d);
  }
  const o = (e.populations ?? []).map((d) => ({
    ...d,
    id: n(d.id)
  })), i = (e.anchors ?? []).map((d) => ({
    ...d,
    id: n(d.id)
  })), l = (e.arms ?? []).map((d) => ({
    ...d,
    id: n(d.id),
    populationId: n(d.populationId),
    anchorPoints: d.anchorPoints.map((r) => ({
      ...r,
      anchorId: n(r.anchorId)
    }))
  })), s = (e.interventionDefinitions ?? []).map((d) => ({
    ...d,
    id: n(d.id),
    items: d.items.map((r) => ({
      ...r,
      id: n(r.id)
    }))
  })), a = (e.periods ?? []).map((d) => ({
    ...d,
    id: n(d.id),
    armId: n(d.armId),
    timepoints: d.timepoints.map((r) => ({
      ...r,
      id: n(r.id)
    })),
    interventions: d.interventions.map((r) => ({
      ...r,
      id: n(r.id),
      definitionId: n(r.definitionId)
    }))
  }));
  return { populations: o, arms: l, periods: a, interventionDefinitions: s, anchors: i };
}
const Zf = [{ id: "1778002441277", name: "P1", inclusionCriteria: ["inclusion criterion 1", "inclusion criterion 2"], exclusionCriteria: ["diabetes", "pregnancy"], randomization: { status: "randomized", allocationRatios: ["", ""], scheme: null, blockSize: "", stratFactors: [], numStrata: "", seqMethod: null, seqResp: null, concealment: null, concealMethod: null, concealOtherSpec: "" } }], Yf = [{ id: "1778002441277-arm-1", name: "G1", participantsCount: 0, populationId: "1778002441277", anchorPoints: [{ anchorId: "baseline-default", participantCount: 50 }] }, { id: "1778002442728", name: "G2", participantsCount: 0, populationId: "1778002441277", anchorPoints: [{ anchorId: "baseline-default", participantCount: 50 }] }], Kf = [{ id: "def-1778002476894-6", role: "experimental", items: [{ id: "1778002545744-16", type: "device", name: "Device under evaluation" }], assignment: "protocol", blinding: { participants: !0, careProviders: !0, assessors: !0 }, color: "#4A90D9" }, { id: "def-1778002494910-11", role: "comparator", items: [], comparatorType: "non_active", nonActiveType: "placebo", assignment: "protocol", blinding: { participants: !0, careProviders: !0, assessors: !0 }, color: "#E74C3C" }], Qf = [{ id: "1778002476894-7", armId: "1778002441277-arm-1", globalOrder: "n", timepoints: [{ id: "1778002476894-5-start", name: "T0", order: "a", isStart: !0 }, { id: "1778002484695-9", name: "T1", order: "m" }, { id: "1778002479462-8", name: "T2", order: "z", isEnd: !0 }], interventions: [{ id: "1778002476894-6", definitionId: "def-1778002476894-6", order: "n" }] }, { id: "1778002494910-12", armId: "1778002442728", globalOrder: "t", timepoints: [{ id: "1778002494910-10-start", name: "T0", order: "a", isStart: !0 }, { id: "1778002499593-14", name: "T1", order: "m" }, { id: "1778002497211-13", name: "T2", order: "z", isEnd: !0 }], interventions: [{ id: "1778002494910-11", definitionId: "def-1778002494910-11", order: "n" }] }], Jf = [{ id: "baseline-default", name: "Baseline", type: "baseline", globalOrder: "!" }, { id: "1778002557844-17", name: "Follow-up", type: "followup", globalOrder: "w" }], ep = {
  populations: Zf,
  arms: Yf,
  interventionDefinitions: Kf,
  periods: Qf,
  anchors: Jf
}, tp = [{ id: "1778002441277", name: "P1", inclusionCriteria: ["inclusion criterion 1", "inclusion criterion 2"], exclusionCriteria: ["diabetes", "pregnancy"], randomization: { status: null, allocationRatios: ["", ""], scheme: null, blockSize: "", stratFactors: [], numStrata: "", seqMethod: null, seqResp: null, concealment: null, concealMethod: null, concealOtherSpec: "" } }], np = [{ id: "1778002441277-arm-1", name: "G1", participantsCount: 0, populationId: "1778002441277", anchorPoints: [{ anchorId: "baseline-default", participantCount: 50 }] }, { id: "1778002442728", name: "G2", participantsCount: 0, populationId: "1778002441277", anchorPoints: [{ anchorId: "baseline-default", participantCount: 50 }] }], op = [{ id: "def-1778002476894-6", role: "experimental", items: [{ id: "1778002545744-16", type: "device", name: "Device under evaluation" }], assignment: "protocol", blinding: { participants: !0, careProviders: !0, assessors: !0 }, color: "#4A90D9" }, { id: "def-1778002494910-11", role: "comparator", items: [], comparatorType: "non_active", nonActiveType: "placebo", assignment: "protocol", blinding: { participants: !0, careProviders: !0, assessors: !0 }, color: "#E74C3C" }], ip = [{ id: "1778002476894-7", armId: "1778002441277-arm-1", globalOrder: "n", timepoints: [{ id: "1778002476894-5-start", name: "T0", order: "a", isStart: !0 }, { id: "1778002484695-9", name: "T1", order: "m" }, { id: "1778002479462-8", name: "T2", order: "z", isEnd: !0 }], interventions: [{ id: "1778002476894-6", definitionId: "def-1778002476894-6", order: "n" }] }, { id: "1778002494910-12", armId: "1778002442728", globalOrder: "t", timepoints: [{ id: "1778002494910-10-start", name: "T0", order: "a", isStart: !0 }, { id: "1778002499593-14", name: "T1", order: "m" }, { id: "1778002497211-13", name: "T2", order: "z", isEnd: !0 }], interventions: [{ id: "1778002494910-11", definitionId: "def-1778002494910-11", order: "n" }] }], lp = [{ id: "baseline-default", name: "Baseline", type: "baseline", globalOrder: "!" }, { id: "1778002557844-17", name: "Follow-up", type: "followup", globalOrder: "w" }], rp = {
  populations: tp,
  arms: np,
  interventionDefinitions: op,
  periods: ip,
  anchors: lp
}, sp = [{ id: "1778002441277", name: "P1", inclusionCriteria: ["inclusion criterion 1", "inclusion criterion 2"], exclusionCriteria: ["diabetes", "pregnancy"], randomization: { status: "randomized", allocationRatios: ["", ""], scheme: null, blockSize: "", stratFactors: [], numStrata: "", seqMethod: null, seqResp: null, concealment: null, concealMethod: null, concealOtherSpec: "" } }], ap = [{ id: "1778002441277-arm-1", name: "G1", participantsCount: 0, populationId: "1778002441277", anchorPoints: [{ anchorId: "baseline-default", participantCount: 50 }] }, { id: "1778002442728", name: "G2", participantsCount: 0, populationId: "1778002441277", anchorPoints: [{ anchorId: "baseline-default", participantCount: 50 }] }], up = [{ id: "def-1778002476894-6", role: "experimental", items: [{ id: "1778002545744-16", type: "device", name: "Device under evaluation" }], assignment: "protocol", blinding: { participants: !0, careProviders: !0, assessors: !0 }, color: "#4A90D9" }, { id: "def-1778002494910-11", role: "comparator", items: [], comparatorType: "non_active", nonActiveType: "placebo", assignment: "protocol", blinding: { participants: !0, careProviders: !0, assessors: !0 }, color: "#E74C3C" }], dp = [{ id: "1778002476894-7", armId: "1778002441277-arm-1", globalOrder: "n", timepoints: [{ id: "1778002476894-5-start", name: "T0", order: "a", isStart: !0 }, { id: "1778002484695-9", name: "T1", order: "m" }, { id: "1778002479462-8", name: "T2", order: "z", isEnd: !0 }], interventions: [{ id: "1778002476894-6", definitionId: "def-1778002476894-6", order: "n" }] }, { id: "1778002494910-12", armId: "1778002442728", globalOrder: "t", timepoints: [{ id: "1778002494910-10-start", name: "T0", order: "a", isStart: !0 }, { id: "1778002499593-14", name: "T1", order: "m" }, { id: "1778002497211-13", name: "T2", order: "z", isEnd: !0 }], interventions: [{ id: "1778002494910-11", definitionId: "def-1778002494910-11", order: "n" }] }, { id: "1778002819475-21", armId: "1778002441277-arm-1", globalOrder: "v", timepoints: [{ id: "1778002819475-19-start", name: "T0", order: "a", isStart: !0 }, { id: "1778003278137-30", name: "T1", order: "m" }, { id: "1778002823409-22", name: "T2", order: "z", isEnd: !0 }], interventions: [{ id: "1778002819475-20", definitionId: "def-1778002494910-11", order: "n" }] }, { id: "1778002833677-26", armId: "1778002442728", globalOrder: "w", timepoints: [{ id: "1778002833677-24-start", name: "T0", order: "a", isStart: !0 }, { id: "1778003276904-29", name: "T1", order: "m" }, { id: "1778002841726-27", name: "T2", order: "z", isEnd: !0 }], interventions: [{ id: "1778002833677-25", definitionId: "def-1778002476894-6", order: "n" }] }], cp = [{ id: "baseline-default", name: "Baseline", type: "baseline", globalOrder: "!" }, { id: "1778002795875-18", name: "Follow-up", type: "followup", globalOrder: "y" }], fp = {
  populations: sp,
  arms: ap,
  interventionDefinitions: up,
  periods: dp,
  anchors: cp
}, pp = [{ id: "1778003390971", name: "P1" }], vp = [{ id: "1778003390971-arm-1", name: "G1", participantsCount: 0, populationId: "1778003390971", anchorPoints: [{ anchorId: "baseline-default", participantCount: 50 }] }, { id: "1778003392069", name: "G2", participantsCount: 0, populationId: "1778003390971", anchorPoints: [{ anchorId: "baseline-default", participantCount: 50 }] }], mp = [], hp = [], gp = [{ id: "baseline-default", name: "Baseline", type: "baseline", globalOrder: "!" }, { id: "1778003399535-31", name: "T0", type: "followup", globalOrder: "m" }, { id: "1778003405302-32", name: "T1", type: "followup", globalOrder: "t" }, { id: "1778003410353-33", name: "T2", type: "followup", globalOrder: "w" }], bp = {
  populations: pp,
  arms: vp,
  interventionDefinitions: mp,
  periods: hp,
  anchors: gp
}, xp = [{ id: "1778003472270", name: "P1" }], yp = [{ id: "1778003472270-arm-1", name: "G1", participantsCount: 0, populationId: "1778003472270", anchorPoints: [{ anchorId: "baseline-default", participantCount: 100 }] }], wp = [{ id: "def-1778003503751-36", role: "experimental", items: [{ id: "1778003487570-34", type: "device", name: "Device under evaluation" }], assignment: "protocol", blinding: { participants: !0, careProviders: !0, assessors: !0 }, color: "#4A90D9" }, { id: "def-1778003524184-40", role: "comparator", items: [], comparatorType: "non_active", nonActiveType: "sham", assignment: "protocol", blinding: { participants: !0, careProviders: !0, assessors: !0 }, color: "#F5A623" }], Cp = [{ id: "1778003503751-37", armId: "1778003472270-arm-1", globalOrder: "n", timepoints: [{ id: "1778003503751-35-start", name: "Start", order: "a", isStart: !0 }, { id: "1778003508201-39", name: "Mid 1", order: "m" }, { id: "1778003507036-38", name: "End", order: "z", isEnd: !0 }], interventions: [{ id: "1778003503751-36", definitionId: "def-1778003503751-36", order: "n", bodyPartName: "right hand" }, { id: "1778003524184-40", definitionId: "def-1778003524184-40", order: "g", bodyPartName: "left hand" }], randomization: { status: "randomized", allocationRatios: ["", ""], scheme: null, blockSize: "", stratFactors: [], numStrata: "", seqMethod: null, seqResp: null, concealment: null, concealMethod: null, concealOtherSpec: "" } }], kp = [{ id: "baseline-default", name: "Baseline", type: "baseline", globalOrder: "!" }, { id: "1778003547051-41", name: "Follow-up", type: "followup", globalOrder: "t" }], $p = {
  populations: xp,
  arms: yp,
  interventionDefinitions: wp,
  periods: Cp,
  anchors: kp
}, Ip = { class: "bg-white rounded-2xl shadow-2xl w-[720px] max-w-[95vw] max-h-[85vh] flex flex-col" }, Tp = { class: "flex items-center justify-between px-6 py-4 border-b border-gray-100" }, Sp = { class: "overflow-y-auto p-6 grid grid-cols-2 sm:grid-cols-3 gap-4" }, Pp = ["onClick"], Ap = { class: "bg-gray-50 h-36 w-full p-3 flex items-center justify-center" }, Ep = { class: "px-3 py-2" }, Op = { class: "text-xs font-medium text-gray-700 group-hover:text-blue-600 transition-colors" }, Mp = /* @__PURE__ */ ge({
  __name: "TemplatePicker",
  props: {
    isEmpty: { type: Boolean }
  },
  emits: ["apply", "close"],
  setup(e, { emit: t }) {
    const n = e, o = t, i = [
      { name: "Randomized Controlled Trial", design: ep },
      { name: "Non-Randomized Controlled Trial", design: rp },
      { name: "Crossover Study", design: fp },
      { name: "Longitudinal Study", design: bp },
      { name: "Split-Body Study", design: $p }
    ], l = B(null);
    function s(r) {
      n.isEmpty ? o("apply", si(r)) : l.value = r;
    }
    function a() {
      l.value && (o("apply", si(l.value)), l.value = null);
    }
    function d() {
      l.value = null;
    }
    return (r, f) => (v(), C("div", {
      class: "fixed inset-0 z-50 flex items-center justify-center bg-black/40",
      onClick: f[1] || (f[1] = he((y) => o("close"), ["self"]))
    }, [
      u("div", Ip, [
        u("div", Tp, [
          f[2] || (f[2] = u("h2", { class: "text-base font-semibold text-gray-800" }, "Load template", -1)),
          u("button", {
            class: "text-gray-400 hover:text-gray-700 transition-colors",
            onClick: f[0] || (f[0] = (y) => o("close")),
            "aria-label": "Close"
          }, [
            K(p(ki), {
              icon: "material-symbols:close",
              class: "size-5"
            })
          ])
        ]),
        u("div", Sp, [
          (v(), C(se, null, pe(i, (y) => u("button", {
            key: y.name,
            class: "group flex flex-col rounded-xl border border-gray-200 hover:border-blue-400 hover:shadow-md transition-all bg-white overflow-hidden text-left",
            onClick: (k) => s(y.design)
          }, [
            u("div", Ap, [
              K(qf, {
                populations: y.design.populations ?? [],
                arms: y.design.arms ?? [],
                periods: y.design.periods ?? [],
                "intervention-definitions": y.design.interventionDefinitions ?? [],
                anchors: y.design.anchors ?? []
              }, null, 8, ["populations", "arms", "periods", "intervention-definitions", "anchors"])
            ]),
            u("div", Ep, [
              u("span", Op, ae(y.name), 1)
            ])
          ], 8, Pp)), 64))
        ])
      ]),
      l.value ? (v(), C("div", {
        key: 0,
        class: "absolute inset-0 flex items-center justify-center bg-black/20",
        onClick: he(d, ["self"])
      }, [
        u("div", { class: "bg-white rounded-xl shadow-xl p-6 w-80 flex flex-col gap-4" }, [
          f[3] || (f[3] = u("p", { class: "text-sm text-gray-700" }, " Loading a template will replace the current study design. This cannot be undone. ", -1)),
          u("div", { class: "flex justify-end gap-2" }, [
            u("button", {
              class: "px-4 py-2 rounded-lg text-sm text-gray-600 hover:bg-gray-100 transition-colors",
              onClick: d
            }, " Cancel "),
            u("button", {
              class: "px-4 py-2 rounded-lg text-sm font-semibold bg-red-600 text-white hover:bg-red-700 transition-colors",
              onClick: a
            }, " Replace ")
          ])
        ])
      ])) : H("", !0)
    ]));
  }
}), Rp = 0.25, Dp = 2, ai = 0.1, Lp = 1e-3;
function en(e) {
  if (!e || !(e instanceof HTMLElement)) return !1;
  const t = e.tagName.toLowerCase();
  return t === "input" || t === "textarea" || t === "select" || e.isContentEditable;
}
function tn(e) {
  return Math.min(Dp, Math.max(Rp, e));
}
function Dn(e, t, n, o, i, l) {
  const s = o / n;
  return {
    panX: i - s * (i - e),
    panY: l - s * (l - t)
  };
}
const Bp = 4;
function Np(e) {
  const t = B(1), n = B(0), o = B(0), i = B(!1), l = B(!1), s = B(!1), a = B(null), d = B(0), r = B(0), f = B(0), y = B(0);
  let k = null, m = null, h = 0, I = 0, b = 0, w = 0, S = !1, A = 0, g = 1, x = 0, T = 0, _ = 0, W = 0, U = null, z = 0, M = 0;
  const R = V(() => `${Math.round(t.value * 100)}%`);
  function F(c) {
    e.value && (e.value.style.cursor = c);
  }
  function L() {
    s.value = !s.value, oe.user("Toggle panning", { panningEnabled: s.value }), s.value ? F("grab") : (i.value = !1, F(""));
  }
  function N(c) {
    if (!e.value) {
      t.value = c;
      return;
    }
    const $ = e.value.getBoundingClientRect(), E = Dn(
      n.value,
      o.value,
      t.value,
      c,
      $.width / 2,
      $.height / 2
    );
    n.value = E.panX, o.value = E.panY, t.value = c;
  }
  function D() {
    N(tn(t.value + ai));
  }
  function X() {
    N(tn(t.value - ai));
  }
  function G() {
    t.value = 1, n.value = 0, o.value = 0;
  }
  function q(c) {
    if (c.code === "Space" && !s.value) {
      if (en(c.target)) return;
      c.preventDefault(), l.value || (l.value = !0, F("grab"));
      return;
    }
    (c.ctrlKey || c.metaKey) && !en(c.target) && (c.key === "+" || c.key === "=" ? (c.preventDefault(), D()) : c.key === "-" ? (c.preventDefault(), X()) : c.key === "0" && (c.preventDefault(), G()));
  }
  function Q(c) {
    if (c.code === "Space" && !s.value) {
      if (en(c.target)) return;
      c.preventDefault(), l.value = !1, i.value = !1, F("");
    }
  }
  function ce(c) {
    if (S || !e.value || c.button !== 0 || en(c.target)) return;
    const $ = document.activeElement;
    $ instanceof HTMLElement && e.value.contains($) && $.blur(), c.preventDefault(), globalThis.getSelection()?.removeAllRanges(), h = c.clientX, I = c.clientY, b = n.value, w = o.value, S = !0, document.addEventListener("mousemove", ye), document.addEventListener("mouseup", xe);
  }
  function be() {
    U = null, n.value = b + z, o.value = w + M;
  }
  function ye(c) {
    if (!S) return;
    const $ = c.clientX - h, E = c.clientY - I;
    if (!i.value) {
      if (Math.sqrt($ * $ + E * E) < Bp) return;
      i.value = !0, F("grabbing"), document.addEventListener("click", ve, !0);
    }
    z = $, M = E, U === null && (U = requestAnimationFrame(be));
  }
  function ve(c) {
    c.stopPropagation(), c.preventDefault(), document.removeEventListener("click", ve, !0);
  }
  function xe() {
    U !== null && (cancelAnimationFrame(U), U = null, n.value = b + z, o.value = w + M), S = !1, i.value = !1, F(l.value ? "grab" : ""), document.removeEventListener("mousemove", ye), document.removeEventListener("mouseup", xe);
  }
  function Ae(c) {
    if (c.preventDefault(), c.ctrlKey || c.metaKey) {
      const $ = tn(t.value - c.deltaY * Lp * t.value);
      if (!e.value) return;
      const E = e.value.getBoundingClientRect(), j = Dn(
        n.value,
        o.value,
        t.value,
        $,
        c.clientX - E.left,
        c.clientY - E.top
      );
      n.value = j.panX, o.value = j.panY, t.value = $;
    } else c.shiftKey ? n.value -= c.deltaY || c.deltaX : (n.value -= c.deltaX, o.value -= c.deltaY);
  }
  function Re(c, $) {
    const E = c.clientX - $.clientX, j = c.clientY - $.clientY;
    return Math.sqrt(E * E + j * j);
  }
  function Ie(c) {
    if (c.touches.length !== 2) return;
    const $ = c.touches[0], E = c.touches[1];
    c.preventDefault(), A = Re($, E), g = t.value, x = ($.clientX + E.clientX) / 2, T = ($.clientY + E.clientY) / 2, _ = n.value, W = o.value;
  }
  function le(c) {
    if (c.touches.length !== 2 || A === 0) return;
    c.preventDefault();
    const $ = Re(c.touches[0], c.touches[1]), E = tn(g * ($ / A));
    if (!e.value) return;
    const j = e.value.getBoundingClientRect(), Y = Dn(
      _,
      W,
      g,
      E,
      x - j.left,
      T - j.top
    );
    n.value = Y.panX, o.value = Y.panY, t.value = E;
  }
  const ue = V(() => {
    const c = y.value * t.value, $ = Math.min(0, o.value), j = Math.max(r.value, o.value + c) - $, Y = j - r.value;
    if (Y <= 0) return { show: !1, thumbFraction: 1, thumbOffset: 0 };
    const ee = Math.max(0.05, Math.min(1, r.value / j)), ie = -$ / Y * (1 - ee);
    return { show: !0, thumbFraction: ee, thumbOffset: ie };
  }), ke = V(() => {
    const c = f.value * t.value, $ = Math.min(0, n.value), j = Math.max(d.value, n.value + c) - $, Y = j - d.value;
    if (Y <= 0) return { show: !1, thumbFraction: 1, thumbOffset: 0 };
    const ee = Math.max(0.05, Math.min(1, d.value / j)), ie = -$ / Y * (1 - ee);
    return { show: !0, thumbFraction: ee, thumbOffset: ie };
  });
  function re(c) {
    c.preventDefault(), c.stopPropagation();
    const $ = c.currentTarget.parentElement;
    $.setPointerCapture(c.pointerId);
    const E = $.getBoundingClientRect(), j = y.value * t.value, Y = Math.min(0, o.value), de = Math.max(r.value, o.value + j) - Y, ie = c.clientY, Ee = o.value;
    function me(vt) {
      const Se = (vt.clientY - ie) / E.height * de;
      o.value = Ee - Se;
    }
    function $e() {
      $.removeEventListener("pointermove", me), $.removeEventListener("pointerup", $e);
    }
    $.addEventListener("pointermove", me), $.addEventListener("pointerup", $e);
  }
  function P(c) {
    c.preventDefault(), c.stopPropagation();
    const $ = c.currentTarget.parentElement;
    $.setPointerCapture(c.pointerId);
    const E = $.getBoundingClientRect(), j = f.value * t.value, Y = Math.min(0, n.value), de = Math.max(d.value, n.value + j) - Y, ie = c.clientX, Ee = n.value;
    function me(vt) {
      const Se = (vt.clientX - ie) / E.width * de;
      n.value = Ee - Se;
    }
    function $e() {
      $.removeEventListener("pointermove", me), $.removeEventListener("pointerup", $e);
    }
    $.addEventListener("pointermove", me), $.addEventListener("pointerup", $e);
  }
  function O() {
    e.value && (k = new ResizeObserver((c) => {
      const $ = c[0];
      $ && (d.value = $.contentRect.width, r.value = $.contentRect.height);
    }), k.observe(e.value));
  }
  return Te(
    a,
    (c, $, E) => {
      m && (m.disconnect(), m = null), c && (m = new ResizeObserver((j) => {
        const Y = j[0];
        Y && (f.value = Y.contentRect.width, y.value = Y.contentRect.height);
      }), m.observe(c), E(() => {
        m?.disconnect(), m = null;
      }));
    },
    { immediate: !0 }
  ), rt(() => {
    O(), globalThis.addEventListener("keydown", q), globalThis.addEventListener("keyup", Q);
  }), jt(() => {
    U !== null && (cancelAnimationFrame(U), U = null), globalThis.removeEventListener("keydown", q), globalThis.removeEventListener("keyup", Q), document.removeEventListener("mousemove", ye), document.removeEventListener("mouseup", xe), document.removeEventListener("click", ve, !0), k?.disconnect(), m?.disconnect();
  }), {
    scale: t,
    panX: n,
    panY: o,
    isPanning: i,
    isSpacePressed: l,
    panningEnabled: s,
    contentRef: a,
    scrollbarV: ue,
    scrollbarH: ke,
    togglePanning: L,
    handleMouseDown: ce,
    handleWheel: Ae,
    handleTouchStart: Ie,
    handleTouchMove: le,
    startVScrollDrag: re,
    startHScrollDrag: P,
    zoomIn: D,
    zoomOut: X,
    resetZoom: G,
    displayScale: R
  };
}
const zp = { class: "flex flex-col w-full min-h-0 relative" }, _p = {
  key: 0,
  class: "absolute right-0 top-0 bottom-3 w-3 z-10 pointer-events-auto"
}, Vp = {
  key: 1,
  class: "absolute bottom-0 left-0 right-3 h-3 z-10 pointer-events-auto"
}, Fp = {
  key: 2,
  class: "absolute bottom-6 left-1/2 -translate-x-1/2 z-10"
}, jp = { class: "bg-white rounded-lg shadow-lg border border-gray-100 p-1 inline-flex items-center" }, Hp = {
  key: 3,
  class: "absolute top-3 right-3 z-10"
}, Up = /* @__PURE__ */ ge({
  __name: "Builder",
  setup(e) {
    const t = pt(), {
      mode: n,
      interventionDrawer: o,
      populationDrawer: i,
      closeInterventionDrawer: l,
      addPeriod: s,
      addInterventionToPeriod: a,
      updateIntervention: d,
      removePeriod: r,
      removeInterventionFromPeriod: f,
      periodsDataEntity: y,
      closePopulationDrawer: k,
      createDefinition: m,
      updateDefinition: h,
      forkDefinition: I,
      getDefinitionUsageCount: b,
      getDefinitionById: w,
      populationsDataEntity: S,
      importStudyDesign: A
    } = t, g = B(!1), x = V(() => S.value.length === 0);
    function T(Ie) {
      A(Ie), g.value = !1;
    }
    function _(Ie) {
      const { updateAll: le, ...ue } = Ie;
      if (o.intervention) {
        const ke = o.intervention, re = ke.definitionId, P = b(re) > 1;
        if (P && le)
          h(re, ue);
        else if (P) {
          const O = I(re);
          O && (h(O.id, ue), d(o.periodId, ke.id, {
            definitionId: O.id
          }));
        } else
          h(re, ue);
      } else {
        const ke = m(ue);
        o.periodId ? a(o.periodId, { definitionId: ke.id }) : s(
          o.armId,
          { definitionId: ke.id },
          o.afterGlobalOrder,
          o.beforeGlobalOrder
        );
      }
      l();
    }
    function W(Ie) {
      const { definitionId: le } = Ie;
      o.periodId ? a(o.periodId, { definitionId: le }) : s(
        o.armId,
        { definitionId: le },
        o.afterGlobalOrder,
        o.beforeGlobalOrder
      ), l();
    }
    function U() {
      if (o.intervention && o.periodId) {
        const Ie = y.value.find((le) => le.id === o.periodId);
        Ie && Ie.interventions.length > 1 ? f(o.periodId, o.intervention.id) : r(o.periodId);
      }
      l();
    }
    const z = B(null), {
      isPanning: M,
      handleMouseDown: R,
      handleWheel: F,
      handleTouchStart: L,
      handleTouchMove: N,
      zoomIn: D,
      zoomOut: X,
      resetZoom: G,
      displayScale: q,
      scale: Q,
      panX: ce,
      panY: be,
      contentRef: ye,
      scrollbarV: ve,
      scrollbarH: xe,
      startVScrollDrag: Ae,
      startHScrollDrag: Re
    } = Np(z);
    return ci(no, { ...t, scale: Q }), rt(() => {
      oe.lifecycle("Builder component mounted");
    }), (Ie, le) => (v(), C("div", zp, [
      u("div", {
        ref_key: "containerRef",
        ref: z,
        class: Z(["dotted-grid-bg bg-gray-50 min-h-0 relative h-full overflow-hidden", [{ "select-none": p(M) }, p(n) === "thumbnail" ? "pointer-events-none" : ""]]),
        style: ne(
          p(n) !== "thumbnail" ? {
            "--dot-radius": `${3 * p(Q)}px`,
            "--dot-spacing": `${32 * p(Q)}px`,
            "--dot-offset-x": `${8 * p(Q) + p(ce)}px`,
            "--dot-offset-y": `${16 * p(Q) + p(be)}px`
          } : void 0
        ),
        onMousedown: le[0] || (le[0] = //@ts-ignore
        (...ue) => p(R) && p(R)(...ue)),
        onWheel: le[1] || (le[1] = //@ts-ignore
        (...ue) => p(F) && p(F)(...ue)),
        onTouchstart: le[2] || (le[2] = //@ts-ignore
        (...ue) => p(L) && p(L)(...ue)),
        onTouchmove: le[3] || (le[3] = he(
          //@ts-ignore
          (...ue) => p(N) && p(N)(...ue),
          ["prevent"]
        ))
      }, [
        u("div", {
          ref_key: "contentRef",
          ref: ye,
          class: "flex min-h-40 w-max",
          style: ne(
            p(n) === "thumbnail" ? { transform: "scale(0.3)", transformOrigin: "top left" } : {
              transform: `translate(${p(ce)}px, ${p(be)}px) scale(${p(Q)})`,
              transformOrigin: "0 0"
            }
          )
        }, [
          K(rc),
          K(nc)
        ], 4)
      ], 38),
      p(n) !== "thumbnail" && p(ve).show ? (v(), C("div", _p, [
        u("div", {
          class: "absolute right-0.5 w-2 rounded-full bg-gray-500/60 hover:bg-gray-500/80 transition-colors cursor-pointer",
          style: ne({
            top: `${p(ve).thumbOffset * 100}%`,
            height: `${p(ve).thumbFraction * 100}%`
          }),
          onPointerdown: le[4] || (le[4] = //@ts-ignore
          (...ue) => p(Ae) && p(Ae)(...ue))
        }, null, 36)
      ])) : H("", !0),
      p(n) !== "thumbnail" && p(xe).show ? (v(), C("div", Vp, [
        u("div", {
          class: "absolute bottom-0.5 h-2 rounded-full bg-gray-500/60 hover:bg-gray-500/80 transition-colors cursor-pointer",
          style: ne({
            left: `${p(xe).thumbOffset * 100}%`,
            width: `${p(xe).thumbFraction * 100}%`
          }),
          onPointerdown: le[5] || (le[5] = //@ts-ignore
          (...ue) => p(Re) && p(Re)(...ue))
        }, null, 36)
      ])) : H("", !0),
      p(n) !== "thumbnail" ? (v(), C("div", Fp, [
        u("div", jp, [
          u("button", {
            onClick: le[6] || (le[6] = //@ts-ignore
            (...ue) => p(X) && p(X)(...ue)),
            class: "inline-flex items-center justify-center w-10 h-10 rounded-lg text-gray-600 hover:bg-gray-100 transition-all",
            title: "Zoom out (Ctrl/Cmd -)"
          }, [...le[11] || (le[11] = [
            u("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: "size-5",
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, [
              u("path", { d: "M19 13H5v-2h14v2z" })
            ], -1)
          ])]),
          u("button", {
            onClick: le[7] || (le[7] = //@ts-ignore
            (...ue) => p(G) && p(G)(...ue)),
            class: "inline-flex items-center justify-center min-w-14 h-10 px-2 rounded-lg text-gray-600 hover:bg-gray-100 transition-all text-sm font-mono font-semibold",
            title: "Reset zoom (Ctrl/Cmd 0)"
          }, ae(p(q)), 1),
          u("button", {
            onClick: le[8] || (le[8] = //@ts-ignore
            (...ue) => p(D) && p(D)(...ue)),
            class: "inline-flex items-center justify-center w-10 h-10 rounded-lg text-gray-600 hover:bg-gray-100 transition-all",
            title: "Zoom in (Ctrl/Cmd +)"
          }, [...le[12] || (le[12] = [
            u("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              class: "size-5",
              viewBox: "0 0 24 24",
              fill: "currentColor"
            }, [
              u("path", { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" })
            ], -1)
          ])])
        ])
      ])) : H("", !0),
      p(n) === "edit" ? (v(), C("div", Hp, [
        u("button", {
          class: "inline-flex items-center justify-center w-10 h-10 rounded-lg bg-white shadow-sm border border-gray-200 text-gray-500 hover:text-blue-600 hover:border-blue-300 hover:shadow-md transition-all",
          title: "Load template",
          onClick: le[9] || (le[9] = (ue) => g.value = !0)
        }, [
          K(p(ki), {
            icon: "material-symbols:layers-outline",
            class: "size-5"
          })
        ])
      ])) : H("", !0),
      g.value ? (v(), Ce(Mp, {
        key: 4,
        "is-empty": x.value,
        onApply: T,
        onClose: le[10] || (le[10] = (ue) => g.value = !1)
      }, null, 8, ["is-empty"])) : H("", !0),
      K(Af, {
        show: p(o).visible,
        "arm-id": p(o).armId,
        intervention: p(o).intervention,
        definition: p(o).intervention ? p(w)(p(o).intervention.definitionId) : void 0,
        onClose: p(l),
        onSave: _,
        onImport: W,
        onDelete: U
      }, null, 8, ["show", "arm-id", "intervention", "definition", "onClose"]),
      K(Vf, {
        show: p(i).visible,
        "population-id": p(i).populationId,
        onClose: p(k)
      }, null, 8, ["show", "population-id", "onClose"])
    ]));
  }
}), Gp = { class: "flex flex-col h-full relative overflow-hidden" }, Wp = { class: "bg-white flex rounded-xl shadow-sm border border-slate-200 min-w-0 min-h-0 h-full" }, Zp = /* @__PURE__ */ ge({
  __name: "VisualStudyDesignBuilder",
  props: /* @__PURE__ */ To({
    mode: { default: "edit" }
  }, {
    modelValue: {
      default: () => ({ populations: [], interventionDefinitions: [] })
    },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ To(["selectionChange"], ["update:modelValue"]),
  setup(e, { emit: t }) {
    const n = e, o = il(e, "modelValue"), i = t, l = Or({
      populations: o.value.populations ?? [],
      arms: o.value.arms ?? [],
      periods: o.value.periods ?? [],
      interventionDefinitions: o.value.interventionDefinitions,
      anchors: o.value.anchors,
      mode: n.mode
    });
    return ci(no, l), Te(
      () => n.mode,
      (s) => {
        l.mode.value = s, s === "edit" && l.clearSelection();
      }
    ), Te(
      [() => l.selectedAnchor.value, () => l.selectedInterventionTimepoints.value],
      () => {
        i("selectionChange", l.getSelection());
      },
      { deep: !0 }
    ), Te(
      [
        () => l.populationsDataEntity.value,
        () => l.armsDataEntity.value,
        () => l.periodsDataEntity.value,
        () => l.interventionDefinitions.value,
        () => l.anchors.value
      ],
      ([s, a, d, r, f]) => {
        o.value = {
          populations: Lt(s),
          arms: Lt(a),
          periods: Lt(d),
          interventionDefinitions: Lt(r),
          anchors: Lt(f)
        };
      },
      { deep: !0 }
    ), rt(() => {
      oe.lifecycle("Visual Study Design Builder mounted");
    }), (s, a) => (v(), C("div", Gp, [
      u("div", Wp, [
        K(Up, null, {
          "toolbar-start": Pe(() => [
            at(s.$slots, "toolbar-start")
          ]),
          "sync-status": Pe(() => [
            at(s.$slots, "sync-status")
          ]),
          _: 3
        })
      ])
    ]));
  }
});
export {
  He as AssignmentType,
  Oe as ComparatorType,
  ze as DurationOperator,
  ot as INTERVENTION_COLORS,
  rn as InterventionItemType,
  De as InterventionRole,
  tt as NonActiveComparatorType,
  qf as StudyDesignThumbnail,
  Zp as VisualStudyDesignBuilder,
  qp as configureLogger,
  eo as emptyRandomization,
  Ii as isRandomized
};
//# sourceMappingURL=index.js.map
